(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('jquery')) :
  typeof define === 'function' && define.amd ? define(['jquery'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Yanda = factory(global.jQuery));
})(this, (function (jQuery) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var jQuery__default = /*#__PURE__*/_interopDefaultLegacy(jQuery);

  const Yanda = {
    prefix: "",
  };

  // deno-lint-ignore-file

  const Util = {
    /**
     * Cria um elemento HTML.
     *
     * @deprecated
     * @param {string} n Descrição do elemento a ser criado.
     * @return {Element}
     */
    createElm(n) {
      return document.createElement(n);
    },

    /**
     * Não permite que o texto da página seja selecionado.
     */
    disableSelect() {
      var style = (arguments[0] || document.body).style;
      style.webkitUserSelect =
        style.MozUserSelect =
        style.msUserSelect =
        style
          .userSelect =
          "none";
    },

    /**
     * Habilita a seleção de texto.
     */
    enableSelect() {
      var style = (arguments[0] || document.body).style;
      style.webkitUserSelect =
        style.MozUserSelect =
        style.msUserSelect =
        style
          .userSelect =
          "text";
    },

    /**
     * Recupera as propriedades de tamanho da página.
     * TODO: Alterar nome do objeto.
     *
     * @deprecated
     * @return Objeto com as propriedades
     */
    getPageSize: function () {
      var pageWidth,
        pageHeight,
        windowWidth,
        windowHeight,
        xScroll,
        yScroll,
        isScroll;
      if (window.innerHeight && window.scrollMaxY) {
        xScroll = document.body.scrollWidth;
        yScroll = window.innerHeight + window.scrollMaxY;
      } else if (document.body.scrollHeight > document.body.offsetHeight) {
        // All but Explorer Mac
        xScroll = document.body.scrollWidth;
        yScroll = document.body.scrollHeight;
      } else {
        // Explorer Mac...would also work in Explorer 6 Strict, Mozilla and Safari
        xScroll = document.body.offsetWidth;
        yScroll = document.body.offsetHeight;
      }
      if (document.documentElement && document.documentElement.clientHeight) {
        // Explorer 6 Strict Mode
        windowWidth = document.documentElement.clientWidth;
        windowHeight = document.documentElement.clientHeight;
      } else if (document.body) {
        // Other Explorers
        windowWidth = document.body.clientWidth;
        windowHeight = document.body.clientHeight;
      }

      // For small pages with total height less then height of the viewport
      if (yScroll <= windowHeight) {
        pageHeight = windowHeight;
        isScroll = false;
      } else {
        pageHeight = yScroll;
        isScroll = true;
      }

      // For small pages with total width less then width of the viewport
      if (xScroll < windowWidth) {
        pageWidth = windowWidth;
      } else {
        pageWidth = xScroll;
      }

      this.pageWidth = pageWidth;
      this.pageHeight = pageHeight;
      this.windowWidth = windowWidth;
      this.windowHeight = windowHeight;
      this.isScroll = isScroll;
    },

    /**
     * Deixa o objeto e seus filhos inselecionaveis.
     *
     * @param {Element} elm
     * @param {boolean} c
     * @return void
     */
    setUnselectable(elm, c) {
      c ? Util.disableSelect(elm) : Util.enableSelect(elm);
    },

    /**
     * Cria div de desabilitação.
     * O div fica por cima dos elementos HTML da página
     *
     * @param {obj} opt Opções para abertura do DIV.
     */
    overlay(opt) {
      if (!opt) return;
      var div = document.getElementById("yanda-overlay");
      if (!div) {
        var d = Util.createElm("div");
        d.id = "yanda-overlay";
        d.style.cssText =
          "visibility: hidden; position: fixed; background-color: #A5A5A5;" +
          "opacity: .4; left: 0px; top: 0px; width: 100%; height: 100%";
        document.body.appendChild(d);
        div = d;
      }

      if (opt.opacity) {
        div.style.opacity = "." + opt.opacity;
      }
      if (opt.cor) {
        div.style.backgroundColor = opt.cor;
      }
      if (opt.zIndex) {
        div.style.zIndex = opt.zIndex;
      }
      div.style.visibility = opt.show ? "visible" : "hidden";
    },

    /**
     * Interrompe evento.
     *
     * @param {event} e
     */
    stopEvent(e) {
      if (!e) e = window.event;
      if (e.stopPropagation) {
        e.stopPropagation();
      } else {
        e.cancelBubble = true;
      }
    },

    /**
     * Cancela evento.
     *
     * @param {event} e
     */
    cancelEvent(e) {
      if (!e) e = window.event;
      if (e.preventDefault) e.preventDefault();
      else e.returnValue = false;
    },

    /**
     * Extrai a tag especificada de uma string.
     * TODO: Rever algoritmo (Usar expressões regulares)
     *
     * @param tag Descrição da tag
     * @param txt Texto a ser pesquisado
     * @deprecated
     */
    extraiTag(tag, txt) {
      var ini = 0;
      while (ini !== -1) {
        ini = txt.indexOf("<" + tag, ini);
        if (ini >= 0) {
          ini = txt.indexOf(">", ini) + 1;
          var fim = txt.indexOf("</" + tag + ">", ini);
          return txt.substring(ini, fim);
        }
      }
    },

    /**
     * Executa javascript quando determinada tecla é precionada.
     *
     * @param event Obj do evento
     * @param key Codigo da tecla precionada
     * @param f String com o código a ser executado
     */
    doOnKeyPress(event, key, f) {
      if (event.keyCode === key) {
        if (typeof (f) === "function") f();
        else Function(f)();
      }
    },

    /**
     * Troca foco de um input quando a tecla enter for precionada.
     *
     * @param id Identificador do dom obj a receber o foco
     * @param e Objeto do evento
     */
    trocaFoco(id, e) {
      if (e.keyCode === 13) {
        const elm = document.getElementById(id);
        elm.focus();
        elm.select && elm.select();
        Util.cancelEvent(e);
      }
    },

    /**
     * Retorna a posição top de um dom objeto fixo.
     *
     * @param o Objeto
     * @return pos
     */
    getTopPos(o) {
      var r = o.offsetTop;
      while ((o = o.offsetParent) !== null) {
        if (o.tagName != "HTML") {
          r += o.offsetTop;
        }
      }
      return r;
    },

    /**
     * Retorna a posição left de um dom objeto fixo.
     *
     * @param o Objeto
     * @return pos
     */
    getLeftPos(o) {
      var r = o.offsetLeft;
      while ((o = o.offsetParent) !== null) {
        if (o.tagName != "HTML") {
          r += o.offsetLeft;
        }
      }
      return r;
    },

    /**
     * Valida datas no formato dd/mm/yyyy.
     * Utilizando getUTCDate para não ter problemas com o horário de verão.
     *
     * @see http://stackoverflow.com/questions/2488313/javascripts-getdate-returns-wrong-date
     * @param e String com a data
     * @return true/false
     */
    validaData(e) {
      var data = e.split("/"),
        dia = parseInt(data[0]),
        mes = parseInt(data[1]),
        ano = parseInt(data[2]);

      if (isNaN(dia) || isNaN(mes) || isNaN(ano)) {
        return false;
      }
      var d = new Date(ano, mes - 1, dia),
        diaT = d.getUTCDate(),
        mesT = d.getUTCMonth() + 1;

      return (dia === diaT) && (mes === mesT);
    },

    isMobile() {
      var mobile = screen.width < 1024 && screen.height < 768;
      try {
        if (
          /Android|webOS|iPhone|iPad|iPod|pocket|psp|kindle|avantgo|blazer|midori|Tablet|Palm|maemo|plucker|phone|BlackBerry|symbian|IEMobile|mobile|ZuneWP7|Windows Phone|Opera Mini/i
            .test(navigator.userAgent)
        ) {
          return true;
        }
        return mobile;
      } catch (e) {
        return mobile;
      }
    },

    /**
     * Converte string para um obj Date.
     *
     * @deprecated
     * @param d String
     * @return Date
     */
    toDate(d) {
      d = d.split("/");
      return new Date(d[2], d[1] - 1, d[0]);
    },

    /**
     * Retorna todos os dados dos objetos filhos.
     * Os dados são preparados para comunicação com o server.
     *
     * @param obj Objeto a ser pesquisado
     * @param o Configurações de pesquisa
     * @return String com os dados obtidos
     */
    getDataToServer(obj, o) {
      var i, type, r = "", inputs;
      if (!o.notSelect) {
        var selects = obj.getElementsByTagName("select");
        for (i = 0; i < selects.length; i++) {
          r += "&" + selects[i].id;
          r += "=" + selects[i].value;
        }
      }
      inputs = obj.getElementsByTagName("input");
      for (i = 0; i < inputs.length; i++) {
        type = inputs[i].type;
        if (type === "button") continue;
        if (type === "text" && o.notText) continue;
        if (type === "radio" && o.notRadio) continue;
        if (type === "checkbox" && o.notCheckbox) continue;
        r += "&" + inputs[i].id;
        if (type === "checkbox") {
          r += "=" + inputs[i].checked;
        } else {
          r += "=" + encodeURIComponent(inputs[i].value);
        }
      }
      return r;
    },

    setScroll() {
      const scroll = document.querySelector("#scroll");
      scroll.style.top = 0;
      var isScroll = Yanda.ctr.pageSize.isScroll,
        pageSize = new Util.getPageSize(),
        maxBottom;

      if (pageSize.isScroll) {
        scroll.style.top = pageSize.pageHeight + "px";
      } else {
        maxBottom = Yanda.getJanMaxBottom();
        if (maxBottom > Yanda.ctr.janPosBottomMax) {
          scroll.style.top = pageSize.pageHeight -
            (pageSize.pageHeight - maxBottom) + "px";
        }
      }

      // Quando exibir/ocultar scroll
      if ((!isScroll && pageSize.isScroll) || (isScroll && !pageSize.isScroll)) {
        Yanda.redraw();
      }
    },

    centralizaScroll(o) {
      if (o.janela.offsetHeight > Yanda.ctr.janMaAlt) {
        window.scrollTo(0, o.janela.offsetTop - Yanda.ctr.janPosTopMax);
        return;
      }

      var diffAltura = (Yanda.ctr.janMaAlt / 2) - (o.janela.offsetHeight / 2) +
        Yanda.ctr.janPosTopMax;
      if (diffAltura < 0) {
        diffAltura = 0;
      }
      window.scrollTo(0, o.janela.offsetTop - diffAltura);
    },

    /**
     * Controla o evento de teclado em campos que devem armazenar data.
     *
     * @deprecated
     * @param obj Referência a um input
     * @param e Objeto do evento
     */
    datas(obj, e) {
      if (e.keyCode !== 8) {
        if (obj.value.length === 2) obj.value += "/";
        if (obj.value.length === 5) obj.value += "/";
      }
    },

    /**
     * Controla o evento de teclado em campos que devem armazenar hora.
     *
     * @deprecated
     * @param obj Referência a um input
     * @param e Objeto do evento
     */
    mskTime(obj, e) {
      if (e.keyCode !== 8) {
        if (obj.value.length === 2) obj.value += ":";
        if (obj.value.length === 5) obj.value += ":";
      }
    },

    /**
     * Controla o evento de teclado em campos que devem armazenar CPF.
     *
     * @deprecated
     * @param obj Referência a um input
     * @param e Objeto do evento
     */
    cpf(obj, e) {
      if (e.keyCode !== 8) {
        if (obj.value.length === 3) obj.value += ".";
        if (obj.value.length === 7) obj.value += ".";
        if (obj.value.length === 11) obj.value += "-";
      }
    },

    /**
     * Controla o evento de teclado em campos que devem armazenar CNPJ.
     *
     * @deprecated
     * @param obj Referência a um input
     * @param e Objeto do evento
     */
    cnpj(obj, e) {
      if (e.keyCode !== 8) {
        if (obj.value.length === 2) obj.value += ".";
        if (obj.value.length === 6) obj.value += ".";
        if (obj.value.length === 10) obj.value += "/";
        if (obj.value.length === 15) obj.value += "-";
      }
    },

    /**
     * Controla o evento de teclado em campos que devem armazenar CEP.
     *
     * @deprecated
     * @param obj Referência a um input
     * @param e Objeto do evento
     */
    cep(obj, e) {
      if (e.keyCode !== 8 && obj.value.length === 5) {
        obj.value += "-";
      }
    },

    /**
     * Seta o cursor em determinada posicao.
     *
     * @param o Referência a um Dom object
     * @param p Posição
     */
    setCaretTo(o, p) {
      p++;
      if (o.selectionStart) {
        o.focus();
        o.setSelectionRange(p, p);
      } else if (o.createTextRange) {
        // Create a textrange, set the internal pointer to a specified
        // position and show the cursor at this position
        var range = o.createTextRange();
        range.move("character", p);
        range.select();
      }
    },

    /**
     * Faz com que input aceite somente valores numéricos.
     *
     * @deprecated
     * @param o Referência a um dom objeto
     * @param e Evento
     */
    soValor(o, e) {
      var k = e.keyCode,
        p = o.value.indexOf(".");
      if (k === 188 || k === 110) {
        if (p === -1) o.value += ".";
        k = 190;
        Util.cancelEvent(e);
      }
      if ((k === 190 || k === 194) && p >= 0) {
        Util.setCaretTo(o, p);
        Util.cancelEvent(e);
      }
      if (
        !(k >= 48 && k <= 57) && !(k >= 96 && k <= 105) && k !== 13 && k !== 8 &&
        k !== 46 && k !== 9 && k !== 39 && k !== 37 && k !== 40 &&
        k !== 38 && k !== 16 && k !== 36 && k !== 35 && k !== 190 &&
        k !== 194 && k !== 110 && !e.ctrlKey && !e.shiftKey && !e.metaKey
      ) {
        Util.cancelEvent(e);
      }
    },

    /**
     * Faz com que input aceite somente inteiros.
     *
     * @deprecated
     * @param e Evento
     */
    soNum(e) {
      var k = e.keyCode;
      if (
        !(k >= 48 && k <= 57) && !(k >= 96 && k <= 105) && k !== 13 && k !== 8 &&
        k !== 46 && k !== 9 && k !== 39 && k !== 37 && k !== 40 &&
        k !== 38 && k !== 16 && k !== 36 && k !== 35 && !e.ctrlKey &&
        !e.shiftKey && !e.metaKey
      ) {
        Util.cancelEvent(e);
      }
    },

    /**
     * Adiciona option em select via JS.
     *
     * @param s Select a receber um novo option
     * @param t Descrição do option
     * @param v Value do option
     */
    addOption(s, t, v) {
      var se = document.getElementById(s),
        p = se.length > 0 ? se.length : 0;
      se.options[p] = new Option(t, v);
    },

    calculateWeek(date, changeDate) {
      var time,
        checkDate = changeDate === true ? date : new Date(date.getTime());

      // sum one day (firstDay week change Saturday to Sunday)
      checkDate.setDate(checkDate.getDate() + 1);

      // Find Thursday of this week starting on Monday
      checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7));

      time = checkDate.getTime();
      checkDate.setMonth(0); // Compare with Jan 1
      checkDate.setDate(1);
      return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
    },
  };

  // deno-lint-ignore-file

  function openUrl(url) {
    window.open(Yanda.basePath + url, "_blank");
  }

  function open() {
    jQuery__default["default"](this).data("helpUrl") && openUrl(jQuery__default["default"](this).data("helpUrl"));
  }

  function jaEntendi(e) {
    Util.stopEvent(e);
    Util.cancelEvent(e);

    var checked = this.checked;
    setTimeout(function () {
      jQuery__default["default"](document).find(
        '.ajan-help [type="checkbox"], .ajan-help-rtl [type="checkbox"]',
      ).prop("checked", checked);
      Yanda.help.hide = checked;
      Yanda.help.click && Yanda.help.click(checked);
    }, 0);
  }

  function create$1($elms, content, show) {
    if (Yanda.help.hide && !show) {
      return;
    }

    $elms.each(function () {
      var title = "Ajuda",
        $elmHelp = jQuery__default["default"](this),
        classes = $elmHelp.prop("class");

      $elmHelp.css("z-index", 20001);
      classes = classes.replace("mdi-help-circle", "").replace("mdi", "");

      var $div = jQuery__default["default"](
        '<div class="' + classes +
          '" style="position: absolute;"><div class="ajan-help-arrow"></div><div class="ajan-help-info">' +
          (content || 'Clique em <i class="mdi mdi-help-circle mdi-18px"></i>' +
              '<br>para obter ajuda<div></div><br><div><input type="checkbox"><label> Já entendi</label><div>') +
          "</div></div>",
      ).css({ cursor: "pointer" }).on("click", function (e) {
        Util.stopEvent(e);
        Util.cancelEvent(e);
        jQuery__default["default"](this).parent().find(".ajan-help-info, .ajan-help-arrow").remove();
      });

      if ($elmHelp.data("helpMsg")) {
        title = $elmHelp.data("helpMsg");
        $div.find(".ajan-help-info div").first().html("<br>" + title);
        $div.css({ width: "350px" });
      }

      $div.find('[type="checkbox"]').on("click", jaEntendi);
      $elmHelp.append($div).prop("title", title);
    });
  }

  function createByJanela(hdl) {
    let $elms = jQuery__default["default"](hdl.janela).find(".ajan-help, .ajan-help-rtl");
    $elms.click(open);

    if (hdl.requests > 1) {
      return;
    }

    // um por janela
    $elms = jQuery__default["default"](hdl.janela).find(":not(.ui-tabs-panel)").find(
      ".ajan-help, .ajan-help-rtl",
    );
    $elms && create$1($elms.eq(0));

    // um por tab
    setTimeout(() => {
      const $tabs = jQuery__default["default"](hdl.janela).find(".ui-tabs-panel");
      $tabs.each((i, elm) => {
        let $aux = jQuery__default["default"](elm).find(".ajan-help, .ajan-help-rtl");
        $aux.length && create$1($aux.eq(0));
      });
    }, 1000);
  }

  var Help = {
    hide: false,
    click: null,
    create: create$1,
    openUrl,
    createByJanela,
  };

  // deno-lint-ignore-file

  const Menu = {
    MenuPrincipalHeight: 20,
    MenuImgNext: null,
  };

  let menuPrincipalSelecionado,
    submenuSelecionado;

  /**
   * Testa se houve click na janela para esconder o menu.
   *
   * @returns {void}
   */
  function testaClick() {
    menuPrincipalSelecionado &&
      (menuPrincipalSelecionado.className = "ajan-menu");
    submenuSelecionado && (submenuSelecionado.style.visibility = "hidden");
    submenuSelecionado = null;
  }

  /**
   * Instancia objeto visual do menu principal.
   *
   * @param {int} l
   * @param {int} t
   * @returns {void}
   */
  function menuPrincipal(l, t) {
    var height = Menu.MenuPrincipalHeight + 5,
      $div = jQuery__default["default"]('<div class="ajan-menu-barra">').css({
        top: t + "px",
        left: l + "px",
        height: height + "px",
      });
    document.addEventListener("click", testaClick, false);
    Menu.SubMenuTop = height - 2;
    return $div[0];
  }

  /**
   * Cria os menus principais.
   *
   * @param {dom} menuBarra
   * @param {string} nome
   * @param {string} acao
   * @returns {void}
   */
  function itensPrincipal(menuBarra, nome, acao) {
    var c = document.createElement("div");
    c.className = "ajan-menu";
    c.style.height = Menu.MenuPrincipalHeight + "px";
    c.acao = acao;
    c.innerHTML = nome;
    menuBarra.appendChild(c);

    c.onmouseover = onMouseOverMenu;
    c.onmouseout = onMouseOutMenu;
    c.onclick = onClickMenu;
    return c;
  }

  function onMouseOverMenu() {
    if (submenuSelecionado && menuPrincipalSelecionado === this) {
      this.classList.add("ajan-menu-click");
      return;
    }
    if (submenuSelecionado) {
      this.classList.add("ajan-menu-click");
      if (menuPrincipalSelecionado) {
        menuPrincipalSelecionado.className = "ajan-menu";
      }
      submenuSelecionado.style.visibility = "hidden";
      var submenu = this.querySelector("div.ajan-sub-menu");
      if (submenu) {
        submenu.style.visibility = "visible";
        submenuSelecionado = submenu;
      }
      menuPrincipalSelecionado = this;
      return;
    }
    this.classList.add("ajan-menu-hover");
  }

  function onMouseOutMenu() {
    if (submenuSelecionado && menuPrincipalSelecionado === this) {
      this.classList.add("ajan-menu-click");
      return;
    }
    this.className = "ajan-menu";
  }

  function onClickMenu(event) {
    this.classList.add("ajan-menu-click");
    if (this.acao) {
      Function(this.acao)();
      return;
    }
    var action = this.querySelector("div.ajan-sub-menu");
    if (!action) {
      return;
    }
    if (action.style.visibility === "visible") {
      action.style.visibility = "hidden";
      this.className = "ajan-menu ajan-menu-hover";
      return;
    }
    submenuSelecionado && (submenuSelecionado.style.visibility = "hidden");
    action.style.visibility = "visible";
    submenuSelecionado = action;
    menuPrincipalSelecionado = this;
    event.stopPropagation();
  }

  function itemSubMenu(o) {
    var div = document.createElement("div");
    div.acao = o.acao;

    if (o.enabled && o.acao && o.acao !== "hr") {
      div.onmouseover = onSubMenuOver;
      div.onmouseout = onSubMenuOut;
      div.onclick = onSubClick;
    }

    // Conteudo do subitem
    var classe = (o.enabled)
      ? "ajan-sub-menu-norm"
      : "ajan-sub-menu-norm ajan-sub-menu-dis";
    var aux =
      `<table style='width:100%' cellpadding=0 cellspacing=0 class='${classe}'>
            <tr><td width=16px style='min-width:16px'>`;
    if (o.img) {
      aux += `<img src='${o.img}'/>`;
    }
    aux += "</td>";
    if (o.acao === "hr") {
      aux += '<td class="ajan-menu-divider"><hr width=100%/></td>';
    } else {
      aux += `<td>${o.nome}</td>`;
    }
    aux += '<td width=16px style="min-width:16px"></td></table>';
    div.innerHTML = aux;
    o.pai.appendChild(div);
    return div;
  }

  function onSubMenuOver() {
    this.getElementsByTagName("table")[0].classList.add("ajan-sub-menu-des");
  }

  function onSubMenuOut() {
    this.getElementsByTagName("table")[0].className = "ajan-sub-menu-norm";
  }

  function onSubClick() {
    this.acao && Function(this.acao)();
  }

  function onSubSubOut() {
    this.style.visibility = "hidden";
  }

  function onSubPaiOver() {
    var item = this.querySelector("div.ajan-sub-menu");
    item.style.visibility = "visible";

    var $menu = jQuery__default["default"](this),
      $subMenu = jQuery__default["default"](item),
      width = $menu.offset().left + $menu.outerWidth(),
      subWidth = 0;

    jQuery__default["default"](this).parent().find(".ajan-sub-menu").each(function () {
      const $elm = jQuery__default["default"](this);
      ($elm.outerWidth() > subWidth) && (subWidth = $elm.outerWidth());
    });

    width += subWidth;

    (width > window.innerWidth)
      ? $subMenu.css({ left: "auto", right: (this.offsetWidth) + "px" })
      : $subMenu.css({ right: "auto", left: (this.offsetWidth) + "px" });

    this.getElementsByTagName("table")[0].classList.add("ajan-sub-menu-des");
  }

  function onSubPaiOut() {
    this.getElementsByTagName("table")[0].className = "ajan-sub-menu-norm";
    var item = this.querySelector("div.ajan-sub-menu");
    item && (item.style.visibility = "hidden");
  }

  Menu.setJson = function (menus) {
    // Container do menu principal
    var menuBarra = menuPrincipal(0, 26);

    function loadChild(childs, container) {
      for (var j = 0; j < childs.length; j++) {
        // Pega os menus secundarios
        var menu = childs[j];

        if (!menu.descricao) {
          itemSubMenu({ nome: "", acao: "hr", pai: container });
          continue;
        }

        var exec = menu.exec
          ? menu.exec
          : (menu.id ? `Yanda.newApl(${menu.id});` : null);
        var menuItem = itemSubMenu({
          img: menu.img,
          nome: menu.descricao,
          acao: exec,
          pai: container,
          enabled: menu.enabled,
        });

        if (menu.childs.length) {
          var subMenu = Util.createElm("div");
          subMenu.className = "ajan-sub-menu";
          subMenu.style.top = "0";
          subMenu.onclick = function () {
            this.onmouseout();
          };
          subMenu.onmouseout = onSubSubOut;
          menuItem.appendChild(subMenu);

          // Altera propriedades do subitem chamador
          menuItem.style.position = "relative";
          menuItem.getElementsByTagName("td")[2].innerHTML =
            '<img style="position: relative; top: 2px;" src="' +
            (Menu.MenuImgNext || Yanda.src + "img/arrow_next.gif") + '">';
          menuItem.onmouseover = onSubPaiOver;
          menuItem.onmouseout = onSubPaiOut;

          loadChild(menu.childs, subMenu);
        }
      }
    }

    for (var i = 0; i < menus.length; i++) {
      var menu = menus[i],
        content = menu.descricao,
        exec = menu.exec
          ? menu.exec
          : (menu.id ? `Yanda.newApl(${menu.id});` : null);

      if (menu.img) {
        content = `<div><i class="mdi mdi-${
        menu.img || "square-o"
      }" title="${menu.descricao}"></i><span>${menu.descricao}</span></div>`;
      }
      var container = itensPrincipal(menuBarra, content, exec);
      if (menu.childs.length) {
        var $subMenu = jQuery__default["default"]('<div class="ajan-sub-menu">').css({
          top: (this.SubMenuTop) + "px",
          left: "-2px",
        }).appendTo(container);
        loadChild(menu.childs, $subMenu[0]);
      }
    }

    document.body.appendChild(menuBarra);

    jQuery__default["default"](".ajan-menu").each(function () {
      var $menu = jQuery__default["default"](this),
        $subMenu = $menu.find("> .ajan-sub-menu"),
        width = $menu.offset().left + $menu.outerWidth() + $subMenu.outerWidth();

      (width > window.innerWidth) &&
        $subMenu.css({ left: "auto", right: "-2px" });
    });
  };

  // deno-lint-ignore-file

  function Toolbar() {
    this.createHTML();
  }

  Toolbar.prototype = {
    icons: ".mdi-chevron-up, .mdi-chevron-down",

    createHTML() {
      jQuery__default["default"](document.body).append(
        `<div class="ajan-toolbar">
        <i class="mdi mdi-chevron-up"></i>
        <div class="ajan-toolbar-content"></div>
        <i class="mdi mdi-chevron-down"></i>
      </div>`,
      );

      this.refresh();
    },

    scrollUp($content, $elm, scroll) {
      clearTimeout(this.timeout);
      if (!scroll) {
        return;
      }

      const that = this;
      that.timeout = setTimeout(function () {
        const scrollTop = $content.prop("scrollTop") - 7;
        $content.prop("scrollTop", scrollTop);
        if (scrollTop <= 0) {
          return;
        }
        that.scrollUp($content, $elm, scroll);
      }, 10);
    },

    scrollDown($content, $elm, scroll) {
      clearTimeout(this.timeout);
      if (!scroll) {
        return;
      }

      const that = this;
      that.timeout = setTimeout(function () {
        const scrollTop = $content.prop("scrollTop") + 7;
        $content.prop("scrollTop", scrollTop);
        if ((scrollTop + $content.height()) >= $content.prop("scrollHeight")) {
          return;
        }
        that.scrollDown($content, $elm, scroll);
      }, 10);
    },

    refresh() {
      const that = this;
      const ctr = Yanda.ctr;
      const $elm = jQuery__default["default"](".ajan-toolbar");
      const $content = jQuery__default["default"](".ajan-toolbar-content");
      const pageSize = new Util.getPageSize();

      $elm.css({
        left: (ctr.janMaPosLeft + 10) + "px",
        top: ctr.janMaPosTop + "px",
      })
        .on("mouseenter", function () {
          $elm.find(that.icons).css({ color: "#424242" });
        })
        .on("mouseleave", function () {
          $elm.find(that.icons).css({ color: "transparent" });
        });

      $content.css({
        height: (pageSize.windowHeight - ctr.janMaPosTop - 25) + "px",
      }).on("scroll", function () {
        const $up = $elm.find(".mdi-chevron-up");
        const $down = $elm.find(".mdi-chevron-down");

        $up.show();
        $down.show();
        $down.removeClass("ajan-toolbar-disabled");

        const scrollTop = $content.prop("scrollTop");
        if (!scrollTop) {
          $up.hide();
          return;
        }

        if ((scrollTop + $content.height()) >= $content.prop("scrollHeight")) {
          $down.hide();
        }
      });

      $elm.height() < $content.prop("scrollHeight")
        ? $elm.find(".mdi-chevron-down").show()
        : $elm.find(that.icons).hide();

      $elm.find(that.icons)
        .on("mouseenter", function () {
          const $elm = jQuery__default["default"](this);
          const $content = jQuery__default["default"](".ajan-toolbar-content");
          const scroll = $elm.hasClass("mdi-chevron-up")
            ? "scrollUp"
            : "scrollDown";

          that[scroll]($content, $elm, true);
        })
        .on("mouseleave", function () {
          clearTimeout(that.timeout);
        })
        .on("click", function () {
          const $elm = jQuery__default["default"](this);
          const $content = jQuery__default["default"](".ajan-toolbar-content");
          const scrollTop = $content.prop("scrollHeight") - $content.height();

          clearTimeout(that.timeout);
          $content.stop().animate(
            { scrollTop: $elm.hasClass("mdi-chevron-up") ? 0 : scrollTop },
            500,
            "swing",
          );
        });
    },

    newIcon(o) {
      const icon = o.img
        ? `<img src="${Yanda.basePath + o.img}">`
        : `<span class="${o.class}"></span>`;

      const $div = jQuery__default["default"](
        `<div data-id="${o.id}" title="${o.tit}">
        ${icon}
        <span style="font-size: 10px;">${o.id}</span>
      </div>`,
      ).on("click", function () {
        const id = jQuery__default["default"](this).data("id");
        id && Yanda.newApl(id);
      });

      jQuery__default["default"](".ajan-toolbar > div").append($div);
      this.refresh();
    },

    clear() {
      jQuery__default["default"](".ajan-toolbar > div").html("");
    },

    load(data) {
      this.clear();
      data.forEach((obj) => this.newIcon(obj));
    },
  };

  // deno-lint-ignore-file no-this-alias
  function selectinsert ($, Yanda) {
    if (!$.widget) {
      return;
    }

    $.widget("custom.selectinsert", {
      options: {
        id: null,
        hdl: null,
        url: null,
        data: null,
        async: true,
        change: null,
        fieldCod: null,
        fieldDes: null,
        btnValue: null,
        adicional: null,
        onSelectValue: null,
        setCarregando: false,
        onOptionCreate: null,
      },

      _create: function () {
        this.select = this.element[0];
        const that = this,
          parent = that.select.parentElement;

        that.options.change && (that._change = that.options.change.bind(this));
        that.options.btnValue = that.options.btnValue
          ? 'value="' + that.options.btnValue + '"'
          : 'class="mdi" style="font: normal normal normal 18px/1 \'Material Design Icons\';" value="&#xF0349"';

        that.div = $(
          '<div><table style="width:100%"><tr><td style="width:100%"></td>' +
            '<td><input type="button" id="bt' + that.select.id + '" ' +
            that.options.btnValue + " yanda-no-focus></td>" +
            "</tr></table></div>",
        ).css({ width: "100%" });

        that.div.data("type", "selectinsert");
        that.div.find("td")[0].appendChild(that.select);
        that.btn = that.div.find("input")[0];
        that.div.appendTo(parent);

        that._change &&
          that.element.change(() => that._change($(that.select).val()));

        that.btn.addEventListener("click", function () {
          const parms = {
            multiselect: false,
            adicional: typeof that.options.adicional === "function" &&
              that.options.adicional(),
          };

          typeof that.options.data === "function" &&
            (parms.postData = that.options.data());
          Yanda.newApl(that.options.id, parms, that.options.hdl, function (hdl) {
            hdl.onValueSelect = function (values) {
              const value = values.shift();
              value && setTimeout(() => that.reload(value), 10);
            };
          });
        }, false);
      },

      disabled: function (val) {
        if (val === undefined) {
          return $(this.select).prop("disabled");
        }
        $(this.btn).prop("disabled", val);
        return $(this.select).prop("disabled", val);
      },

      reload: function (value) {
        const data = {},
          that = this,
          $elm = $(that.select);

        if (value && that.select.multiple) {
          const aux = value[that.options.fieldCod];
          value = $elm.val() || [];
          value.push(aux);
        } else if (value) {
          value = value[that.options.fieldCod];
        }

        data[that.options.fieldCod] = value;

        typeof that.options.data === "function" &&
          $.extend(data, that.options.data());

        function getColVal(obj, key) {
          const pos = key.indexOf(".");
          if (pos === -1) {
            return obj[key];
          }
          return obj[key.substr(0, pos)]
            ? getColVal(obj[key.substr(0, pos)], key.substr(pos + 1, key.length))
            : "";
        }

        $.ajax({
          url: that.options.url,
          data: data,
          async: that.options.async,
          method: "POST",
          beforeSend: function () {
            that.options.setCarregando &&
              Yanda.getJanByPid(that.options.hdl.pid).setCarregando(true);
          },
        }).done(function (resp) {
          if (typeof resp !== "object") {
            try {
              resp = JSON.parse(resp);
            } catch (_e) {
              resp = {};
            }
          }

          that.select.innerHTML = "<option/>";

          if (resp.type && resp.type !== "success") {
            Notify[resp.type](resp.msg);
            return;
          }

          const objs = resp.data ? resp.data : resp;
          objs.forEach(function (obj) {
            const id = that.select.options.length;
            if (that.options.onOptionCreate) {
              that.select.options[id] = that.options.onOptionCreate(
                obj,
                that.select,
              );
              return;
            }
            that.select.options[id] = new Option(
              obj[that.options.fieldDes] ||
                getColVal(obj, that.options.fieldDes) || "",
              obj[that.options.fieldCod],
            );
          });

          if (!value) {
            return;
          }

          that.options.onSelectValue
            ? that.options.onSelectValue(value, that.select)
            : $elm.val(value);
          that._change && that._change($elm.val());
        }).always(function () {
          that.options.setCarregando &&
            Yanda.getJanByPid(that.options.hdl.pid).setCarregando(false);
        });
      },

      _destroy: function () {
      },
    });
  }

  // deno-lint-ignore-file

  function foreigninput ($, Yanda) {
    if (!$.widget) {
      return;
    }

    $.widget("custom.foreigninput", {
      options: {
        id: null,
        hdl: null,
        url: null,
        data: null,
        name: "",
        async: true,
        change: null,
        number: false,
        textarea: null,
        btnValue: null,
        fieldCod: "id",
        fieldDes: null,
        inputDes: null,
        required: false,
        adicional: null,
        inputmask: null,
        valueChange: true, // TODO: deprecated (in future only false)
        autocomplete: null,
        fieldCodStyle: "",
        setCarregando: false,
        fieldCodPlaceholder: "",
        attributeName: false,
      },

      _create: function () {
        this.div = this.element[0];

        const that = this,
          opt = that.options,
          nameInput = opt.attributeName
            ? that.element.attr("name")
            : (opt.name ? opt.name : that.element.prop("id"));

        opt.change && (that._change = opt.change.bind(this));
        opt.btnValue = opt.btnValue
          ? `value='${opt.btnValue}'`
          : 'class="mdi" style="font: normal normal normal 18px/1 \'Material Design Icons\';" value="&#xF0349"';
        that.$table = $(
          '<table style="width:100%"><tr><td style="width:100px;">' +
            `<input type="hidden" name="${nameInput}">` +
            `<input style="width:100px; ${
            (opt.number ? "text-align: right;" : "") + opt.fieldCodStyle
          }"` +
            `${
            opt.required ? "required" : ""
          } placeholder="${opt.fieldCodPlaceholder}">` +
            `</td><td style="width: ${opt.textarea ? " 100%;" : "28px;"}">` +
            `<input type="button" ${opt.btnValue} yanda-no-focus>` +
            `${
            !opt.textarea
              ? `</td><td><input readonly style="width:100%; ${
                opt.fieldDes ? "" : "display:none;"
              }">`
              : ""
          }` +
            "</td></tr>" +
            `${
            opt.textarea
              ? `<tr><td colspan="2" style="width:100%;">${opt.textarea}</td></tr>`
              : ""
          }` +
            "</table>",
        ).appendTo(that.element);

        that.element[0].setAttribute("data-type", "foreigninput");
        const $input = that.element.find("input:not([type])");
        that.$btn = that.element.find("input[type=button]");
        that.$inputCod = $input.eq(0);

        (that.element.attr("yanda-no-focus") !== undefined) &&
          that.element.find("input, textarea").attr("yanda-no-focus", true);
        (that.element.attr("yanda-no-enter") !== undefined) &&
          that.element.find("input, textarea").attr("yanda-no-enter", true);

        if (opt.number && !opt.autocomplete) {
          const k = $.ui.keyCode,
            keys = [
              k.LEFT,
              k.RIGHT,
              k.UP,
              k.DOWN,
              k.HOME,
              k.END,
              k.PAGE_DOWN,
              k.PAGE_UP,
              k.BACKSPACE,
              k.DELETE,
              k.ENTER,
              k.TAB,
              k.ESCAPE,
            ],
            keysNumbers = [
              48,
              49,
              50,
              51,
              52,
              53,
              54,
              55,
              56,
              57, // 0-9 teclado normal
              96,
              97,
              98,
              99,
              100,
              101,
              102,
              103,
              104,
              105, // 0-9 teclado numerico
            ],
            pasteDrop = function (e) {
              const data = e.originalEvent.clipboardData ||
                  e.originalEvent.dataTransfer,
                value = data.getData("Text");
              if (value && !/^[0-9]+$/.test(value)) {
                e.cancelBubble = true;
                e.stopImmediatePropagation();
                e.returnValue = false;
                e.preventDefault();
                Notify.warning("Somente números");
              }
            };

          that.$inputCod.on("keydown", function (e) {
            return (
              e.metaKey || e.ctrlKey ||
              $.inArray(e.keyCode || e.which, keys) !== -1 ||
              (!e.shiftKey && $.inArray(e.keyCode || e.which, keysNumbers) !== -1)
            );
          });
          that.$inputCod.on("paste", pasteDrop);
          that.$inputCod.on("drop", pasteDrop);
        }

        that.$inputDes = opt.textarea
          ? that.element.find("textarea")
          : $input.eq(1);
        that.$inputHidden = that.element.find("input[type=hidden]");
        that._value = "";

        opt.inputDes &&
          that.$inputDes.prop("id", opt.inputDes).prop("name", opt.inputDes);

        // TODO: deprecated old autocomplete
        if (opt.autocomplete && opt.autocomplete.source) {
          opt.autocomplete.old = true;
          (opt.autocomplete.readonly === undefined) &&
            (opt.autocomplete.readonly = true);
          that.$inputDes.autocomplete(opt.autocomplete);
          that.$inputCod.on("keypress", function (e) {
            ((e.keyCode || e.which) === 13) &&
              that.$inputDes.prop(
                "readonly",
                that.$inputCod.val() ? opt.autocomplete.readonly : false,
              );
          });
          that.$inputDes.prop("readonly", false);
        }

        if (opt.autocomplete && !opt.autocomplete.old) {
          that.element.css("position", "relative");

          $('<span class="mdi mdi-information-outline mdi-18px" title="Pesquisar"></span>')
            .appendTo(that.element)
            .tooltip({
              content: () =>
                `${opt.autocomplete.info || "Pesquise por Código ou Descrição"}
              <div>
                <ul style="padding-left: 20px;">
                  <li style="font-style: italic;">
                    Utilize <b style="font-size: 1.5em;">;</b> para múltiplas condições
                  </li>
                </ul>
              </div>`,
            });

          const newRegister = {};
          newRegister[opt.fieldCod] = null;
          newRegister.newRegister = true;

          that.$inputCod.css("padding-left", "22px").autocomplete({
            appendTo: opt.hdl.janela,
            change: function () {
              return false;
            },
            source: (request, response) => {
              let dataOpt = { term: request.term };
              typeof opt.data === "function" &&
                (dataOpt = { term: request.term, ...opt.data() });
              newRegister[opt.fieldDes] = request.term;
              $.ajax({
                url: opt.autocomplete.url,
                data: dataOpt,
                dataType: "json",
                success: (resp) => {
                  const data = resp.data || resp.results || [];
                  opt.autocomplete.newId && data.push(newRegister);
                  response(data.map((d) => {
                    d.value = d[opt.fieldCod];
                    return d;
                  }));
                },
              });
            },
            minLength: 2,
            open: function () {
              let obj = Object.assign(
                {
                  width: "500px",
                  padding: "5px 10px",
                  "max-height": "405px",
                  "overflow-y": "hidden",
                  "overflow-x": "hidden",
                  "border-radius": "4px",
                },
                opt.autocomplete.widgetCss,
              );
              $(this).autocomplete("widget").css(obj);
            },
            close: (e) => e.stopPropagation(),
            select: (e, ui) => {
              Yanda.util.cancelEvent(e);
              if (ui.item && ui.item.newRegister) {
                that.$inputCod.val("");
                Yanda.newApl(opt.autocomplete.newId, null, opt.hdl, (hdl) => {
                  hdl.onClose = () => that.$inputCod.select();

                  const registroSalvo = hdl.registroSalvo;
                  hdl.registroSalvo = (data) => {
                    let id = null;
                    if (!data) {
                      hdl.refElm && (id = hdl.refElm.value);
                    } else if (typeof data === "object") {
                      id = data[opt.fieldCod];
                    } else {
                      id = data;
                    }

                    registroSalvo && registroSalvo(data);
                    id && setValue(id);
                  };

                  opt.autocomplete.onNew &&
                    opt.autocomplete.onNew(hdl, newRegister[opt.fieldDes]);
                });
                return;
              }

              setValue(ui.item, true);
              opt.autocomplete.onSelect && opt.autocomplete.onSelect(ui.item);
            },
          }).autocomplete("instance")._renderItem = (ul, data) => {
            if (!data[opt.fieldCod]) {
              return $('<li style="display:flex">').append(
                `<div style="flex: 1 auto; overflow: hidden; white-space: nowrap;
                text-overflow: ellipsis; width: 0; line-height: 25px; border-radius: 4px;">
                  <b>Cadastrar...</b>
              </div>`,
              ).appendTo(ul);
            }

            const descricao = opt.fieldDes
              ? that._getColVal(data, opt.fieldDes)
              : "";
            return opt.autocomplete.renderItem
              ? opt.autocomplete.renderItem(ul, data)
              : $('<li style="display:flex">').append(
                `<div style="flex: 1 auto; overflow: hidden; white-space: nowrap;
                text-overflow: ellipsis; width: 0; line-height: 25px; border-radius: 4px;">
                  <b>${data[opt.fieldCod]}</b> - ${descricao}
              </div>`,
              ).appendTo(ul);
          };
        }

        that.$inputCod.on("change", function () {
          that.$inputHidden[0].value = this.value;
        });

        const clearValue = () =>
          !that._value && opt.url && (that.$inputCod[0].value = "");
        if (opt.inputmask) {
          opt.inputmask && that.$inputCod.inputmask(opt.inputmask);
          that.$inputCod.on("blur", () => setTimeout(clearValue, 10));
        } else {
          that.$inputCod.on("blur", clearValue);
        }

        that.$btn.on("click", function () {
          const parms = {
            multiselect: false,
            adicional: typeof opt.adicional === "function" && opt.adicional(),
          };
          typeof opt.data === "function" && (parms.postData = opt.data());
          Yanda.newApl(opt.id, parms, opt.hdl, function (hdl) {
            let cancelado = true;
            hdl.onValueSelect = function (values) {
              const value = values.shift();
              if (value) {
                cancelado = false;
                that.$inputHidden[0].value = value;
                that._change && that._change(value);
              }
            };
            hdl.onClose = function () {
              let e;
              that.$inputCod.select();

              // se for cancelado deixa o foco nele mesmo
              if (cancelado) {
                return;
              }

              if (that.$inputCod.attr("yanda-no-enter") !== undefined) {
                return;
              }

              // Simular evento enter (evento do jqGridEdit)
              e = $.Event("keydown");
              e.which = 13;
              e.keyCode = 13;
              that.$inputCod.trigger(e);
              (opt.autocomplete && opt.autocomplete.old)
                ? that.$inputDes.trigger(e)
                : that.$inputCod.trigger(e);

              if (Util.isMobile()) {
                return;
              }

              // Simular evento enter
              e = $.Event("keypress");
              e.which = 13;
              e.keyCode = 13;
              that.$inputCod.trigger(e);
              (opt.autocomplete && opt.autocomplete.old)
                ? that.$inputDes.trigger(e)
                : that.$inputCod.trigger(e);
            };
          });
        });

        that.div.focus = () => that.$inputCod.focus();
        that.div.select = () => that.$inputCod.select();

        function getValue() {
          return that._value;
        }

        function setValue(v, change = false) {
          let cod = v;
          const isObject = typeof v === "object";
          if (isObject) {
            try {
              opt.fieldDes && that.$inputDes.val(
                (v[opt.fieldDes] || that._getColVal(v, opt.fieldDes) || "")
                  .replace(/(<([^>]+)>)/g, ""),
              );
              that.$inputDes.prop("title", that.$inputDes.val());
              cod = v[opt.fieldCod].toString() || "";
            } catch (e) {
              cod = "";
              that.$inputDes.val("").prop("title", "");
            }
          } else {
            cod = cod.toString() || "";
          }

          that.$inputCod[0].value = cod;

          (opt.autocomplete && opt.autocomplete.old) &&
            that.$inputDes.prop(
              "readonly",
              cod ? opt.autocomplete.readonly : false,
            );

          if (
            isObject || (cod === that._value && !opt.valueChange) ||
            (cod === that._value && opt.autocomplete)
          ) {
            that._value = cod;
            isObject && change && that._change && that._change(v);
            return;
          }

          that._value = cod;
          that.change();
        }

        Object.defineProperty(that.$inputHidden[0], "value", {
          get: getValue,
          set: setValue,
        });
        Object.defineProperty(that.div, "value", {
          get: getValue,
          set: setValue,
          configurable: true,
        });
      },

      _destroy: function () {
        this.$table.remove();
      },

      _getColVal: function (obj, key) {
        const pos = key.indexOf(".");
        if (pos !== -1) {
          if (obj[key.substr(0, pos)]) {
            return this._getColVal(
              obj[key.substr(0, pos)],
              key.substr(pos + 1, key.length),
            );
          }
          return "";
        }
        return obj[key];
      },

      change: function () {
        const that = this,
          opt = that.options,
          clear = opt.number && that.$inputCod.val().match(/\D+/g, "");

        that.$inputDes.val("").prop("title", "");
        if (clear || !that.$inputCod.val()) {
          that.$inputCod.val("");
          that._value = "";
          that._change && that._change(null);
          return;
        }

        if (!opt.url) {
          const obj = {};
          obj[opt.fieldCod] = that.$inputCod.val();
          that._change && that._change(obj);
          return;
        }

        const data = {};
        data[opt.fieldCod] = that.$inputCod.val();
        typeof opt.data === "function" && $.extend(data, opt.data());

        $.ajax({
          method: "POST",
          url: opt.url,
          data,
          async: opt.async,
          beforeSend: function () {
            opt.setCarregando
              ? Yanda.getJanByPid(opt.hdl.pid).setCarregando(true)
              : that.$inputCod.addClass("input-loading");
          },
        }).done(function (resp) {
          opt.setCarregando &&
            Yanda.getJanByPid(opt.hdl.pid).setCarregando(false);
          that.$inputCod.removeClass("input-loading");

          if (typeof resp !== "object") {
            try {
              resp = JSON.parse(resp);
            } catch (e) {
              that._value = "";
              that.$inputCod.select();
              return;
            }
          }

          if (!resp) {
            return;
          }

          if (resp.type && resp.type !== "success") {
            that._change && that._change(null);
            Notify[resp.type](resp.msg);
            that._value = "";
            that.$inputCod.select();
            return;
          }

          const obj = resp.data ? resp.data : resp;
          opt.fieldDes && that.$inputDes.val(
            (that._getColVal(obj, opt.fieldDes) || "").replace(
              /(<([^>]+)>)/g,
              "",
            ),
          ).prop("title", that.$inputDes.val());

          that._change && that._change(obj);
        }).always(function (data, status, xhr) { // Executado sempre no termino da requisição
          opt.setCarregando &&
            Yanda.getJanByPid(opt.hdl.pid).setCarregando(false);
          that.$inputCod.removeClass("input-loading");

          if (!xhr.responseText || xhr.responseText.toLowerCase() === "null") {
            that._change && that._change(null);
            Notify.warning("Cadastro não encontrado");
            that._value = "";
            that.$inputCod.select();
          }
        });
      },

      disabled: function (val) {
        if (val === undefined) {
          return this.$inputCod.prop("disabled");
        }
        this.$btn.prop("disabled", val);
        this.$inputDes.prop("disabled", val);
        return this.$inputCod.prop("disabled", val);
      },

      readonly: function (val) {
        if (val === undefined) {
          return this.$inputCod.prop("readonly");
        }
        this.$btn.prop("disabled", val);
        if (
          this.options.autocomplete && this.options.autocomplete.old &&
          !this.$inputCod.val()
        ) {
          this.$inputDes.prop("readonly", val);
        }
        return this.$inputCod.prop("readonly", val);
      },
    });
  }

  // deno-lint-ignore-file
  /*
   * jQuery onoff
   *
   * Copyright 2011, L.STEVENIN
   * Released under the MIT license.
   *
   * Depends:
   * 	jquery.ui.widget.js
   */
  function onoff ($, onoff) {
    if (!$.widget) {
      return;
    }
    $.widget("onoff.onoff", {
      options: {
        classes: "",
        duration: 100,
        dragThreshold: 5,
        autoResize: true,
        labels: true,
        checkedLabel: "Sim",
        uncheckedLabel: "Não",
        disabledClass: "ui-onoff-disabled ui-state-disabled",
        template: null,
      },
      _create: function () {
        if (!this.element.is(":checkbox")) {
          return;
        }

        this._wrapCheckboxInContainer();
        this._attachEvents();
        this._globalEvents();
        this._disableTextSelection();

        if (this.element.prop("checked")) {
          this.$container.toggleClass(
            "ui-state-active",
            this.element.prop("checked"),
          );
        }

        if (this.options.autoResize) {
          this._autoResize();
        }

        this._initialPosition();
        this.refresh();
      },

      _template: function () {
        var that = this;

        if (that.options.template && typeof that.options.template === "object") {
          return $(that.options.template);
        }

        const dataset = that.element[0].dataset;
        if (dataset.label) {
          var label = document.createElement("label");
          $(label).css({
            position: "relative",
            top: "-8px",
            cursor: "pointer",
            "padding-left": "4px",
          }).text(
            dataset.label,
          ).on("click", function () {
            if (that.element.prop("disabled")) {
              return;
            }
            that.element.prop("checked", !that.element.prop("checked"));
          });
          that.element.after(label);
        }

        const getContrastYiq = (hexcolor) => {
            hexcolor = hexcolor.replace(/^#/, "");
            let r = parseInt(hexcolor.substr(0, 2), 16),
              g = parseInt(hexcolor.substr(2, 2), 16),
              b = parseInt(hexcolor.substr(4, 2), 16),
              yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
            return (yiq >= 128) ? "black" : "white";
          },
          background = dataset.color,
          tplColor = background
            ? `style="background: ${background}; color: ${
            getContrastYiq(background)
          }!important"`
            : "",
          template = document.createElement("div"),
          uncheckedLabel = that.options.labels
            ? dataset.uncheckedLabel || that.options.uncheckedLabel
            : "",
          checkedLabel = that.options.labels
            ? dataset.checkedLabel || that.options.checkedLabel
            : "",
          html = '<label class="ui-onoff-disabled">' +
            "<span>" + uncheckedLabel + "</span>" +
            "</label>" +
            '<label class="ui-onoff-enabled" ' + tplColor + ">" +
            "<span>" + checkedLabel + "</span>" +
            "</label>" +
            '<div class="ui-onoff-handle"></div>';

        template.className = "ui-onoff ui-onoff-default ui-onoff-ios5" +
          that.options.classes +
          (that.options.labels ? "" : " ui-onoff-no-labels");
        template.tabIndex = "0";
        template.innerHTML = html;
        dataset.minWidth && (template.style.minWidth = dataset.minWidth);
        dataset.maxWidth && (template.style.maxWidth = dataset.maxWidth);

        return $(template);
      },

      _wrapCheckboxInContainer: function () {
        var that = this;

        that.$container = $(that._template());
        that.element.after(that.$container);
        that.element.remove();
        that.$container.append(that.element);
        that.$disabledLabel = that.$container.children(".ui-onoff-disabled");
        that.$disabledSpan = that.$disabledLabel.children("span");
        that.$enabledLabel = that.$container.children(".ui-onoff-enabled");
        that.$enabledSpan = that.$enabledLabel.children("span");
        that.$handle = that.$container.children(".ui-onoff-handle");

        that.disabled = that.element[0].disabled;
        that.checked = that.element[0].checked;

        Object.defineProperty(that.element[0], "checked", {
          get: function () {
            return that.checked;
          },
          set: function (v) {
            that.checked = v;
            that.element.change();
          },
        });

        Object.defineProperty(that.element[0], "disabled", {
          get: function () {
            return that.disabled;
          },
          set: function (v) {
            that.disabled = v;
            that.refresh();
            that._setOption("disabled", v);
          },
        });
      },

      _attachEvents: function () {
        var obj = this;

        function refreshHandle() {
          obj.refresh();

          var new_left = obj.element.prop("checked") ? obj.rightSide : 0;

          obj.$handle.animate({ "left": new_left }, obj.options.duration);
          obj.$enabledLabel.animate({ "width": new_left }, obj.options.duration);
          obj.$disabledSpan.animate(
            { "margin-right": -new_left },
            obj.options.duration,
          );
          obj.$enabledSpan.animate(
            { "margin-left": new_left - obj.rightSide },
            obj.options.duration,
          );
        }

        // Listen for keyboard events such as <space>, <left> and <right>
        this.$container.bind("keydown", function (event) {
          //Ignore if a key combo was used
          if (event.ctrlKey || event.altKey || event.metaKey || event.shiftKey) {
            return;
          }

          //Catch <space>, <left>, and <right>
          if (
            event.keyCode === 32 || event.keyCode === 37 || event.keyCode === 39
          ) {
            event.preventDefault();
          }

          //Ignore if the element is disabled
          if (obj.element.prop("disabled")) {
            return;
          }

          //Determine if we're supposed to toggle
          var checked = obj.element.prop("checked");
          if (
            event.keyCode === 32 || (event.keyCode === 37 && checked) ||
            (event.keyCode === 39 && !checked)
          ) {
            //Perform the toggle
            var willChangeEvent = $.Event("willChange");
            obj.element.trigger(willChangeEvent);
            if (willChangeEvent.isDefaultPrevented()) {
              return;
            }

            checked = !checked;

            obj.element.prop("checked", checked);
            obj.$container.toggleClass("ui-state-active", checked);
            obj.element.trigger("didChange");
          }

          // A mousedown anywhere in the control will start tracking for dragging
        }).bind("mousedown touchstart", function (event) {
          event.preventDefault();

          if (obj.element.prop("disabled")) {
            return;
          }

          $(this).focus();

          var x = event.pageX || event.originalEvent.changedTouches[0].pageX;
          $[onoff].currentlyClicking = obj.$handle;
          $[onoff].dragStartPosition = x;
          $[onoff].handleLeftOffset = parseInt(obj.$handle.css("left"), 10) || 0;
          $[onoff].dragStartedOn = obj.element;

          // Utilize event bubbling to handle drag on any element beneath the container
        }).bind("iPhoneDrag", function (event, x) {
          event.preventDefault();

          if (obj.element.prop("disabled")) {
            return;
          }
          if (obj.element !== $[onoff].dragStartedOn) {
            return;
          }

          var p = (x + $[onoff].handleLeftOffset - $[onoff].dragStartPosition) /
            obj.rightSide;
          if (p < 0) {
            p = 0;
          }
          if (p > 1) {
            p = 1;
          }
          obj.$handle.css({ "left": p * obj.rightSide });
          obj.$enabledLabel.css({ "width": p * obj.rightSide });
          obj.$disabledSpan.css({ "margin-right": 0 - p * obj.rightSide });
          obj.$enabledSpan.css({ "margin-left": 0 - (1 - p) * obj.rightSide });

          // Utilize event bubbling to handle drag end on any element beneath the container
        }).bind("iPhoneDragEnd", function (event, x) {
          if (obj.element.prop("disabled")) {
            return;
          }

          var willChangeEvent = $.Event("willChange");
          obj.element.trigger(willChangeEvent);
          if (willChangeEvent.isDefaultPrevented()) {
            checked = obj.element.prop("checked");
          } else {
            var checked;
            if ($[onoff].dragging) {
              var p = (x - $[onoff].dragStartPosition) / obj.rightSide;
              checked = (p < 0) ? Math.abs(p) < 0.5 : p >= 0.5;
            } else {
              checked = !obj.element.prop("checked");
            }
          }

          $[onoff].currentlyClicking = null;
          $[onoff].dragging = null;
          // Somente executar o change quando alterar o checkbox
          var check = obj.element.prop("checked");
          if (check !== checked) {
            obj.element.prop("checked", checked);
          } else {
            refreshHandle();
          }

          obj.$container.toggleClass("ui-state-active", checked);
          obj.element.trigger("didChange");
        });

        // Animate when we get a change event
        this.element.change(function () {
          refreshHandle();
        });
      },
      _globalEvents: function () {
        if ($[onoff].initComplete) {
          return;
        }

        var opt = this.options;

        // As the mouse moves on the page, animate if we are in a drag state
        $(document).bind("mousemove touchmove", function (event) {
          if (!$[onoff].currentlyClicking) {
            return;
          }
          event.preventDefault();

          var x = event.pageX || event.originalEvent.changedTouches[0].pageX;
          if (
            !$[onoff].dragging &&
            (Math.abs($[onoff].dragStartPosition - x) > opt.dragThreshold)
          ) {
            $[onoff].dragging = true;
          }

          $(event.target).trigger("iPhoneDrag", [x]);

          // When the mouse comes up, leave drag state
        }).bind("mouseup touchend", function (event) {
          if (!$[onoff].currentlyClicking) {
            return;
          }
          event.preventDefault();

          var x = event.pageX || event.originalEvent.changedTouches[0].pageX;
          $($[onoff].currentlyClicking).trigger("iPhoneDragEnd", [x]);
        });
      },
      _disableTextSelection: function () {
        // Elements containing text should be unselectable
        $([
          this.$handle,
          this.$disabledLabel,
          this.$enabledLabel,
          this.$container,
        ]).attr("unselectable", "on");
      },
      _autoResize: function () {
        var spanWidth,
          onLabelWidth = this.$enabledLabel.width(),
          offLabelWidth = this.$disabledLabel.width(),
          spanPadding = this.$disabledSpan.innerWidth() -
            this.$disabledSpan.width(),
          handleMargins = this.$handle.outerWidth() - this.$handle.innerWidth(),
          handleWidth = (onLabelWidth > offLabelWidth)
            ? onLabelWidth
            : offLabelWidth,
          containerWidth = handleWidth;

        this.$handle.css({ "width": handleWidth });
        handleWidth = this.$handle.width();

        containerWidth += handleWidth + 6;
        spanWidth = containerWidth - handleWidth - spanPadding - handleMargins;

        this.$container.css({ "width": containerWidth });
        this.$container.find("span").width(spanWidth);
      },
      _initialPosition: function () {
        this.$disabledLabel.css({ width: this.$container.width() - 5 });

        this.rightSide = this.$container.width() - this.$handle.outerWidth();

        if (this.element.prop("checked")) {
          this.$handle.css({ "left": this.rightSide });
          this.$enabledLabel.css({ "width": this.rightSide });
          this.$disabledSpan.css({ "margin-right": -this.rightSide });
        } else {
          this.$enabledLabel.css({ "width": 0 });
          this.$enabledSpan.css({ "margin-left": -this.rightSide });
        }

        this.refresh();
      },
      enable: function () {
        this.element.prop("disabled", false);
        this.refresh();
        return this._setOption("disabled", false);
      },
      disable: function () {
        this.element.prop("disabled", true);
        this.refresh();
        return this._setOption("disabled", true);
      },
      widget: function () {
        return this.$container;
      },
      refresh: function () {
        if (this.element.prop("disabled")) {
          this.$container.prop("tabIndex", "-1");
          this.$container.addClass(this.options.disabledClass);
          return false;
        } else {
          this.$container.prop("tabIndex", "0");
          this.$container.removeClass(this.options.disabledClass);
        }
      },
    });
  }

  // deno-lint-ignore-file no-this-alias

  function jqAdapter (jQuery, Yanda) {
    /**
     * Adaptação da criação de janelas do GRID.
     * Os elementos da janela, sempre são criados no body e acabam não sendo removidos quando
     * as janelas do ajaynada são fechadas.
     * Para mais informações: https://github.com/tonytomov/jqGrid/blob/master/js/grid.common.js
     *
     * @param {type} $
     * @returns {undefined}
     */
    (function ($) {
      if (!$.jgrid) {
        return;
      }

      const originalCreateModal = $.jgrid.createModal;
      $.extend($.jgrid, {
        defaults: {
          regional: "pt-br",
        },
        createModal: function (
          aIDs,
          content,
          p,
          insertSelector,
          posSelector,
          _appendsel,
          css,
        ) {
          originalCreateModal.call(
            this,
            aIDs,
            content,
            p,
            insertSelector,
            posSelector,
            false,
            css,
          );
        },
      });

      $.jgrid.regional["pt-br"].search.odata.push({
        oper: "it",
        text: "verdadeiro",
      });
      $.jgrid.regional["pt-br"].search.odata.push({ oper: "if", text: "falso" });
    })(jQuery);

    /**
     * Datepicker e Timepicker
     */
    (function ($) {
      if (!$.datepicker || !$.timepicker) {
        return;
      }
      $.extend($.datepicker, { defaults: { regional: "pt-BR" } });

      $.datepicker.regional["pt-BR"] = {
        closeText: "Fechar",
        prevText: "Anterior",
        nextText: "Pr&oacute;ximo",
        currentText: "Hoje",
        monthNames: [
          "Janeiro",
          "Fevereiro",
          "Marco",
          "Abril",
          "Maio",
          "Junho",
          "Julho",
          "Agosto",
          "Setembro",
          "Outubro",
          "Novembro",
          "Dezembro",
        ],
        monthNamesShort: [
          "Janeiro",
          "Fevereiro",
          "Marco",
          "Abril",
          "Maio",
          "Junho",
          "Julho",
          "Agosto",
          "Setembro",
          "Outubro",
          "Novembro",
          "Dezembro",
        ],
        dayNames: [
          "Domingo",
          "Segunda-feira",
          "Ter&ccedil;a-feira",
          "Quarta-feira",
          "Quinta-feira",
          "Sexta-feira",
          "S&aacute;bado",
        ],
        dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "S&aacute;b"],
        dayNamesMin: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "S&aacute;b"],
        weekHeader: "Sm",
        dateFormat: "dd/mm/yy",
        firstDay: 0,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: "",
        showWeek: true,
        changeMonth: true,
        changeYear: true,
        showButtonPanel: true,
        showOtherMonths: true,
        showOn: "button",
        buttonImageOnly: true,
        buttonImage: () => `${Yanda.src}img/calendar.png`,
        calculateWeek: Util.calculateWeek,
      };
      $.datepicker.setDefaults($.datepicker.regional["pt-BR"]);

      $.timepicker.regional["pt-BR"] = {
        prevText: "Anterior",
        nextText: "Pr&oacute;ximo",
        timeOnlyTitle: "Escolha o horário",
        timeText: "Horário",
        hourText: "Hora",
        minuteText: "Minutos",
        secondText: "Segundos",
        millisecText: "Milissegundos",
        microsecText: "Microssegundos",
        timezoneText: "Fuso horário",
        monthNames: [
          "Janeiro",
          "Fevereiro",
          "Mar&ccedil;o",
          "Abril",
          "Maio",
          "Junho",
          "Julho",
          "Agosto",
          "Setembro",
          "Outubro",
          "Novembro",
          "Dezembro",
        ],
        monthNamesShort: [
          "Janeiro",
          "Fevereiro",
          "Mar&ccedil;o",
          "Abril",
          "Maio",
          "Junho",
          "Julho",
          "Agosto",
          "Setembro",
          "Outubro",
          "Novembro",
          "Dezembro",
        ],
        dayNames: [
          "Domingo",
          "Segunda-feira",
          "Ter&ccedil;a-feira",
          "Quarta-feira",
          "Quinta-feira",
          "Sexta-feira",
          "S&aacute;bado",
        ],
        dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "S&aacute;b"],
        dayNamesMin: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "S&aacute;b"],
        currentText: "Agora",
        weekHeader: "Sm",
        closeText: "Fechar",
        timeFormat: "HH:mm:ss",
        amNames: ["a.m.", "AM", "A"],
        pmNames: ["p.m.", "PM", "P"],
        isRTL: false,
        stepHour: 1,
        stepMinute: 1,
        stepSecond: 1,
        showWeek: true,
        changeMonth: true,
        changeYear: true,
        showButtonPanel: true,
        showOtherMonths: true,
        showOn: "button",
        buttonImage: () => `${Yanda.src}img/calendar_time.png`,
        calculateWeek: Util.calculateWeek,
      };
      $.timepicker.setDefaults($.timepicker.regional["pt-BR"]);

      const formatDate = function () {
        const $elm = $(this);
        const value = this.value;
        const length = value.length;

        let format;
        let date = "";
        switch (jQuery(this).data("formatajan")) {
          case "datepicker":
            (length === 8) &&
              (date = moment(value, "DD/MM/YY").format("DD/MM/YYYY"));
            (length === 10) &&
              (date = moment(value, "DD/MM/YYYY").format("DD/MM/YYYY"));
            break;

          case "datetimepicker":
          case "datetimepickerFull":
            format = (jQuery(this).data("formatajan") === "datetimepicker")
              ? "DD/MM/YYYY HH:mm"
              : "DD/MM/YYYY HH:mm:ss";

            switch (length) {
              case 8:
                date = moment(value, "DD/MM/YY").format(format);
                break;
              case 10:
                date = moment(value, "DD/MM/YYYY").format(format);
                break;
              case 13:
                date = moment(value, "DD/MM/YYYY HH").format(format);
                break;
              case 16:
                date = moment(value, "DD/MM/YYYY HH:mm").format(format);
                break;
              case 19:
                date = moment(value, format).format(format);
                break;
            }
            break;

          case "datepickerYear":
            (length === 2) && (date = moment(value, "YY").format("YYYY"));
            (length === 4) && (date = moment(value, "YYYY").format("YYYY"));
            break;

          case "datepickerWeek":
            (length === 5) &&
              (date = $elm.datepickerWeek(
                "getDateWeek",
                moment(value, "WW/YY").toDate(),
              ));
            (length === 7) &&
              (date = $elm.datepickerWeek(
                "getDateWeek",
                moment(value, "WW/YYYY").toDate(),
              ));
            break;

          case "datepickerMonth":
            (length === 5) && (date = moment(value, "MM/YY").format("MM/YYYY"));
            (length === 7) && (date = moment(value, "MM/YYYY").format("MM/YYYY"));
            break;

          case "datepickerDayMonth":
            (length === 5) && (date = moment(value, "DD/MM").format("DD/MM"));
            break;
        }

        $elm.val(date);
      };

      // Formatar datas
      const $fndatepicker = $.fn.datepicker;
      $.fn.datepicker = function (opt) {
        // config || undefined (config padrão)
        // outros metodos retorna o padrão (option, setDate, destroy...)
        if (typeof opt !== "object" && opt !== undefined) {
          return $fndatepicker.apply(this, arguments);
        }

        let format;
        let timeOnly;
        let formatajan;
        if (!opt) {
          format = "99/99/9999";
          formatajan = "datepicker";
        } else if (opt.custom) {
          switch (opt.custom) {
            case "datepicker":
              format = "99/99/9999";
              break;
            case "datepickerYear":
              format = "9999";
              break;
            case "datepickerWeek":
              format = "99/9999";
              break;
            case "datepickerMonth":
              format = "99/9999";
              break;
          }
          formatajan = opt.custom;
        } else if (opt.timeOnly) {
          timeOnly = true;
          format = opt.timeFormat === "HH:mm" ? "99:99" : "99:99:99";
          opt.buttonImage = `${Yanda.src}img/time.png`;
        } else if (opt.timeFormat === "HH:mm") {
          format = "99/99/9999 99:99";
          formatajan = "datetimepicker";
        } else if (opt.timeFormat === "HH:mm:ss") {
          format = "99/99/9999 99:99:99";
          formatajan = "datetimepickerFull";
        } else if (opt.dateFormat === "dd/mm") {
          format = "99/99";
          formatajan = "datepickerDayMonth";
        } else {
          format = "99/99/9999";
          formatajan = "datepicker";
        }

        !timeOnly && $(this).not(".hasDatepicker")
          .data("formatajan", formatajan)
          .off("change", formatDate)
          .on("change", formatDate);

        $(this).inputmask(format, { placeholder: " " });

        const $elm = $fndatepicker.apply(this, arguments);

        if (opt && opt.date) {
          const type =
            ["datetimepicker", "datetimepickerFull"].includes(formatajan)
              ? "datetimepicker"
              : "datepicker";
          $elm[type]("setDate", opt.date);
        }

        return $elm;
      };

      $.widget("custom.datepickerDay", {
        _create: function () {
          const that = this;
          that.element.datepicker({
            date: that.options && that.options.date ? that.options.date : null,
            custom: "datepicker",
            beforeShow: function (input, inst) {
              $(this).datepicker("hide");
              $("#ui-datepicker-div").removeClass("hide-calendar").removeClass(
                "hide-calendar-month",
              );
              that.options.beforeShow && that.options.beforeShow(input, inst);
            },
          });
        },
        _destroy: function () {
          this.element.datepicker("destroy");
        },
      });

      $.widget("custom.datepickerWeek", {
        _create: function () {
          const that = this;

          that.element.datepicker({
            custom: "datepickerWeek",
            beforeShow: function (input, inst) {
              const $elm = $(this);
              const val = $elm.val();
              let date;

              $elm.datepicker("hide");
              $("#ui-datepicker-div").removeClass("hide-calendar").removeClass(
                "hide-calendar-month",
              );
              if ($elm.val()) {
                const ano = parseInt($elm.val().substr(3, 4));
                const day = $elm.prop("id") == "dataInicial"
                  ? "Sunday"
                  : "Saturday";
                const semana = parseInt($elm.val().substr(0, 2)) + 1;

                date = moment().year(ano).week(semana).day(day).toDate();
                $elm.datepicker("option", "defaultDate", date).datepicker(
                  "setDate",
                  date,
                );
              }

              setTimeout(() => {
                $elm.val(val);
                that.options.beforeShow && that.options.beforeShow(input, inst);
              }, 0);
            },
            onSelect: function (dateText, inst) {
              $(this).val(
                that.getDateWeek(moment(dateText, "DD/MM/YYYY").toDate()),
              );
              that.options.onSelect && that.options.onSelect(dateText, inst);
            },
            onChangeMonthYear: function (year, month, obj) {
              const day = obj.selectedDay || "01";
              $(this).val(
                that.getDateWeek(
                  moment(`${day}/${month}/${year}`, "DD/MM/YYYY").toDate(),
                ),
              );
              // that.options.onSelect && that.options.onSelect(dateText, inst);
            },
          });

          that.options && that.options.date && that.element.val(
            that.element.datepickerWeek(
              "getDateWeek",
              new Date(that.options.date.getTime()),
            ),
          );
        },
        getDateWeek: function (date) {
          let week = Util.calculateWeek(date, true);
          (week < 10) && (week = "0" + week);
          return `${week}/${date.getFullYear()}`;
        },
        _destroy: function () {
          this.element.datepicker("destroy");
        },
      });

      $.widget("custom.datepickerMonth", {
        _create: function () {
          const that = this;

          that.element.datepicker({
            date: that.options && that.options.date ? that.options.date : null,
            custom: "datepickerMonth",
            dateFormat: "mm/yy",
            changeYear: true,
            changeMonth: true,
            showButtonPanel: true,
            showOtherMonths: true,
            beforeShow: function (input, inst) {
              const $elm = $(this);
              let date;

              $elm.datepicker("hide");
              $("#ui-datepicker-div").addClass("hide-calendar").removeClass(
                "hide-calendar-month",
              );

              if ($elm.val()) {
                date = moment($elm.val(), "MM/YYYY").toDate();
                $elm.datepicker("option", "defaultDate", date).datepicker(
                  "setDate",
                  date,
                );
              }
              that.options.beforeShow && that.options.beforeShow(input, inst);
            },
            onClose: function (dateText, inst) {
              const month = $("#ui-datepicker-div .ui-datepicker-month :selected")
                .val();
              const year = $("#ui-datepicker-div .ui-datepicker-year :selected")
                .val();
              $("#ui-datepicker-div").removeClass("hide-calendar").removeClass(
                "hide-calendar-month",
              );
              $(this).datepicker("setDate", new Date(year, month, 1));
              that.options.onClose && that.options.onClose(dateText, inst);
              $(this).change();
            },
            onChangeMonthYear: function (year, month) {
              (month < 10) && (month = `0${month}`);
              $(this).val(`${month}/${year}`);
            },
          });
        },
        _destroy: function () {
          this.element.datepicker("destroy");
        },
      });

      $.widget("custom.datepickerYear", {
        _create: function () {
          const that = this;

          that.element.datepicker({
            date: that.options && that.options.date ? that.options.date : null,
            custom: "datepickerYear",
            dateFormat: "yy",
            changeYear: true,
            changeMonth: false,
            showButtonPanel: true,
            showOtherMonths: true,
            hideIfNoPrevNext: true,
            beforeShow: function () {
              const $elm = $(this);
              let date;

              $elm.datepicker("hide");
              $("#ui-datepicker-div").addClass("hide-calendar").addClass(
                "hide-calendar-month",
              );

              if ($elm.val()) {
                date = moment($elm.val(), "YYYY").toDate();
                $elm.datepicker("option", "defaultDate", date).datepicker(
                  "setDate",
                  date,
                );
              }
            },
            onClose: function () {
              const year = $("#ui-datepicker-div .ui-datepicker-year :selected")
                .val();
              $("#ui-datepicker-div").removeClass("hide-calendar").removeClass(
                "hide-calendar-month",
              );
              $(this).datepicker("setDate", new Date(year, 1, 1));
              $(this).change();
            },
            onChangeMonthYear: function (year) {
              $(this).val(year);
            },
          });
        },
        _destroy: function () {
          this.element.datepicker("destroy");
        },
      });
    })(jQuery);
  }

  // deno-lint-ignore-file
  function jqGridEdit ($) {
    if (!$.widget) {
      return;
    }

    $.widget("custom.jqGridEdit", {
      options: {},

      _create: function () {
        var that = this,
          iCol = -1;

        that.options.subGrid === true && iCol++;
        that.options.multiselect === true && iCol++;
        that.options.rownumbers === true && iCol++;

        that.rowId = null;
        that.iRow = null;
        that.iCol = null;
        that.firstCol = null;
        that.lastCol = null;
        that.columns = [];

        $.each(that.options.colModel, function () {
          iCol++;
          if (this.editable !== true) {
            return;
          }

          if (!this.hidden) {
            that.columns.push(iCol);
            if (that.firstCol === null) {
              that.firstCol = iCol;
            }
            that.lastCol = iCol;
          }
          if (this.cellattr === undefined) {
            this.cellattr = function () {
              return ' style="background-color: #EFF6FD;"';
            };
          }

          // só funciona para elementos que o jqgrid cria
          if (!this.editoptions) {
            this.editoptions = {};
          }
          !this.editoptions.dataEvents && (this.editoptions.dataEvents = []);
          this.editoptions.dataEvents.push({
            type: "keydown",
            fn: function (e) {
              if ((e.keyCode || e.which) == $.ui.keyCode.ESCAPE) {
                that.stopEvent(e);
                that.save();
              }
            },
          });

          this.foreigninput && that._foreigninput(this, iCol);
          this.selectinsert && that._selectinsert(this, iCol);
          this.numberinput && that._numberinput(this, iCol);
        });

        if (
          that.options.multiselect === true &&
          that.options.beforeSelectRow === undefined
        ) {
          that.options.beforeSelectRow = function (rowid, e) {
            var $self = $(this),
              iCol,
              cm,
              $td = $(e.target).closest("tr.jqgrow>td"),
              $tr = $td.closest("tr.jqgrow"),
              p = $self.getGridParam();

            if ($(e.target).is("input[type=checkbox]") && $td.length > 0) {
              iCol = $.jgrid.getCellIndex($td[0]);
              cm = p.colModel[iCol];
              // multiselect checkbox is clicked
              (cm != null && cm.name === "cb") &&
                $self.setSelection($tr.attr("id"), true, e);
            }
            return false;
          };
        }

        that.options = $.extend({}, {
          idPrefix: "edit_",
          datatype: "local",
          cellsubmit: "clientArray",
          recordtext: "Total de registros: <b>{2}</b>",
          rowNum: 999999,
          scrollrows: true,
          viewrecords: true,
          pgbuttons: false,
          pginput: false,
          cellEdit: true,
          afterEditCell: function (rowId, name, value, iRow, iCol) {
            let $elm = that.element.find(
              `#${iRow}_${name}`.replace(/\./g, "\\."),
            );
            const type = $elm.data("type") || $elm.attr("type");

            that.rowId = rowId;
            that.iRow = iRow;
            that.iCol = iCol;
            if (type !== "foreigninput" && type !== "numberinput") {
              that.keydown($elm, iRow, iCol, type);
            } else {
              $elm = $elm.find('input[type!="hidden"]').eq(0);
            }
            setTimeout(() => $elm.focus().select(), 10);
          },
          afterSaveCell: function () {
            that.iRow = null;
            that.iCol = null;
          },
          afterRestoreCell: function () {
            that.iRow = null;
            that.iCol = null;
          },
        }, that.options);

        that.element.jqGrid(that.options);
      },

      _setAttributes: function (elm, atr) {
        var exclude = [
          "dataInit",
          "dataEvents",
          "dataUrl",
          "buildSelect",
          "sopt",
          "searchhidden",
          "defaultValue",
          "attr",
          "custom_element",
          "custom_value",
          "oper",
        ];
        $.each(atr, function (key, value) {
          ($.inArray(key, exclude) === -1) && $(elm).attr(key, value);
        });
      },

      _foreigninput: function (obj, iCol) {
        const that = this;
        (obj.editoptions === undefined) && (obj.editoptions = {});

        obj.edittype = "custom";
        obj.editoptions.custom_element = (function (fn, iCol) {
          return function (value, opt) {
            const $elm = $("<div></div>");
            const iRow = parseInt(opt.id.split("_")[0]);
            const options = fn(opt.rowId, opt.name, value, iRow, iCol);

            options.async = false;
            options.setCarregando = true;
            $elm.foreigninput(options);
            $elm.find("td").css({ "border-width": "0" });
            if (value) {
              const data = {};
              data[options.fieldCod] = value;
              $elm.val(data);
            }
            that._setAttributes(
              $elm.find('input[type!="hidden"]').eq(0),
              obj.editoptions,
            );
            options.customElement && options.customElement($elm);
            that.keydown($elm.find('input[type!="hidden"]').eq(0), iRow, iCol);
            return $elm;
          };
        })(obj.foreigninput, iCol);

        obj.editoptions.custom_value = function ($elm) {
          const value = $elm.find("input").eq(1).val();
          ($elm.val() !== value) && $elm.val(value);
          return value;
        };
      },

      _selectinsert: function (obj, iCol) {
        var that = this;
        if (obj.editoptions === undefined) {
          obj.editoptions = {};
        }

        obj.editoptions.dataInit = function (elm, opt) {
          const $elm = $(elm);
          const iRow = parseInt(opt.id.split("_")[0]);
          const options = (function (fn, iCol) {
            return fn(opt.rowId, opt.name, $elm.val(), iRow, iCol);
          })(obj.selectinsert, iCol);

          options.async = false;
          options.setCarregando = true;
          options.onSelectValue = function (value, elm) {
            const data = {};
            $(elm).find("option").each(function () {
              const $opt = $(this);
              data[$opt.val()] = $opt.text();
            });

            that.element.setColProp(obj.name, { editoptions: { value: data } });
            $(elm).val(value).focus();
            const e = $.Event("keydown");
            e.which = 13;
            e.keyCode = 13;
            $(elm).trigger(e);
          };

          $elm.selectinsert(options);
          $elm.parent().parent().find("td").css({ "border-width": "0" });
          that._setAttributes($elm, obj.editoptions);
        };
      },

      _numberinput: function (obj, iCol) {
        const that = this;
        const defaults = $.custom.numberinput.prototype.options;
        const numberinput = obj.numberinput();

        (obj.width === undefined) && (obj.width = 100);
        (obj.align === undefined) && (obj.align = "right");
        (obj.editoptions === undefined) && (obj.editoptions = {});
        (obj.formatoptions === undefined) && (obj.formatoptions = {});

        obj.formatoptions.decimalSeparator = numberinput.decPoint !== undefined
          ? numberinput.decPoint
          : defaults.decPoint;

        obj.formatoptions.thousandsSeparator =
          numberinput.thousandsSep !== undefined
            ? numberinput.thousandsSep
            : defaults.thousandsSep;

        if (obj.formatoptions?.decimalPlaces === undefined) {
          obj.formatoptions.decimalPlaces = numberinput.decimals !== undefined
            ? numberinput.decimals
            : defaults.decimals;
        }

        obj.formatoptions.defaultValue = numberinput.defaultValue !== undefined
          ? numberinput.defaultValue
          : "0";

        obj.sorttype = "float";
        obj.edittype = "custom";
        obj.formatter = obj.formatter ? obj.formatter : "number";
        obj.editoptions.custom_element = (function (fn, iCol) {
          return function (value, opt) {
            const iRow = parseInt(opt.id.split("_")[0]);
            const $elm = $(
              `<input style="text-align: ${obj.align}; width:100%;">`,
            );
            const options = fn(opt.rowId, opt.name, value, iRow, iCol);

            $elm.val(value);
            $elm.numberinput(options);
            that._setAttributes($elm, obj.editoptions);
            that.keydown.call(that, $elm, iRow, iCol);

            return $elm.parent();
          };
        })(obj.numberinput, iCol);

        obj.editoptions.custom_value = function ($div) {
          const $elm = $div.find('input[type!="hidden"]');
          ($elm[0].numberValue !=
            parseFloat($elm.numberinput("format", $elm.val()))) &&
            ($elm[0].numberValue = $elm.val());
          return $elm[0].numberValue;
        };
      },

      stopEvent: function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        e.preventDefault ? e.preventDefault() : (e.returnValue = false);
      },

      keydown: function ($elm, iRow, iCol) {
        const that = this;

        $elm.on("keydown", function (e) {
          const key = e.keyCode || e.which;

          if (key == $.ui.keyCode.ESCAPE) {
            that.stopEvent(e);
            that.save();
            return;
          }

          if (key !== $.ui.keyCode.ENTER) {
            return;
          }

          that.stopEvent(e);
          that.save();

          function next(e, that, iRow, iCol) {
            const lastRow =
              that.element.parent().find(".ui-jqgrid-btable .ui-row-ltr").length;
            let newColl = 1,
              newRow = iRow + (e.shiftKey ? -1 : 1);

            $.each(that.columns, function (i, v) {
              if (iCol === v) {
                if (e.ctrlKey) {
                  newColl = iCol;
                  return false;
                }

                newColl = e.shiftKey
                  ? (that.columns[i - 1] !== undefined
                    ? that.columns[i - 1]
                    : that.lastCol)
                  : (that.columns[i + 1] !== undefined
                    ? that.columns[i + 1]
                    : that.firstCol);

                if (e.shiftKey) {
                  newRow = newColl < iCol ? iRow : newRow;
                  return false;
                }

                newRow = newColl > iCol ? iRow : newRow;
                return false;
              }
            });

            // pular linha agrupamento
            const $lines = that.element.parent().find(".ui-jqgrid-btable tr");
            const $line = $lines.eq(newRow);
            if ($line.hasClass("jqgroup")) {
              if (!e.shiftKey) {
                $line.find(".ui-icon-circlesmall-plus").click();
                newRow++;
              } else {
                newRow--;
                $line.prev().is(":hidden") &&
                  $lines.slice(0, newRow).find(".ui-icon-circlesmall-plus").last()
                    .click();
              }
            }

            if (newRow === 0 || newRow > lastRow) {
              return false;
            }

            const colModel = that.element.getGridParam("colModel")[newColl];
            if (colModel.nofocus === true || colModel.hidden === true) {
              return next(e, that, newRow, newColl);
            }

            that.element.editCell(newRow, newColl, true);
            return true;
          }

          const findNext = next(e, that, iRow, iCol);
          if (findNext) {
            return;
          }

          // next page
          that.element.parent().parent().parent().parent()
            .find(`td[id*="${e.shiftKey ? "prev_" : "next_"}"]`).click();

          that.element.setGridParam({
            gridComplete: function () {
              const row = e.shiftKey
                ? that.element.getGridParam("reccount") + 1
                : 0;
              const col = e.shiftKey ? that.firstCol : that.lastCol;
              next(e, that, row, col);
              that.element.setGridParam({ gridComplete: null });
            },
          });
        });
      },

      restore: function () {
        const that = this;
        !(that.iRow === null || that.iCol === null) &&
          that.element.restoreCell(that.iRow, that.iCol);
      },

      save: function () {
        const that = this;
        !(that.iRow === null || that.iCol === null) &&
          that.element.saveCell(that.iRow, that.iCol);
      },

      edit: function (iRow, iCol) {
        const that = this;
        setTimeout(function () {
          const isRow = iRow <= that.element.getGridParam("reccount");
          let isCol = false;

          $.each(that.columns, function (i, v) {
            if (iCol === v) {
              isCol = true;
              return false;
            }
          });

          isCol && isRow && that.element.editCell(iRow, iCol, true);
        }, 10);
      },

      set: function (rowId, data) {
        (typeof data === "object") &&
          setTimeout(() => this.element.setRowData(rowId, data), 10);
      },
    });
  }

  // deno-lint-ignore-file
  function highlight (jQuery) {
    function ignorarAcentos(str) {
      var rExps = [
        { re: /[\xC0-\xC6]/g, ch: "A" },
        { re: /[\xE0-\xE6]/g, ch: "a" },
        { re: /[\xC8-\xCB]/g, ch: "E" },
        { re: /[\xE8-\xEB]/g, ch: "e" },
        { re: /[\xCC-\xCF]/g, ch: "I" },
        { re: /[\xEC-\xEF]/g, ch: "i" },
        { re: /[\xD2-\xD6]/g, ch: "O" },
        { re: /[\xF2-\xF6]/g, ch: "o" },
        { re: /[\xD9-\xDC]/g, ch: "U" },
        { re: /[\xF9-\xFC]/g, ch: "u" },
        { re: /[\xD1]/g, ch: "N" },
        { re: /[\xF1]/g, ch: "n" },
        { re: /Ç/g, ch: "C" },
        { re: /ç/g, ch: "c" },
      ];
      for (var i = 0, len = rExps.length; i < len; i++) {
        str = str.replace(rExps[i].re, rExps[i].ch);
      }
      return str;
    }

    jQuery.extend({
      highlight: function (node, re, nodeName, className) {
        if (node.nodeType === 3) {
          var match = ignorarAcentos(node.data).match(re);
          if (match) {
            var highlight = document.createElement(nodeName || "span");
            highlight.className = className || "highlight";
            var wordNode = node.splitText(match.index);
            wordNode.splitText(match[0].length);
            var wordClone = wordNode.cloneNode(true);
            highlight.appendChild(wordClone);
            wordNode.parentNode.replaceChild(highlight, wordNode);
            return 1; //skip added node in parent
          }
        } else if (
          (node.nodeType === 1 && node.childNodes) && // only element nodes that have children
          !/(script|style)/i.test(node.tagName) && // ignore script and style nodes
          !(node.tagName === nodeName.toUpperCase() &&
            node.className === className)
        ) { // skip if already highlighted
          for (var i = 0; i < node.childNodes.length; i++) {
            i += jQuery.highlight(node.childNodes[i], re, nodeName, className);
          }
        }
        return 0;
      },
    });

    jQuery.fn.unhighlight = function (options) {
      var settings = { className: "highlight", element: "span" };
      jQuery.extend(settings, options);

      return this.find(settings.element + "." + settings.className).each(
        function () {
          var parent = this.parentNode;
          parent.replaceChild(this.firstChild, this);
          parent.normalize();
        },
      ).end();
    };

    jQuery.fn.highlight = function (words, options) {
      var settings = {
        className: "highlight",
        element: "span",
        caseSensitive: false,
        wordsOnly: false,
      };
      jQuery.extend(settings, options);

      if (words.constructor === String) {
        words = [words];
      }

      words = jQuery.map(words, function (word) {
        return ignorarAcentos(word);
      });

      words = jQuery.grep(words, function (word) {
        return word !== "";
      });

      words = jQuery.map(words, function (word) {
        return word.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
      });

      if (words.length === 0) return this;

      var flag = settings.caseSensitive ? "" : "i";
      var pattern = "(" + words.join("|") + ")";
      if (settings.wordsOnly) {
        pattern = "\\b" + pattern + "\\b";
      }
      var re = new RegExp(pattern, flag);

      return this.each(function () {
        jQuery.highlight(this, re, settings.element, settings.className);
      });
    };
  }

  // deno-lint-ignore-file

  function stopEvent(e) {
    e.stopPropagation();
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      e.returnValue = false;
    }
  }

  function collapseAll(that) {
    var elements = that.divTree.find("i.mdi-minus").parent();
    jQuery__default["default"].each(elements, function (i, elm) {
      var children = jQuery__default["default"](elm).parent("div").parent("li.parent_li").find(
        " > ul > li",
      );
      children.hide();
      jQuery__default["default"](elm).attr("title", "Expandir").find(" > i").addClass("mdi-plus")
        .removeClass("mdi-minus");
    });
  }

  function expandSelecteds(that) {
    var elements = that.divTree.find("zjq-tree-highlight").parents("li").find(
      " > div > span > i.mdi-plus",
    ).parent();
    jQuery__default["default"].each(elements, function (i, elm) {
      var children = jQuery__default["default"](elm).parent("div").parent("li.parent_li").find(
        " > ul > li",
      );
      children.show();
      jQuery__default["default"](elm).attr("title", "Recolher").find(" > i").addClass("mdi-minus")
        .removeClass("mdi-plus");
    });

    that.divTree.find("> ul > li > ul li > div > span > i").not(".mdi-minus")
      .parent().parent().parent().hide();
    that.divTree.find("li > div zjq-tree-highlight").parent().parent().parent()
      .show();
  }

  function setSelectedById(that, id) {
    var li = that.divTree.find("[data-id='" + id + "']");
    if (!li.length) {
      return;
    }
    var elements = li.parents("li").find(" > div > span > i.mdi-plus").parent();
    jQuery__default["default"].each(elements, function (i, elm) {
      var children = jQuery__default["default"](elm).parent("div").parent("li.parent_li").find(
        " > ul > li",
      );
      children.show();
      jQuery__default["default"](elm).attr("title", "Recolher").find(" > i").addClass("mdi-minus")
        .removeClass("mdi-plus");
    });

    li.show();
    li.find("div").focus();
  }

  function setEvents(that) {
    that.divTree.on("keydown", function (e) {
      var activeElm = jQuery__default["default"](document.activeElement);
      switch (e.keyCode) {
        case 13: // enter
          stopEvent(e);
          that.trigger("enter", activeElm.parent().attr("data-id"));
          break;
        case 37: // L
          stopEvent(e);
          if (
            activeElm.find(" > span > i.mdi-plus")[0] ||
            activeElm.find(" > span > i.mdi-leaf")[0]
          ) {
            activeElm = activeElm.parent().parent().parent();
            if (activeElm.find(" > div").length) {
              activeElm.find(" > div").focus();
              break;
            }
            that.divTree.parent().find("input").focus();
            break;
          }
          activeElm.find(" > span").click();
          break;
        case 38: // U
          stopEvent(e);
          jQuery__default["default"].tabPrev();
          if (that.divTree.find(document.activeElement).length) {
            return;
          }
          that.divTree.find("div:visible").last().focus();
          break;
        case 39: // R
          stopEvent(e);
          if (activeElm.find(" > span > i").not(".mdi-minus")[0]) {
            activeElm.find(" > span").click();
          }
          break;
        case 40: // D
          stopEvent(e);
          jQuery__default["default"].tabNext();
          if (that.divTree.find(document.activeElement).length) {
            return;
          }
          that.divTree.find("div:visible").first().focus();
          break;
      }
    });

    var searchTimeout = null,
      searchVal;
    that.tree.find("input").on("keyup", function (e) {
      if (e.keyCode === 13) {
        stopEvent(e);
        that.divTree.find("div").first().focus();
      } else if (this.value === searchVal) {
        return;
      }
      searchVal = jQuery__default["default"](this).val();
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(function () {
        collapseAll(that);
        that.divTree.unhighlight({ element: "zjq-tree-highlight" });
        that.divTree.highlight(searchVal, { element: "zjq-tree-highlight" });
        expandSelecteds(that);
      }, 300);
    });

    that.tree.find("button.mdi-plus").on("click", function () {
      that.trigger("add", jQuery__default["default"](that.focused).parent().attr("data-id"));
    });
    that.tree.find("button.mdi-pencil-square-o").on("click", function () {
      that.trigger("edit", jQuery__default["default"](that.focused).parent().attr("data-id"));
    });
    that.tree.find("button.mdi-minus").on("click", function () {
      that.trigger("delete", jQuery__default["default"](that.focused).parent().attr("data-id"));
    });
  }

  function create(that) {
    jQuery__default["default"](
      '<table class="zjq-tree-control"><tr><td><div><span class="mdi mdi-magnify mdi-18px"></span><input type="text" ' +
        'placeholder="Pesquisar"></div></td>' +
        '<td><button class="mdi mdi-plus" tabindex="-1"></button></td>' +
        '<td><button class="mdi mdi-pencil-square-o" tabindex="-1"></button></td>' +
        '<td><button class="mdi mdi-minus" tabindex="-1"></button></td>' +
        "<td></td></tr></table>",
    ).appendTo(that.tree);
    setEvents(that);

    function montaColumns() {
      var html = "";
      that.options.columns.forEach(function (column) {
        html +=
          '<span style="display:inline-block;width:100px;text-align:center">' +
          (column.descricao || "") + "</span>";
      });
      return html;
    }
    that.tree.find(".zjq-tree-control td:last-child").append(montaColumns());

    if (that.options.noButtons) {
      that.tree.find(".zjq-tree-control button").css({ "visibility": "hidden" });
    }

    that.tree.css({
      "display": "flex",
      "flex-direction": "column",
    });
  }

  function load(that) {
    that.divTree.html("");

    function montaColumns(row) {
      var html = "";
      for (var i = that.options.columns.length - 1; i >= 0; i--) {
        var column = that.options.columns[i];
        html += '<em style="width:100px">' + (row[column.name] || "") + "</em>";
      }
      return html;
    }

    function setTree(elmPai, idPai) {
      var ul = null,
        li;
      jQuery__default["default"].each(that.data, function (i, row) {
        if (idPai === row.parent) {
          if (ul === null) {
            ul = jQuery__default["default"]("<ul>").appendTo(elmPai);
          }
          var columns = montaColumns(row);
          li = jQuery__default["default"](
            '<li data-id="' + row.id +
              '"><div tabindex="0"><span><i></i></span>&nbsp;<label title="' +
              row.descricao + '">' + row.descricao + "</label>" + columns +
              "</div></li>",
          ).appendTo(ul);
          var columnsWidth = that.options.columns.length * 100 + 50;
          li.find("label").css({ width: "calc(100% - " + columnsWidth + "px)" });
          that.trigger("insertRow", { "content": li, "rowData": row });
          setTree(li, row.id);
        }
      });
    }
    setTree(that.divTree, null);
    jQuery__default["default"](that.divTree).appendTo(that.tree);

    that.divTree.find("i").addClass("mdi");
    that.divTree.find(" > ul > li > ul li").hide();
    that.divTree.find("li:has(ul)").addClass("parent_li")
      .find(" > div > span").attr("title", "Expandir")
      .find(" > i ").addClass("mdi-plus");
    that.divTree.find("i").not(".mdi-plus").addClass("mdi-leaf");
    that.divTree.find("li.parent_li > div > span").on("click", function (e) {
      var children = jQuery__default["default"](this).parent("div").parent("li.parent_li").find(
        " > ul > li",
      );
      if (children.is(":visible")) {
        children.hide();
        jQuery__default["default"](this).attr("title", "Expandir").find(" > i").addClass("mdi-plus")
          .removeClass("mdi-minus");
      } else {
        children.show();
        jQuery__default["default"](this).attr("title", "Recolher").find(" > i").addClass("mdi-minus")
          .removeClass("mdi-plus");
      }
      e.stopPropagation();
    });

    // style da div selecionada
    that.divTree.find("div").on("focusin", function () {
      jQuery__default["default"](that.focused).removeClass("focused");
      if (that.focused !== this) {
        that.trigger("select", jQuery__default["default"](this).parent().attr("data-id"));
      }

      that.focused = this;
      jQuery__default["default"](this).addClass("focused");
    }).on("dblclick", function () {
      that.trigger("dblclick", jQuery__default["default"](this).parent().attr("data-id"));
    });
  }

  function tree(options) {
    this.tree = options.tree;
    this.divTree = jQuery__default["default"]('<div class="zjq-tree"></div>');
    this.data = [];
    this.focused = null;
    this.options = {
      columns: [],
      noButtons: false,
    };
    jQuery__default["default"].extend(this.options, options);
    create(this);
    load(this);

    this.reload = function (data) {
      this.focused = null;
      this.data = data;
      load(this);
    };

    this.setData = function (data) {
      this.reload(data);
    };

    this.trigger = function (type, data) {
      jQuery__default["default"](this).triggerHandler(type, data);
    };

    /*
     * enter, dblclick, select, add, edit, delete, close, open
     */
    this.on = function (type, data) {
      jQuery__default["default"](this).on(type, data);
      return this;
    };

    this.getIdSelected = function () {
      if (this.focused) {
        return this.focused.parentElement.dataset.id;
      }
      return null;
    };

    this.setSelectById = function (id) {
      setSelectedById(this, id);
    };

    if (this.options.data) {
      this.setData(this.options.data);
      this.options.data = null;
    }
  }

  function zjqTree (options) {
    return new tree(options);
  }

  function installJqueryPlugins (Yanda) {
    Yanda.zjqTree = zjqTree;
    Yanda.installJQueryPlugins = function () {
      jqAdapter(jQuery__default["default"], Yanda);
      selectinsert(jQuery__default["default"], Yanda);
      foreigninput(jQuery__default["default"], Yanda);
      onoff(jQuery__default["default"], "onoff");
      jqGridEdit(jQuery__default["default"]);
      highlight(jQuery__default["default"]);
    };
  }

  // deno-lint-ignore-file

  /**
   * Verifica se em está dentro de tabs do jquery.
   * Se estiver, todas devem ser ativadas.
   *
   * @param {element} elm
   * @returns {void}
   */
  function showTabs(elm) {
    // Verifica se o elmento está dentro de tabs do jquery
    // Se estiver todas devem ser ativadas
    let tab;
    let $ref = jQuery__default["default"](elm);
    let tabIndex;

    // eslint-disable-next-line no-constant-condition
    while (true) {
      tab = $ref.closest(".ui-tabs-panel");
      tabIndex = tab.index();

      if (tabIndex === -1) {
        break;
      }
      tab.parent().tabs("option", "active", tabIndex === -1 ? 0 : tabIndex - 1);
      $ref = tab.parent();
    }
  }

  /**
   * Options deve conter:
   * janela: Paramentros para abertura da janela
   * gridId: Id do grid
   * gridOptions: Opções de configuração do grid
   * params: Parametros extras passados para abertura da janela (Via ajax)
   * filters: Filtros de pesquisa inicial
   * idTelaNovo: Id da tela para inserção/alteração
   * urlExcluir: Endereço utilizado para exclusão do registro
   * refId: Nome da columa principal da tabela a ser gerenciada pela tela
   *
   * @param {type} options
   * @param {type} template
   * @returns {unresolved}
   */
  function telaDefaultConsulta(options, template = null) {
    const _hdl = Yanda.newJanela(options.janela);
    let gridType = "jqGrid";

    !options.gridId && (options.gridId = _hdl.uniqid);

    _hdl.setContent(
      template || `<div id="body">
      <fieldset>
        <table>
          <tr>
            <td style="text-align: right;">
              <label>Pesquisar&nbsp;por:</label>
            </td>
            <td>
              <select id="campo"></select>
            </td>
            <td>
              <select id="operador"></select>
            </td>
            <td>
              <input id="filter" style="width: 300px;">
            </td>
            <td>
              <img id="imgClear">
            </td>
            <td style="padding-left: 5px;">
              <input type="button" id="btnPesquisar" value="Pesquisar">
            </td>
          </tr>
        </table>
      </fieldset>
      <table id="{{uniqid}}"></table>
      <div id="{{uniqid}}Pager"></div>
    </div>
    <div id="footer">
      <button id="btnNovo">Novo</button>
      <button id="btnAlterar">Alterar</button>
      <button id="btnExcluir">Excluir</button>
      <button class="btn-primary" style="float: right; display: none;" id="btnSelecionar">Selecionar</button>
      <button id="btnFechar" style="text-align: center; float: right;">Fechar</button>
    </div>`,
    );
    _hdl.setTamanho(900, 532, { minWidth: 700, minHeight: 400 });
    _hdl.centraliza();

    _hdl.grid = jQuery__default["default"](`#${options.gridId}`);
    _hdl.rowNum = "auto";
    _hdl.filters = options.filters;
    _hdl.gridIdSelect = null;
    _hdl.gridIdsSelect = null;
    _hdl._parentIdSelect = null;

    _hdl.$filter = jQuery__default["default"](_hdl.$("filter"));

    _hdl.obj = JSON.parse(Storage.getItem(`_${_hdl.id}`));
    if (_hdl.obj) {
      const sortname = _hdl.obj.filters && _hdl.obj.filters.sortname
        ? _hdl.obj.filters.sortname
        : "";
      if (sortname) {
        let isCampo = false;
        options.gridOptions.colModel.forEach((m) =>
          (m.index === sortname) && (isCampo = true)
        );
        isCampo && (_hdl.filters = _hdl.obj.filters);
      }

      _hdl.rowNum = _hdl.obj.rowNum || _hdl.rowNum;
    }
    _hdl.$filter.val(_hdl.filters.valor);

    const params = (options.params || options.parms) || {};
    if (params) {
      (params.multiselect === true) && _hdl.filters.iCol++;
      if (params.adicional) {
        _hdl.filters.adicional =
          (_hdl.filters.adicional ? _hdl.filters.adicional + " and " : "") +
          params.adicional;
      }
    }

    _hdl.onSetPreferencias = function (pref, callback) {
      pref.dados && pref.dados.campo &&
        jQuery__default["default"](_hdl.$("campo")).val(pref.dados.campo).change();
      pref.dados && pref.dados.operador &&
        jQuery__default["default"](_hdl.$("operador")).val(pref.dados.operador).change();

      callback(pref);
    };

    _hdl.filterFocus = function (filter) {
      if (!Util.isMobile()) {
        !filter && (filter = _hdl.$filter);
        filter.focus();
        filter.select && filter.select();
      }
    };

    _hdl.onShow = _hdl.filterFocus;

    const close = _hdl.close.bind(_hdl);

    _hdl.close = function () {
      _hdl.filters.adicional = "";
      _hdl.filters.filter = "";
      close();
    };

    _hdl.onBeforeClose = function () {
      // Salvar dados do filters no Storage

      const obj = { filters: _hdl.filters, rowNum: _hdl.rowNum };

      // Se for multi select as colunas mudam de posição
      // devido a primeira coluna de multi seleção dos dados
      (params.multiselect === true) && _hdl.filters.iCol--;

      Storage.setItem(`_${_hdl.id}`, JSON.stringify(obj));
    };

    function resizeTela() {
      var body = _hdl.$("body"),
        fieldset = body.querySelector("fieldset"),
        footerHeight = (_hdl.$("footer") ? _hdl.$("footer").clientHeight : 0) +
          10,
        fieldsetWidth = fieldset ? fieldset.clientWidth : 0,
        fieldsetHeight = fieldset ? fieldset.clientHeight : 0,
        h = 78 + fieldsetHeight + footerHeight,
        w;

      !_hdl.$(`${options.gridId}Pager`) && (h -= 30);

      _hdl.grid.setGridWidth(0);
      _hdl.grid.setGridHeight(0);

      w = _hdl.content.clientWidth - 5;
      _hdl.grid.setGridWidth(w < fieldsetWidth ? fieldsetWidth : w);
      if (options.groupHeaders) {
        h += 25;
        _hdl.grid.destroyGroupHeader().setGroupHeaders(
          typeof options.groupHeaders === "function"
            ? options.groupHeaders()
            : options.groupHeaders,
        );
      }

      (w < fieldsetWidth) && (h += 10);
      options.gridOptions.footerrow && (h += 20);

      h = _hdl.content.clientHeight - h;
      (h < 130) && (h = 130);
      _hdl.grid.setGridHeight(h);
    }

    function setFilterEvents($elm, padrao) {
      $elm.on("change", () => _hdl.filter()).on("keyup", function (e) {
        // 38 seta p/ cima (seleciona o ultimo registro do grid)
        // 40 seta p/ baixo (seleciona o primeiro registro do grid)
        if (e.keyCode === 38 || e.keyCode === 40) {
          e.stopPropagation();
          e.preventDefault ? e.preventDefault() : (e.returnValue = false);

          if (_hdl.grid.getGridParam("records") > 0) {
            var rows = _hdl.grid.getDataIDs();
            _hdl.grid.setSelection(
              e.keyCode === 40 ? rows[0] : rows[rows.length - 1],
            );
            _hdl.grid.focus();
          }
          return;
        }

        if (this.value) {
          _hdl.filter();
          return;
        }

        // Se pressionado backspace ou delete refaz consulta
        (e.keyCode === 8 || e.keyCode === 46) && _hdl.filter(true);
      }).on("keypress", function (e) {
        (e.keyCode === 13) && _hdl.gridReload();
      }).attr("padrao", padrao);
    }

    _hdl.onResize = _hdl.resize = () => resizeTela();

    _hdl.getType = (tipo) => {
      if (!tipo) {
        return "string";
      }
      if (jQuery__default["default"].inArray(tipo, ["int", "integer"]) !== -1) {
        return "integer";
      }
      if (jQuery__default["default"].inArray(tipo, ["float", "number", "currency"]) !== -1) {
        return "numeric";
      }
      return tipo;
    };

    _hdl.filterMask = function (type) {
      if (jQuery__default["default"].inArray(type, ["integer", "numeric"]) === -1) {
        _hdl.$filter.inputmask("remove").css("text-align", "left");
        return;
      }

      (jQuery__default["default"].inArray(_hdl.filters.operador, ["in", "ni"]) !== -1)
        ? _hdl.$filter.inputmask("", { regex: "[.|-|,|0-9]+", placeholder: " " })
        : _hdl.$filter.inputmask(type);
    };

    _hdl.setOperadores = function (change) {
      var str = [],
        customFilter = false,
        operadoresOptions = {
          boolean: ["it", "if", "nu", "nn"],
          numeric: [
            "eq",
            "ne",
            "lt",
            "le",
            "gt",
            "ge",
            "nu",
            "nn",
            "in",
            "ni",
            "bt",
          ],
          integer: [
            "eq",
            "ne",
            "lt",
            "le",
            "gt",
            "ge",
            "nu",
            "nn",
            "in",
            "ni",
            "bt",
          ],
          string: [
            "eq",
            "ne",
            "bw",
            "bn",
            "ew",
            "en",
            "cn",
            "nc",
            "nu",
            "nn",
            "in",
            "ni",
          ],
          date: ["eq", "ne", "lt", "le", "gt", "ge", "nu", "nn", "bt"],
        },
        $option = jQuery__default["default"](_hdl.$("campo")).find("option:selected"),
        $operador = jQuery__default["default"](_hdl.$("operador")),
        type = _hdl.getType($option.data("type")),
        searchoptions = $option.data("searchoptions") || {},
        operadores = searchoptions.sopt
          ? searchoptions.sopt
          : operadoresOptions[type],
        getDescricao = function (operador) {
          if (operador == "bt") {
            return "entre";
          }
          jQuery__default["default"].each(
            jQuery__default["default"].jgrid.regional[jQuery__default["default"].jgrid.defaults.regional].search.odata,
            function () {
              if (operador == this.oper) {
                operador = this.text;
                return false;
              }
            },
          );
          return operador;
        };

      let $filter = jQuery__default["default"](_hdl.janela).find('[padrao="false"]');
      let $filterPadrao = jQuery__default["default"](_hdl.janela).find('[padrao="true"]');

      $filter.length && (_hdl.filters.value = "");
      $filter.remove();

      if (searchoptions.custom_element) {
        customFilter = true;
        $filterPadrao.hide();

        $filter = jQuery__default["default"]('<div padrao="false"></div>')
          .append(searchoptions.custom_element());

        $filterPadrao.parent().append($filter);
        _hdl.$filter = $filter.children();
        searchoptions.dataInit && searchoptions.dataInit($filter);
        setFilterEvents(_hdl.$filter, false);
        _hdl.$filter.val(_hdl.filters.valor).change();
      } else if (_hdl.filters.operador == "bt") {
        customFilter = true;
        $filterPadrao.hide();
        _hdl.$filter = $filterPadrao;

        $filter = jQuery__default["default"](
          `<div padrao="false">
            <input id="filterInicial${_hdl.uniqid}" name="filterInicial">
            &nbsp;<label>a</label>&nbsp;
            <input id="filterFinal${_hdl.uniqid}" name="filterFinal">
          </div>`,
        ).css("width", "300px");

        $filterPadrao.parent().append($filter);
        setFilterEvents($filter.find(`#filterInicial${_hdl.uniqid}`), false);
        setFilterEvents($filter.find(`#filterFinal${_hdl.uniqid}`), false);

        _hdl.$filter = $filter.find(`#filterInicial${_hdl.uniqid}`);

        if (type === "date") {
          $filter.find("input").css({ width: "100px", "text-align": "center" })
            .datepicker({
              onClose: function () {
                jQuery__default["default"](this).change();
              },
            });
        } else {
          $filter.find("input").css({ width: "135px", "text-align": "right" });
          (jQuery__default["default"].inArray(_hdl.filters.operador, ["in", "ni"]) !== -1)
            ? $filter.find("input").inputmask("", {
              regex: "[.|-|,|0-9]+",
              placeholder: " ",
            })
            : $filter.find("input").inputmask(type);
        }

        $filter.find(`#filterInicial${_hdl.uniqid}`).val(_hdl.filters.inicial);
        $filter.find(`#filterFinal${_hdl.uniqid}`).val(_hdl.filters.final)
          .change();
      } else if (type == "date") {
        customFilter = true;
        $filterPadrao.hide();
        $filter = jQuery__default["default"](
          `<div padrao="false"><input id="filterDate${_hdl.uniqid}" name="filterDate"></div>`,
        );
        $filterPadrao.parent().append($filter);

        _hdl.$filter = $filter.children();

        _hdl.$filter.css({ width: "100px", "text-align": "center" }).datepicker({
          onClose: function () {
            jQuery__default["default"](this).change();
          },
        });

        setFilterEvents(_hdl.$filter, false);
        _hdl.$filter.val(_hdl.filters.valor).change();
      } else {
        $filterPadrao.show().attr("id", "filter");
        _hdl.$filter = $filterPadrao;
      }

      _hdl.filters.valor = _hdl.$filter.val();
      if (!$operador.length) {
        return;
      }

      jQuery__default["default"].each(operadores, function () {
        str.push(`<option value='${this}'>${getDescricao(this)}</option>`);
      });
      $operador.find("option").remove();

      if (type === "boolean") {
        $operador.append(`<option/>${str.join("")}`);
        _hdl.filters.operador && $operador.val(_hdl.filters.operador);
        $filterPadrao.val("").change().hide();
        return;
      }

      (type === "integer") &&
        $filterPadrao.val(_hdl.filters.valor.replace(/\D/g, "")).change();

      $operador.append(str.join(""));

      let operador =
        $operador.find(`option[value="${_hdl.filters.operador}"]`).length;
      if (change === true || !_hdl.filters.operador || !operador) {
        _hdl.filters.operador =
          (jQuery__default["default"].inArray(type, ["date", "integer", "numeric"]) !== -1)
            ? "eq"
            : "cn";
        operador =
          $operador.find(`option[value="${_hdl.filters.operador}"]`).length;
      }
      operador
        ? $operador.val(_hdl.filters.operador)
        : $operador.val($operador.find("option:first").prop("value"));

      !customFilter && _hdl.filterMask(type);
    };

    _hdl.gridSelectRow = function () {
      let id,
        ids = _hdl.grid.getDataIDs(),
        setSelect = (idSelect) => {
          for (id of ids) {
            if (
              _hdl.grid.getCell(id, options.refId).toString() ===
                idSelect.toString()
            ) {
              _hdl.grid.setSelection(id, false);
              return;
            }
          }
        };

      if (_hdl.gridIdsSelect && _hdl.gridIdsSelect.length) {
        _hdl.grid.resetSelection();
        _hdl.gridIdsSelect.forEach((idSelect) => setSelect(idSelect));
        return;
      }
      _hdl.gridIdSelect && setSelect(_hdl.gridIdSelect);
    };

    _hdl.onSelectClick = () => {
      let id;
      const resp = [];

      (gridType === "jqGridEdit") && _hdl.grid[gridType]("save");

      if (params && params.multiselect === true) {
        _hdl.grid.getGridParam("selarrrow").map((id) =>
          resp.push(_hdl.grid.getRowData(id))
        );
      } else {
        id = _hdl.grid.getGridParam("selrow");
        id && resp.push(_hdl.grid.getRowData(id));
      }
      _hdl.onValueSelect && _hdl.onValueSelect(resp);
      _hdl.acptDisableAll = false;
      _hdl.close();
    };

    _hdl.getIdSelected = function (soUm) {
      const ids = _hdl.grid.getGridParam("selarrrow");
      let selRowId = _hdl.grid.getGridParam("selrow");

      soUm = soUm === undefined ? true : soUm;
      _hdl.gridIdSelect = null;

      if (params.multiselect === true) {
        selRowId = null;
        if (ids.length > 1) {
          if (soUm) {
            Notify.warning("Selecione apenas um registro");
            return false;
          }
          _hdl.gridIdsSelect = [];
          ids.map((id) =>
            _hdl.gridIdsSelect.push(_hdl.grid.getCell(id, options.refId))
          );
          return false;
        }
        if (ids[0]) {
          selRowId = ids[0];
          _hdl.gridIdSelect = _hdl.grid.getCell(selRowId, options.refId);
          _hdl.gridIdsSelect = [_hdl.gridIdSelect];
          return _hdl.gridIdSelect;
        }
        _hdl.gridIdsSelect = null;
      }

      if (selRowId) {
        _hdl.gridIdSelect = _hdl.grid.getCell(selRowId, options.refId);
        return _hdl.gridIdSelect;
      }

      if (soUm) {
        Notify.warning("Selecione um registro");
        return false;
      }
    };

    _hdl.gridData = function (postData) {
      const add = (str) => {
        _hdl.filters.adicional =
          (_hdl.filters.adicional ? _hdl.filters.adicional + " and " : "") + str;
      };

      _hdl.filters.filter && add(_hdl.filters.filter);
      params.adicional && add(params.adicional);

      postData.filtros = {
        campo: _hdl.filters.campo,
        valor: _hdl.filters.valor.trim(),
        final: (_hdl.filters.final || "").trim(),
        inicial: (_hdl.filters.inicial || "").trim(),
        operador: _hdl.filters.operador,
        adicional: _hdl.filters.adicional,
      };

      params.postData && jQuery__default["default"].extend(postData, params.postData);
      _hdl.filters.adicional = "";

      return postData;
    };

    _hdl.gridConfirm = function (rowid) {
      function click() {
        if (!_hdl.parent || !_hdl.$("btnSelecionar")) {
          _hdl.$("btnAlterar") && _hdl.$("btnAlterar").click();
          return;
        }
        _hdl.$("btnSelecionar").click();
      }

      if (!params && !_hdl.parent) {
        click();
        return;
      }

      if (params && params.multiselect === true) {
        _hdl.grid.jqGrid("resetSelection");
        _hdl.grid.setSelection(rowid, false);
        _hdl.getIdSelected(false);
        click();
        return;
      }

      click();
    };

    _hdl.telaNovo = (id) => Yanda.newApl(options.idTelaNovo, id, _hdl);

    _hdl.excluir = function (id) {
      Yanda.confirm({
        msg: "Tens certeza que desejas excluir o registro selecionado?",
        actionTrue: function () {
          _hdl.ajax(
            true,
            options.urlExcluir,
            `${options.refId}=${id}&hdl=_${_hdl.id}`,
            (xhr) => {
              if (
                /text\/javascript/.test(xhr.getResponseHeader("content-type"))
              ) {
                return Function(xhr.responseText)();
              }

              const obj = JSON.parse(xhr.responseText);
              if (obj.detail || obj.exception) {
                Yanda.message(obj);
                return;
              }

              Notify[obj.type](obj.msg);
              (obj.type === "success") && _hdl.gridReload();
            },
          );
        },
      });
    };

    _hdl.gridReload = function () {
      if (arguments[0]) {
        _hdl.gridIdSelect = arguments[0];
        _hdl.parent && (_hdl._parentIdSelect = true);
      }
      _hdl.grid.trigger("reloadGrid");
    };

    // Recupera index da coluna do grid a partir do nome
    _hdl.getColumnSrcIndexByName = function (grid, columnName) {
      var index = 0,
        cmName,
        cm = grid.getGridParam("colModel"),
        l = cm.length,
        i = 0;

      while (i < l) {
        cmName = cm[i].name;
        i++;
        if (cmName === columnName) {
          return index;
        }
        (cmName !== "rn" && cmName !== "subgrid") && index++;
      }
      return -1;
    };

    _hdl.filter = function () {
      if (arguments[0] === true) {
        _hdl.$filter.val("");
        _hdl.filterFocus();
      }

      _hdl.filters.valor = _hdl.$filter.val();
      _hdl.filters.campo = _hdl.$("campo").value;
      jQuery__default["default"](`#filterFinal${_hdl.uniqid}`) &&
        (_hdl.filters.final = jQuery__default["default"](`#filterFinal${_hdl.uniqid}`).val());
      jQuery__default["default"](`#filterInicial${_hdl.uniqid}`) &&
        (_hdl.filters.inicial = jQuery__default["default"](`#filterInicial${_hdl.uniqid}`).val());
    };

    if (options.editable === true) {
      gridType = "jqGridEdit";
      options.gridOptions.pginput = true;
      options.gridOptions.pgbuttons = true;
    }

    _hdl.grid[gridType](jQuery__default["default"].extend({
      mtype: "POST",
      pager: `${options.gridId}Pager`,
      sortname: _hdl.filters.sortname,
      datatype: "local",
      autowidth: true,
      sortorder: _hdl.filters.sortorder,
      multiselect: (params.multiselect === true),
      viewrecords: true,
      rowNum: _hdl.rowNum,
      rowList: ["auto", 10, 15, 20, 30, 40, 50, 100],
      onSortCol(index, iCol) {
        _hdl.filters.iCol = iCol;
        _hdl.filters.index = index;
        _hdl.filters.sortname = _hdl.grid.getGridParam("sortname");
        _hdl.filters.sortorder = _hdl.grid.getGridParam("sortorder");
        _hdl.filter();
      },
      ondblClickRow(rowid) {
        _hdl.gridConfirm(rowid);
      },
      onSelectRow() {
        _hdl.getIdSelected(false);
      },
      onSelectAll() {
        _hdl.getIdSelected(false);
      },
      loadBeforeSend() {
        _hdl.$filter.prop("readonly", true);
      },
      loadError() {
        _hdl.$filter.prop("readonly", false);
      },
      loadComplete(data) {
        if (data && data.type && data.type !== "success") {
          (data.detail || data.exception)
            ? Yanda.message(data)
            : Notify[data.type](data.msg);
        }

        options.groupHeaders && _hdl.grid.destroyGroupHeader().setGroupHeaders(
          typeof options.groupHeaders === "function"
            ? options.groupHeaders()
            : options.groupHeaders,
        );

        _hdl.$filter.prop("readonly", false);

        _hdl.rowNum = parseInt(_hdl.grid.getGridParam("rowNum"));
        (jQuery__default["default"](_hdl.janela).find(".ui-pg-selbox").find("option:selected")
          .text() === "auto") && (_hdl.rowNum = "auto");

        (_hdl === Yanda.ctr.janelaDes) && _hdl.filterFocus();
        _hdl.gridSelectRow();
        _hdl.getIdSelected(false);

        if (_hdl.imprimir === true) {
          _hdl.imprimeDadosGrid();
          _hdl.imprimir = false;
        } else if (_hdl[`_select${_hdl.uniqid}`]) {
          const ids = _hdl.grid.getDataIDs();
          const id = ids.length ? ids[_hdl[`_select${_hdl.uniqid}`]]() : null;
          _hdl.grid.focus();
          id && _hdl.grid.setSelection(id, true);
          _hdl[`_select${_hdl.uniqid}`] = null;
        }

        _hdl.gridLoadComplete && _hdl.gridLoadComplete(data);

        _hdl._parentIdSelect && _hdl.gridIdSelect &&
          jQuery__default["default"](_hdl.$("btnSelecionar")).click();
        _hdl._parentIdSelect = null;
      },
      serializeGridData(postData) {
        const $uiPgSelbox = jQuery__default["default"](_hdl.janela).find(".ui-pg-selbox").find(
          "option:selected",
        );

        if (_hdl.imprimir === true && $uiPgSelbox.text() === "auto") {
          postData.rows = 1000;
          _hdl.rowNum = 1000;
          this.p.rowNum = 1000;
          postData.page = 1;
          this.p.page = postData.page;

          return _hdl.gridData(postData);
        }

        if ($uiPgSelbox.text() === "auto") {
          const $div = jQuery__default["default"](_hdl.janela).find(".ui-jqgrid-bdiv");
          const scroll =
            jQuery__default["default"](_hdl.janela).find(".ui-jqgrid-labels").width() > $div.width()
              ? 10
              : 0;
          postData.rows = parseInt(($div.height() - scroll) / 24);
          this.p.rowNum = postData.rows;
        }

        if (isNaN(postData.page)) {
          postData.page = 1;
          this.p.page = postData.page;
        }

        const data = _hdl.gridData(postData);
        if (_hdl._parentIdSelect && _hdl.gridIdSelect && data.filtros) {
          data.filtros.adicional = "";
          data.filtros.campo = `e.${options.refId}`;
          data.filtros.operador = "eq";
          data.filtros.valor = _hdl.gridIdSelect;
        }

        return data;
      },
    }, options.gridOptions)).navGrid(
      `#${options.gridId}Pager`,
      { edit: false, add: false, del: false, refresh: false },
      {},
      {},
      {},
      {
        multipleSearch: true,
        multipleGroup: true,
        onReset: function () {
          _hdl.filters.filter = "";
        },
        onSearch: function () {
          const filter = jQuery__default["default"](`#${jQuery__default["default"].jgrid.jqID(`fbox_${this.id}`)}`);
          const dados = filter.jqFilter("filterData");
          const opFilter = ["nn", "nu"];
          dados.rules.forEach((rule) => {
            const colRule = colModels.find((cols) => cols.index === rule.field);
            if (!colRule || (colRule.sorttype === "string")) {
              return;
            }
            !rule.data && !opFilter.includes(rule.op) && (rule.op = "nn");
          });

          _hdl.filters.filter = filter.jqFilter("toSQLString").replace(
            new RegExp('"', "g"),
            "'",
          )
            .replace("ISNOT NULL", "IS NOT NULL");
          _hdl.gridReload();
        },
        closeOnEscape: true,
      },
    ).jqGrid("bindKeys");

    _hdl.grid.jqGrid("navButtonAdd", `#${options.gridId}Pager`, {
      onClickButton: function () {
        const $uiPgSelbox = jQuery__default["default"](_hdl.janela).find(".ui-pg-selbox").find(
            "option:selected",
          ),
          rowNum = _hdl.grid.getGridParam("rowNum"),
          allRecords = _hdl.grid.getGridParam("records"),
          totalPages = parseInt((allRecords / rowNum) + 1);

        if ($uiPgSelbox.text() != "auto" || totalPages === 1) {
          _hdl.imprimeDadosGrid();
          return;
        }

        _hdl.imprimir = true;
        _hdl.gridReload();
      },
      buttonicon: "ui-icon ui-icon-print",
      position: "last",
      caption: "",
      cursor: "pointer",
      title: "Imprimir",
    });

    _hdl.imprimeDadosGrid = function () {
      const $elm = jQuery__default["default"](_hdl.$(`gview_${options.gridId}`)).clone();
      $elm.find(".ui-jqgrid-sdiv").remove();

      $elm.find("td").css({
        "border-bottom": "solid 1px",
        "border-left": "solid 1px",
      });
      $elm.find("tr > td:last-child").css("border-right", "solid 1px");

      const title = _hdl.options.title.replace(/<[^>]*>?/gm, "");
      $elm.printThis({
        debug: false, //show the iframe for debugging
        importCSS: false, //import page CSS
        pageTitle: title, //add title to print page
        printDelay: 333, //variable print delay S. Vance
        removeInline: false, //remove all inline styles from print elements
        printContainer: false, //grab outer container as well as the contents of the selector
        header:
          `<table style='border: solid 1px; border-spacing: 0px; width: 100%; border-radius:4px'>
                <tr><td style='text-align: center;'><b>${title}</b></td></tr>
            </table>`, //prefix to html
      });
    };

    // Feito evento do enter separado proque no bindKeys e jqGridKeyEnter não é possivel recuperar o evento para para-lo
    _hdl.grid.on("keydown", function (e) {
      if (![13, 37, 38, 39, 40].includes(e.keyCode)) {
        return;
      }

      e.stopPropagation();
      e.preventDefault ? e.preventDefault() : (e.returnValue = false);

      if (e.keyCode === 13) {
        const rowid = _hdl.grid.getGridParam("selrow");
        rowid && _hdl.gridConfirm();
        return;
      }

      if (e.keyCode === 37) { // <
        _hdl[`_select${_hdl.uniqid}`] = "pop";
        jQuery__default["default"](`#${options.gridId}Pager`).find(".ui-icon-seek-prev").parent()
          .click();
        return;
      }

      if (e.keyCode === 39) { // >
        _hdl[`_select${_hdl.uniqid}`] = "shift";
        jQuery__default["default"](`#${options.gridId}Pager`).find(".ui-icon-seek-next").parent()
          .click();
        return;
      }
    });

    _hdl.$("btnNovo") && jQuery__default["default"](_hdl.$("btnNovo"))
      .on("click", () => _hdl.telaNovo(null))
      .html(
        `<i class="mdi mdi-sticker-plus-outline mdi-18px">${
        _hdl.$("btnNovo").innerHTML
      }</i>`,
      );

    _hdl.$("btnAlterar") && jQuery__default["default"](_hdl.$("btnAlterar")).on("click", function () {
      const id = _hdl.getIdSelected(true);
      id && _hdl.telaNovo(id);
    }).html(
      `<i class="mdi mdi-square-edit-outline mdi-18px">${
      _hdl.$("btnAlterar").innerHTML
    }</i>`,
    );

    _hdl.$("btnExcluir") && jQuery__default["default"](_hdl.$("btnExcluir")).on("click", function () {
      const id = _hdl.getIdSelected(true);
      id && _hdl.excluir(id);
    }).html(
      `<i class="mdi mdi-trash-can-outline mdi-18px">${
      _hdl.$("btnExcluir").innerHTML
    }</i>`,
    );

    _hdl.$("btnFechar") &&
      jQuery__default["default"](_hdl.$("btnFechar")).on("click", () => _hdl.close());

    jQuery__default["default"](_hdl.$("imgClear")).on("click", () => _hdl.filter(true))
      .prop("src", Yanda.src + "img/clear-left.png")
      .css({ top: "2px", cursor: "pointer", position: "relative" });

    jQuery__default["default"](_hdl.$("btnPesquisar")).on("click", () => _hdl.gridReload());

    jQuery__default["default"](_hdl.$("campo")).on("change", function () {
      _hdl.filters.campo = this.value;
      _hdl.filters.operador = null;
      _hdl.setOperadores(true);
    });

    jQuery__default["default"](_hdl.$("operador")).on("change", function () {
      _hdl.filters.operador = this.value;
      _hdl.setOperadores();
    });

    setFilterEvents(_hdl.$filter, true);

    if (_hdl.parent && _hdl.$("btnSelecionar")) {
      _hdl.$("btnFechar").innerHTML = "Cancelar";
      const icon = params && params.multiselect === true
        ? "box-multiple-outline"
        : "box-outline";
      jQuery__default["default"](_hdl.$("btnSelecionar"))
        .on("click", () => _hdl.onSelectClick())
        .html(
          `<i class="mdi mdi-check-${icon} mdi-18px">${
          _hdl.$("btnSelecionar").innerHTML
        }</i>`,
        )
        .show();
    }

    // Feito posteriormente para evitar primeiro reload
    _hdl.grid.setGridParam({ datatype: "json" });
    if (options.groupHeaders) {
      _hdl.grid.setGroupHeaders(
        typeof options.groupHeaders === "function"
          ? options.groupHeaders()
          : options.groupHeaders,
      );
    }

    // Setar colunas a consultar
    const colModels = _hdl.grid.getGridParam("colModel");
    const groupHeaders = options.groupHeaders
      ? _hdl.grid.getGridParam("groupHeader")[0].groupHeaders
      : [];
    jQuery__default["default"].each(colModels, function (i, colModel) {
      if (
        !colModel.sorttype &&
        (colModel.hidden === true || colModel.sortable === false)
      ) {
        return;
      }

      let campoFilter = colModel.index,
        descricaoFilter = _hdl.grid.getGridParam("colNames")[i],
        $option;
      if (colModel.label) {
        descricaoFilter = colModel.label;
      } else if (options.groupHeaders) { // Busca descricao do group header
        let posCol;
        for (var j in groupHeaders) {
          posCol = _hdl.getColumnSrcIndexByName(
            _hdl.grid,
            groupHeaders[j].startColumnName,
          );
          if (i >= posCol && i < (posCol + groupHeaders[j].numberOfColumns)) {
            descricaoFilter += " " + groupHeaders[j].titleText;
            break;
          }
        }
      }
      $option = jQuery__default["default"](
        new Option(descricaoFilter.replace(/(<([^><]+)>)/ig, ""), campoFilter),
      );
      $option.data("type", colModel.sorttype || colModel.searchtype);
      colModel.searchoptions &&
        $option.data("searchoptions", colModel.searchoptions);
      jQuery__default["default"](_hdl.$("campo")).append($option);
    });

    if (_hdl.filters) {
      _hdl.$("campo").value = _hdl.filters.campo ? _hdl.filters.campo : "";
      _hdl.filters.operador &&
        jQuery__default["default"](_hdl.$("operador")).val(_hdl.filters.operador);
      jQuery__default["default"](`#filterFinal${_hdl.uniqid}`).val(
        _hdl.filters.final ? _hdl.filters.final : "",
      );
      jQuery__default["default"](`#filterInicial${_hdl.uniqid}`).val(
        _hdl.filters.inicial ? _hdl.filters.inicial : "",
      );
    }

    jQuery__default["default"](_hdl.$("operador")).css("width", "150px");
    _hdl.setOperadores(false);

    resizeTela();
    return _hdl;
  }

  /**
   * Options deve conter:
   * janela: Paramentros para abertura da janela
   *
   * @param {type} options
   * @param {type} template
   * @returns {unresolved}
   */
  function telaDefaultCadastro(options, template) {
    const _hdl = Yanda.newJanela(options.janela);
    _hdl.setTamanho(800, 500);
    _hdl.centraliza();
    _hdl.setContent(template);
    _hdl.refId = null;
    _hdl.form = _hdl.$("form");

    _hdl.onBeforeClose = function () {
      Storage.setItem(
        `_${_hdl.id}`,
        JSON.stringify({ pinoCad: jQuery__default["default"](_hdl.$("pinoCad")).attr("class") }),
      );
      _hdl.parent?.filterFocus?.();
    };

    _hdl.onResize = _hdl.resize = function () {
      const footerHeight = _hdl.$("footer") ? _hdl.$("footer").clientHeight : 0;
      jQuery__default["default"](_hdl.$("tabs")).css(
        "minHeight",
        (_hdl.content.clientHeight - footerHeight - 9) + "px",
      );
    };

    jQuery__default["default"](_hdl.$("btnCancelar")).on("click", () => _hdl.close());

    jQuery__default["default"](_hdl.$("pinoCad"))
      .on("click", function () {
        if (this.className === "pino") {
          this.className += " pino-click";
          this.title = "Clique aqui para fechar a janela após salvar";
          return;
        }
        this.className = "pino";
        this.title = "Clique aqui para continuar adicionando após salvar";
      })
      .click();

    _hdl.$("btnPersistir") && jQuery__default["default"](_hdl.$("btnPersistir"))
      .on("click", () => showTabs(_hdl.$("form").querySelector(":invalid")))
      .html(
        `<i class="mdi mdi-content-save-outline mdi-18px">${
        _hdl.$("btnPersistir").innerHTML
      }</i>`,
      );

    try {
      _hdl.obj = JSON.parse(Storage.getItem(`_${_hdl.id}`));
      (_hdl.obj.pinoCad !== "pino") &&
        jQuery__default["default"](_hdl.$("pinoCad")).attr("class", "pino");
    } catch (e) {}

    _hdl.resize();
    return _hdl;
  }

  function getMaisNova(janelaRef) {
    while (janelaRef.ajanChild[0]) {
      janelaRef = janelaRef.ajanChild[0];
    }
    return janelaRef;
  }

  /**
   * Controla o evento de redimensionamento da janela.
   */
  function ajanResize(o) {
    if (!o.resizeSta) {
      return;
    }
    o.setUnselectable(true);

    // Pega posicao da janela
    const pL = parseInt(o.janela.style.left);
    const pT = parseInt(o.janela.style.top);

    Yanda.ctr.janCtrResize = true;
    Yanda.ctr.divResize.style.left = pL + "px";
    Yanda.ctr.divResize.style.top = pT + "px";
    Yanda.ctr.divResize.style.width = o.janela.style.width;
    Yanda.ctr.divResize.style.height = o.janela.style.height;
    Yanda.ctr.divResize.style.zIndex = Yanda.ctr.contZindex + 1;
    Yanda.ctr.divResize.style.display = "block";

    // Finaliza o evento
    document.onmouseup = function () {
      if (Yanda.ctr.janCtrResize) {
        Yanda.ctr.divResize.style.display = "none";
        Yanda.ctr.janCtrResize = false;
        o.setUnselectable(false);
        o.setTamanho(
          parseInt(Yanda.ctr.divResize.style.width),
          parseInt(Yanda.ctr.divResize.style.height),
        );
        Util.setScroll();
        o.onResize && o.onResize();
      }
    };

    // Altera o tamanho do div resize conforme o movimento do mouse
    document.onmousemove = function (e) {
      if (!Yanda.ctr.janCtrResize) {
        return;
      }
      const evt = e || event,
        Y = (window.scrollY + evt.clientY) - pT,
        X = evt.clientX - pL;

      (Y > o.janela.janResizeAltMin) &&
        (Yanda.ctr.divResize.style.height = Y + "px");
      (X > o.janela.janResizeLarMin) &&
        (Yanda.ctr.divResize.style.width = X + "px");
    };
  }

  /**
   * Põe a janela em foco ao receber um clique.
   */
  function ajanOnMouseDown() {
    const ref = Yanda.jansPid[this.id];
    if (ref && !ref.disabled && Yanda.ctr.janelaDes != ref) {
      ref.setFocus();
    }
  }

  /**
   * Clique na barra de titulo.
   */
  function ajanTitOnMouseDown(e) {
    if (this.disabled) {
      return;
    }

    this.setUnselectable(true);

    // deno-lint-ignore no-this-alias
    const janela = this;

    const evt = e || event;
    janela.Tx = parseInt(janela.janela.style.left);
    janela.Ty = parseInt(janela.janela.style.top);
    janela.X = evt.clientX;
    janela.Y = evt.clientY;

    Yanda.ctr.janCtrMove = true;
    Yanda.ctr.divResize.style.left = janela.Tx + "px";
    Yanda.ctr.divResize.style.top = janela.Ty + "px";
    Yanda.ctr.divResize.style.width = janela.janela.style.width;
    Yanda.ctr.divResize.style.height = janela.janela.style.height;
    Yanda.ctr.divResize.style.zIndex = Yanda.ctr.contZindex + 1;

    window.onmousemove = function (e) {
      if (Yanda.ctr.janCtrMove && !janela.isMax) {
        const evt = e || event;
        let y = janela.Ty + evt.clientY - janela.Y;
        const x = janela.Tx + evt.clientX - janela.X;

        if (!janela.disabled) {
          janela.setDisable(true);
          Yanda.ctr.divResize.style.display = "block";
        }
        Yanda.ctr.divResize.style.left = x + "px";
        if (y < Yanda.ctr.janPosTopMax) {
          y = Yanda.ctr.janPosTopMax;
        }
        Yanda.ctr.divResize.style.top = y + "px";
        return false;
      }
    };
    window.onmouseup = function () {
      window.onmousemove = null;
      window.onmouseup = null;

      const t = Yanda.ctr.janCtrMove,
        x = parseInt(Yanda.ctr.divResize.style.left),
        y = parseInt(Yanda.ctr.divResize.style.top);

      Yanda.ctr.janCtrMove = false;
      Yanda.ctr.divResize.style.display = "none";

      if (!janela.disabled) {
        return false;
      }
      janela.setDisable(false);
      janela.setPosicao(x, y, true);

      if (!t) {
        return false;
      }
      janela.setUnselectable(false);
      if (janela.onMove) {
        janela.onMove();
      }
    };
  }

  /**
   * Duplo clique sobre a barra de titulo.
   */
  function ajanTitOnBdlClick() {
    if (this.disabled) {
      return;
    }
    this.options.btMa && this.maximize();
  }

  /**
   * Clique sobre o objeto de resize.
   */
  function ajanRszOnMouseDown() {
    const ref = Yanda.jansPid[this.id];
    if (ref.disabled || ref.isMax) {
      return;
    }
    ajanResize(ref);
  }

  /**
   * Eventos sobre a barra de tarefas.
   */
  function ajanBrOnMouseMove() {
    const o = Yanda.jansPid[this.id];
    if (o.ajanChild[0]) {
      if (Yanda.ctr.janelaDes != o && Yanda.ctr.janelaDes != getMaisNova(o)) {
        this.className = "ajan-brt-jan-des";
      }
    } else if (Yanda.ctr.janelaDes != o) {
      this.className = "ajan-brt-jan-des";
    }
  }

  function ajanBrOnMouseOut() {
    const o = Yanda.jansPid[this.id];
    if (o.ajanChild[0]) {
      if (Yanda.ctr.janelaDes != o && Yanda.ctr.janelaDes != getMaisNova(o)) {
        this.className = "ajan-brt-jan-norm";
      }
    } else if (Yanda.ctr.janelaDes != o) {
      this.className = "ajan-brt-jan-norm";
    }
  }

  function ajanBrOnClick() {
    const o = Yanda.jansPid[this.id];
    if (Yanda.ctr.janelaDes && Yanda.ctr.janelaDes != o) {
      if (Yanda.ctr.janelaDes.barra) {
        Yanda.ctr.janelaDes.className = "ajan-brt-jan-norm";
      }
    }

    // Recupera a janela com foco
    // No caso de janela com filhas deve ser recuperado a mais nova
    const janelaRef = getMaisNova(o);
    if (janelaRef === Yanda.ctr.janelaDes) {
      o.minimiza();
    } else {
      o.show();
    }
  }

  /**
   * Clique sobre os botoes da janela.
   */
  function ajanBtOnClick(e) {
    const o = Yanda.jansPid[this.id];
    if (o.disabled) return;
    switch (this.tpo) {
      case "fe":
        o.close(e);
        break;
      case "mi":
        o.minimiza(e);
        break;
      case "ma":
        o.maximize(e);
        break;
      case "pr":
        o.campoPadrao(e);
        break;
      case "he":
        Yanda.help.openUrl(this.help);
        break;
    }
  }

  // deno-lint-ignore-file

  const jansPid = [];

  /*
   EVENTOS DA JANELA

   onMove - quando a janela e movimentada
   onResize - quando a janela e redimencionada
   onMinimize - quando a janela e minimizada
   onMaximize - quando a janela e maximinizada
   onBeforeClose - antes da janela ser fechada
   onClose - depois da janela ser fechada
   onAfterClose - antes da janela ser fechada
   onShow - quando a janela é exibida
   onCreate - quando a janela eh criada
   onFocus - quando a janela entra em foco
   onBlur - quando a jenal entra em blur
   onDisable - quando a janela é desabilitada
   onEnable - quando a jnela é habilitada
   onHide - qdo a janela e escondida
   */

  /**
   * Retorna a janela com maior zIndex antes da janela destacada.
   * Utilizada nos eventos de minimização e fechamento de janelas onde
   * a próxima janela deve ficar em foco.
   */
  function maxZindex() {
    let res = false, max = 1, j = 1, len = jansPid.length;
    for (; j < len; j++) {
      const ref = jansPid[j];
      if (
        ref && parseInt(ref.janela.style.zIndex) > max && ref.estatus === "NO"
      ) {
        max = parseInt(ref.janela.style.zIndex);
        res = ref;
      }
    }
    return res;
  }

  /**
   * Maximiza ou normaliza a janela.
   */
  function ajanMaNo(o) {
    if (o.isMax) {
      o.isMax = false;
      o.setTamanho(o.janLar, o.janAlt);
      o.setPosicao(o.janPosLeft, o.janPosTop, true);
      Util.centralizaScroll(o);
      return;
    }

    // Salva os antigos valores da janela
    o.janPosLeft = parseInt(o.janela.style.left);
    o.janPosTop = parseInt(o.janela.style.top);
    o.janLar = parseInt(o.janela.style.width);
    o.janAlt = parseInt(o.janela.style.height);
    o.isMax = true;
    o.setTamanho(Yanda.ctr.janMaLar, Yanda.ctr.janMaAlt);
    o.setPosicao(Yanda.ctr.janMaPosLeft, Yanda.ctr.janMaPosTop);
    Util.centralizaScroll(o);
  }

  /**
   * Muda as classe da janela quando fica em foco ou em blur.
   */
  function focusOrBlur(o, c) {
    var linha,
      method = c ? "add" : "remove",
      tit = o.janela.firstChild.firstChild;

    // Primeira linha
    linha = tit.firstChild.getElementsByTagName("TD");
    linha[0].classList[method]("ajan-tit-canto-esq-focus");
    linha[1].classList[method]("ajan-tit-sup-focus");
    linha[2].classList[method]("ajan-tit-canto-dir-focus");

    // Segunda linha
    linha = tit.getElementsByTagName("TR")[1].getElementsByTagName("TD");
    linha[0].classList[method]("ajan-tit-esq-focus");
    linha[1].classList[method]("ajan-tit-focus");
    linha[linha.length - 1].classList[method]("ajan-tit-dir-focus");

    function toggle(toFind, toToggle) {
      var elms = o.janela.querySelectorAll(toFind);
      if (!elms.length) {
        return;
      }
      for (var elm of elms) {
        elm.classList[method](toToggle);
      }
    }

    toggle(".ajan-help", "ajan-help-focus");
    toggle(".ajan-title", "ajan-title-focus");
    toggle(".ajan-help-rtl", "ajan-help-rtl-focus");
    o.options.btFe && toggle(".ajan-title-bt-fe", "ajan-title-bt-fe-focus");
    o.options.btMa && toggle(".ajan-title-bt-max", "ajan-title-bt-max-focus");
    o.options.btMi && toggle(".ajan-title-bt-min", "ajan-title-bt-min-focus");
    o.options.btPr && toggle(".ajan-title-bt-pr", "ajan-title-bt-pr-focus");
    o.options.help && toggle(".ajan-title-bt-help", "ajan-title-bt-help-focus");
  }

  /**
   * Controla o blur da janela.
   */
  function ajanBlur(o) {
    o.estatus = "NO";
    o.barra && (o.barra.className = "ajan-brt-jan-norm");
    focusOrBlur(o, false);
    o.setUnselectable(true);
  }

  /**
   * Evento focus da janela.
   */
  function ajanFocus(o) {
    o.estatus = "FO";
    if (Yanda.ctr.janelaDes) {
      Yanda.ctr.janelaDes.setBlur();
    } else if (getTotJans() === 1) {
      const dda = document.querySelector("#yanda-overlay");
      dda && (dda.style.zIndex = 4);
      Yanda.ctr.contZindex = 5;
    }

    // Controle z-index
    o.janela.style.zIndex = Yanda.ctr.contZindex++;

    Yanda.ctr.janelaDes = o;
    focusOrBlur(o, true);
    Yanda.ctr.BT.style.zIndex = Yanda.ctr.contZindex + 5;
    o.barra && (o.barra.className = "ajan-brt-jan-click");
    o.setUnselectable(false);
    Util.centralizaScroll(o);
  }

  /**
   * Minimiza a janela.
   */
  function ajanMi(o) {
    if (o.barra || o.barraChild) {
      (o.barra || o.barraChild).className = "ajan-brt-jan-norm";
    }
    o.estatus = "MI";
    Yanda.ctr.janelaDes = false;
    nextFocus();

    // Se houver janela filha
    o.ajanChild[0] && ajanMi(o.ajanChild[0]);

    o.hide();
  }

  /**
   * Chama a proxima janela apta a ter o foco.
   */
  function nextFocus() {
    const ref = maxZindex();
    ref && ref.setFocus();
  }

  function ajanFe(ref) {
    Yanda.ctr.windowsLastFocused = null;

    // Deleta as janelas filhas
    for (let i = 0, len = ref.ajanChild.length; i < len; i++) {
      ref.ajanChild[i] && ref.ajanChild[i].kill();
    }

    // Se for uma janela filha, atualiza a janela pai
    if (ref.parent) {
      const parent = ref.parent;
      const idx = parent.ajanChild?.findIndex?.((v) => v === ref);
      ref.options.modal && parent.setDisable?.(false);
      delete parent.ajanChild?.[idx];
    }

    if (ref.barra) {
      Yanda.ctr.delBarraTar(ref.barra);
      ref.barra = null;
    }

    // Apaga do array geral a janela
    delete jansPid[ref.pid];

    for (let p in ref) {
      ref[p] && ref[p]._isVue && ref[p].$destroy && ref[p].$destroy(); // Destroy Vue2 instance
      ref[p] && ref[p]._uid && ref[p].unmount && ref[p].unmount(); // Unmount Vue3 instance
    }

    // Removendo o html com o jQuery para que limpe o seu cache de dados
    if (jQuery__default["default"]) {
      jQuery__default["default"](ref.janela).remove();
    } else {
      document.body.removeChild(ref.janela);
    }

    const id = ref.id;
    for (let p in ref) {
      ref[p] = null;
    }
    ref = null;

    // TODO: Parar de expor a ref. das janelas no escopo global
    // Pode haver mais de uma janela com o mesmo id
    // So pode ser removido da variavel global se não houver mais janelas com o mesmo id
    if (id && !getJansById(id)) {
      eval.call(window, `try{_${id}=null;}catch(e){}`);
    }

    Util.setScroll();

    // Organiza as janelas ainda ativas
    Yanda.ctr.janelaDes = false;
    nextFocus();
  }

  /**
   * Gera pid para as aplicações.
   */
  function newPid(o) {
    for (let i = 1;; i++) {
      if (!jansPid[i]) {
        jansPid[i] = o;
        return i;
      }
    }
  }

  /**
   * Cria os botoes superiores da janela
   */
  function createBtn(ref, parent, tpo, title, className, help) {
    const div = Util.createElm("div");
    div.className = className;
    div.tpo = tpo;
    div.help = help;
    div.id = ref.pid;
    div.onclick = ajanBtOnClick;
    div.oncontextmenu = ajanBtOnClick;
    div.title = title;
    parent.appendChild(div);
    return div;
  }

  /**
   * Cria o HTML da janela.
   */
  function createHTML(o) {
    var j, t, tb, tr, td;

    // Div principal da janela - com propriedades iniciais
    j = Util.createElm("div");
    j.className = "ajan-geral";
    j.id = o.pid;
    j.dataset.id = o.id;
    o.janela = j;

    // Cria a tabela geral da janela
    t = Util.createElm("table");
    o.janela.appendChild(t);
    t.style.height = "100%";
    t.style.width = "100%";
    t.style.borderCollapse = "collapse";
    tb = Util.createElm("tbody");
    t.appendChild(tb);

    // Primeira linha
    tr = Util.createElm("tr");
    tr.style.height = Yanda.ctr.janTitTopAlt + "px";
    tb.appendChild(tr);

    // Canto superior esquerdo
    td = Util.createElm("td");
    td.style.width = Yanda.ctr.janTamBorda + "px";
    td.className = "ajan-tit-canto-esq";
    tr.appendChild(td);

    // Borda superior
    td = Util.createElm("td");
    td.className = "ajan-tit-sup";
    tr.appendChild(td);

    // Borda superior direita
    td = Util.createElm("td");
    td.style.width = Yanda.ctr.janTamBorda + "px";
    td.className = "ajan-tit-canto-dir";
    tr.appendChild(td);

    // Segunda linha
    tr = Util.createElm("tr");
    tr.style.height = Yanda.ctr.janTitAlt + "px";
    tb.appendChild(tr);

    // Borda esquerda
    td = Util.createElm("td");
    td.className = "ajan-tit-esq";
    tr.appendChild(td);

    //titulo
    td = Util.createElm("td");
    td.className = "ajan-tit";
    tr.appendChild(td);

    // Cria a barra de titulo
    const tit = Util.createElm("div");
    tit.className = "ajan-title";
    td.appendChild(tit);
    o.titulo = tit;

    // Cria os botoes da janela
    const bt = Util.createElm("div");
    bt.className = "ajan-title-buttons";
    bt.id = "AjanBtn" + o.pid;
    td.appendChild(bt);

    if (o.options.btFe) {
      createBtn(o, bt, "fe", "", "ajan-title-bt-fe");
    }
    if (o.options.btMa) {
      createBtn(o, bt, "ma", "", "ajan-title-bt-max");
    }
    if (o.options.btMi) {
      createBtn(o, bt, "mi", "", "ajan-title-bt-min");
    }
    if (o.options.btPr) {
      createBtn(o, bt, "pr", "Preferências da Janela", "ajan-title-bt-pr");
    }
    if (o.options.help) {
      createBtn(
        o,
        bt,
        "he",
        "Ajuda",
        "ajan-help-rtl ajan-title-bt-help",
        o.options.help,
      );
      o.help = true;
    }

    // Borda direita
    td = Util.createElm("td");
    td.className = "ajan-tit-dir";
    tr.appendChild(td);

    // Terceira linha
    tr = Util.createElm("tr");
    tb.appendChild(tr);

    // Borda esquerda
    td = Util.createElm("td");
    td.className = "ajan-besq";
    tr.appendChild(td);

    // Conteudo
    td = Util.createElm("td");
    td.className = "ajan-centro";
    tr.appendChild(td);

    // Borda direita
    td = Util.createElm("td");
    td.className = "ajan-bdir";
    tr.appendChild(td);

    // Quarta linha
    tr = Util.createElm("tr");
    tr.style.height = Yanda.ctr.janTamBordaInf + "px";
    tb.appendChild(tr);

    // Borda inferior esquerda
    td = Util.createElm("td");
    td.className = "ajan-inf-esq";
    tr.appendChild(td);

    // Borda inferior
    td = Util.createElm("td");
    td.className = "ajan-inf";
    tr.appendChild(td);

    // Borda inferior direita
    td = Util.createElm("td");
    td.className = "ajan-inf-dir";
    td.id = o.pid;
    o.rsz = td;
    tr.appendChild(td);

    // Cria a area de conteudo da janela
    j = Util.createElm("div");
    j.className = "ajan-content";
    j.id = "AjanCon" + o.pid;
    o.janela.appendChild(j);
    o.content = j;

    // Div para uso do metodo setDisable
    j = Util.createElm("div");
    j.className = "ajan-div-disabled";
    j.id = "AjanDes" + o.pid;
    o.janela.appendChild(j);

    // Div para o estatus do ajax
    j = Util.createElm("div");
    j.id = "AjanAjax" + o.pid;
    j.className = "ajan-div-ajax";
    o.janela.appendChild(j);

    document.body.appendChild(o.janela);
  }

  /**
   * Checa as teclas precionadas.
   */
  function checaCtrKeys(e, ctrl, alt, shift) {
    if (ctrl || alt || shift) {
      if (ctrl && alt && shift) {
        if (e.ctrlKey && e.altKey && e.shiftKey) {
          return true;
        }
      } else if (ctrl && alt) {
        if (e.ctrlKey && e.altKey) {
          return true;
        }
      } else if (ctrl && shift) {
        if (e.ctrlKey && e.shiftKey) {
          return true;
        }
      } else if (alt && shift) {
        if (e.altKey && e.shiftKey) {
          return true;
        }
      } else if (ctrl && e.ctrlKey) {
        return true;
      } else if (alt && e.altKey) {
        return true;
      } else if (shift && e.shiftKey) {
        return true;
      }
    }
    return false;
  }

  /**
   * Seta foco no proximo elemento da lista.
   *
   * @param {node} elm Elemento de referência
   * @param {event} e Evento de tecla que originou a mudança de foco
   * @param {array} focusables Lista de elementos que podem receber foco
   */
  function setFocus(elm, e, focusables) {
    const current = focusables.index(elm) +
      (jQuery__default["default"](elm).hasClass("select2-selection--multiple") ? 1 : 0);
    const next = focusables.eq(current + 1).length
      ? focusables.eq(current + 1)
      : focusables.eq(0);
    const first = next[0];

    // Se o campo estiver desabilitado ou apenas leitura
    // pula para o proximo
    if (
      first.disabled || jQuery__default["default"](first).prop("readonly") ||
      first.hasAttribute("yanda-no-focus")
    ) {
      setFocus(first, e, focusables);
      return;
    }

    // Se o proximo campo não estiver visível
    // tenta exibir as tabbar se tiver a tecla ctrl pressionada ao teclar enter
    if (first.offsetHeight === 0) {
      if (e.ctrlKey !== true) {
        doAfterIfButton(elm, () => {
          elm.blur();
          elm.focus();
        });
        return;
      }
      Yanda.showTabs(next);
    }

    // Se ainda não estiver visível, tenta selecionar o próximo
    if (
      first.offsetHeight === 0 || getComputedStyle(first).visibility === "hidden"
    ) {
      setFocus(first, e, focusables);
      return;
    }
    doAfterIfButton(elm, () => {
      next.focus();
      next.select && next.select();
      next.find(".select2-hidden-accessible") &&
        next.next().find(".select2-selection").focus();
    });
  }

  /**
   * No firefox caso o elemento esteja ouvindo o evento "click", o mesmo não é chamado
   * caso seja setado o foco em outro elemento no mesmo event loop.
   *
   * Como correção o foco é setando no próximo event loop utilizando uma macroTask.
   *
   * Essa correção foi aplicada somente quando for um botão
   *
   * @param {Element} target
   * @param {function} fn
   */
  function doAfterIfButton(target, fn) {
    const { type, nodeName } = target;
    (nodeName === "BUTTON" || type === "button" || type === "submit")
      ? setTimeout(fn)
      : fn();
  }

  function keypress(e) {
    const target = e.currentTarget;
    let maxchar = false;

    if (
      jQuery__default["default"](target).prop("maxchar") &&
      jQuery__default["default"](target).val().length >= jQuery__default["default"](target).prop("maxchar")
    ) {
      maxchar = true;
    }

    // Continua caso for enter(13), ctrl + enter (10) ou último
    if (!(e.keyCode === 13 || e.keyCode === 10 || maxchar)) {
      return;
    }

    const targetEvent = target.onkeypress ? target.onkeypress.toString() : "";
    if (
      jQuery__default["default"](target).attr("yanda-no-enter") !== undefined ||
      (targetEvent &&
        (targetEvent.indexOf("trocaFoco") !== -1 ||
          targetEvent.indexOf("doOnKeyPress") !== -1)) ||
      (target.nodeName === "TEXTAREA" && e.shiftKey === true)
    ) {
      return;
    }

    // Somente previne a operação padrão caso não sejam botões
    // Necessario para não dar submit nos forms ao dar enter nos inputs
    (target.nodeName !== "BUTTON" && target.type !== "submit" &&
      target.type !== "button") && e.preventDefault();

    setFocus(target, e, this.focusables);
  }

  function minWidthJanela(hdl) {
    if (!hdl.isResponsive() && Util.isMobile()) {
      var minWidth = hdl.janela.querySelector(".ajan-min-width");
      minWidth && (minWidth.style.minWidth = hdl.janela.janResizeLarMin + "px");
    }
  }

  function janela(opt) {
    // Janela filha
    if (opt && opt.dad) {
      const dad = opt.dad,
        modal = (typeof opt.modal === "boolean") ? opt.modal : true;
      if (typeof dad !== "object") {
        throw new Error("Janela pai inválida");
      }
      opt.dad = opt.modal = null;
      opt.showBarra = false;
      return dad.newChild(modal, opt);
    }

    this.options = opt;
    this.id = opt.id;

    // Variaveis de controle
    this.pid = newPid(this);
    this.help = opt.help;
    this.barra = false;
    this.grids = []; // Armazena os grids da janela em um Array
    this.isMax = false;
    this.uniqid = `uuid${Math.uuid(8)}`;
    this.disabled = false;
    this.estatus = "NO"; /*NO - normal, MI - minimizada, FO - focus*/
    this.created = false;
    this.acptDisableAll = true;

    // Janelas filhas
    this.ajanChild = [];
    createHTML(this);
    this.setResize(true);

    // Dimensões minimas da janela
    this.janela.janResizeLarMin = Yanda.ctr.janResizeLarMin;
    this.janela.janResizeAltMin = Yanda.ctr.janResizeAltMin;

    // Poe a jenela em foco
    this.janela.onmousedown = ajanOnMouseDown;

    // Quando é clicado na barra de titulo
    this.titulo.onmousedown = ajanTitOnMouseDown.bind(this);

    // Quando e dado um duplo clique na barra de titulo
    this.titulo.ondblclick = ajanTitOnBdlClick.bind(this);

    // Redimensiona a janela com o mouse
    this.rsz.onmousedown = ajanRszOnMouseDown;

    this.setTitulo(opt.title);
  }

  janela.prototype = {
    atualizaFocus() {
      var focusables = this.focusables;
      this._keypressListener &&
        focusables.off("keypress", this._keypressListener);
      this._keypressListener = keypress.bind(this);
      focusables.on("keypress", this._keypressListener);
    },

    isResponsive() {
      return (this.options && this.options.isResponsive === true);
    },

    addFocus(depoisDe, campos) {
      var focusables = this.focusables,
        index = focusables.index(depoisDe);

      if (index === -1) {
        return;
      }

      index++;
      for (var campo of campos) {
        focusables.splice(index, 0, campo);
        index++;
      }
      this.atualizaFocus();
    },

    delFocus(campos) {
      var focusables = this.focusables,
        index = -1;

      if (!campos.length) {
        return;
      }
      for (var campo of campos) {
        index = focusables.index(campo);
        (index !== -1) && focusables.splice(index, 1);
      }
      this.atualizaFocus();
    },

    resetFocus() {
      // Os links são ignorados
      this.focusables = jQuery__default["default"]("div#AjanCon" + this.pid + " :not(a):focusable");
      this.atualizaFocus();

      // abilitar tabs ao clicar no botão submit (ref. valdações de formulário)
      var janela = this.janela;
      jQuery__default["default"](janela).find("button[type=submit]").on("click", function () {
        Yanda.showTabs(jQuery__default["default"](this).closest("form")[0].querySelector(":invalid"));
      });
    },

    onCreate() {
      const janStyle = this.janela.style;
      const style = !this.isMax && !Util.isMobile() && Yanda.ctr.janelaDes &&
        Yanda.ctr.janelaDes.janela.style;
      let top = parseInt(janStyle.top),
        left = parseInt(janStyle.left);

      // Seta uma posição diferente
      // Quando a posição da nova janela coincidir com a janela em foco
      if (style && top === parseInt(style.top) && left === parseInt(style.left)) {
        // se tiver espaço
        (parseFloat(janStyle.width) + 10 <= Yanda.ctr.janMaLar) && (left += 10);
        (parseFloat(janStyle.height) + 10 <= Yanda.ctr.janMaAlt) && (top += 10);
        this.setPosicao(left, top);
      }
      this.resetFocus();
      minWidthJanela(this);
    },

    setOpacidade(v) {
      this.janela.style.opacity = v;
    },

    show() {
      if (this.acptDisableAll && Yanda.ctr.disableAll) {
        return;
      }
      this.janela.style.visibility = "visible";
      if (!this.created) {
        // Cria div de controle da janela na barra de tarefas
        if (this.options.showBarra) {
          this.barra = Yanda.ctr.newBarraTar(this, this.options.title);
        }
        this.onCreate && this.onCreate();
        this.created = true;
      }
      this.onShow && this.onShow();
      this.setFocus();

      // Se houver janela filha
      this.ajanChild[0] && this.ajanChild[0].show();
    },

    hide() {
      this.onHide && this.onHide();
      this.janela.style.visibility = "hidden";
    },

    minimiza() {
      if (this.acptDisableAll && Yanda.ctr.disableAll) {
        return;
      }
      if (!this.options.btMi) {
        return;
      }
      this.onMinimize && this.onMinimize();

      function getAncestral(janelaRef) {
        while (janelaRef.parent) {
          janelaRef = janelaRef.parent;
        }
        return janelaRef;
      }

      ajanMi(getAncestral(this));
    },

    setTamanho(w, h, t) {
      var tbody = this.janela.firstChild.firstChild,
        title = tbody.getElementsByTagName("TR")[1].getElementsByTagName("TD")[1],
        content =
          tbody.getElementsByTagName("TR")[2].getElementsByTagName("TD")[1],
        ajanbtn = this.janela.querySelector("#AjanBtn" + this.pid),
        mobile = !this.isResponsive() && Util.isMobile(),
        centraliza = false;

      if (mobile) {
        (this.janela.janResizeLarMin === 60) && (!t || !t.minWidth) &&
          (this.janela.janResizeLarMin = w);
        !this.isMax && (w > Yanda.ctr.janMaLar) && (w = Yanda.ctr.janMaLar);
      }

      // Altera tamanho minimo da janela
      if (t) {
        t.minWidth && (this.janela.janResizeLarMin = t.minWidth);
        t.minHeight && (this.janela.janResizeAltMin = t.minHeight);
      }

      var set = () => {
        this.janela.style.width = w + "px";
        this.janela.style.height = h + "px";

        centraliza && this.centraliza();
        this.content.style.height = content.clientHeight + "px";
        this.content.style.width = content.clientWidth + "px";
        this.titulo.style.width = (title.clientWidth - ajanbtn.clientWidth) +
          "px";
        this.content.style.height = content.clientHeight + "px";
        minWidthJanela(this);
      };

      set();

      if (mobile && h < Yanda.ctr.janMaAlt && !this.isMax) {
        var body = this.content.querySelector("#body"),
          footer = this.content.querySelector("#footer");

        if (body) {
          h = body.scrollHeight + 78;
          footer && (h += footer.clientHeight);
        }

        (h > Yanda.ctr.janMaAlt) && (h = Yanda.ctr.janMaAlt);
        centraliza = true;
        set();
      }
    },

    /**
     * Seta a posição da janela.
     *
     * @param {type} l
     * @param {type} t
     * @param {type} noScroll (Maximize||Move) === true
     */
    setPosicao(l, t, noScroll) {
      (noScroll !== true) && (t += window.scrollY);
      (l < Yanda.ctr.janPosLeftMax) && (l = Yanda.ctr.janPosLeftMax);
      (l > Yanda.ctr.janPosRightMax) && (l = Yanda.ctr.janPosRightMax);
      (t < Yanda.ctr.janPosTopMax) && (t = Yanda.ctr.janPosTopMax);
      (l < 0) && (l = 0);

      this.janela.style.left = l + "px";
      this.janela.style.top = t + "px";
      Util.setScroll();
    },

    setTitulo(t) {
      this.titulo.innerHTML =
        (this.id && /^\d+$/.test(this.id)
          ? (this.id + "").padStart(4, "0") + " - "
          : "") + t;
      if (this.barra) {
        this.barra.title = t;
        this.barra.innerHTML = t;
      }
    },

    setFocus() {
      if (this.acptDisableAll && Yanda.ctr.disableAll) {
        return;
      }
      this.parent && (Yanda.ctr.janelaDes !== this.parent) &&
        this.parent?.setFocus?.();
      ajanFocus(this);
      this.parent && this.barraChild &&
        (this.barraChild.className = "ajan-brt-jan-click");
      this.onFocus && this.onFocus();
    },

    setBlur() {
      ajanBlur(this);
      this.parent && this.barraChild &&
        (this.barraChild.className = "ajan-brt-jan-norm");
      this.onBlur && this.onBlur();
    },

    close() {
      if (this.acptDisableAll && Yanda.ctr.disableAll) {
        return;
      }
      if (this.disabled || !this.options.btFe) {
        return;
      }
      if (this.onBeforeClose) {
        if (this.onBeforeClose() === false) {
          return;
        }
      }
      if (this.onAfterClose) {
        if (this.onAfterClose() === false) {
          return;
        }
      }
      var a = this.onClose ? this.onClose : false;

      ajanFe(this);
      a && a();
    },

    /**
     * Fecha a janela sem chamar eventos.
     */
    kill() {
      ajanFe(this);
    },

    /**
     * Controla se a janela podera ter seu tamanho redefinido com o mouse.
     */
    setResize(a) {
      const style = this.rsz.style;
      if (a) {
        style.cursor = "nw-resize";
        style.zIndex = 1;
        style.position = "relative";
      } else {
        style.cursor = "default";
        style.zIndex = 1;
        style.position = "unset";
      }
      this.resizeSta = a;
    },

    /**
     * Maximiniza ou restaura a janela.
     */
    maximize() {
      if (
        (this.acptDisableAll && Yanda.ctr.disableAll) ||
        (this.disabled || !this.options.btMa)
      ) {
        return;
      }
      ajanMaNo(this);
      this.onMaximize && this.onMaximize();
      this.onResize && this.onResize();
    },

    maximizeSys() {
      ajanMaNo(this);
    },

    /**
     * Torna a janela inselecionavel.
     */
    setUnselectable(c) {
      Util.setUnselectable(this.janela, c);
    },

    /**
     * Desabilita/Habilita a janela.
     */
    setDisable(c) {
      this.disabled = c;
      if (c) {
        this.onDisable && this.onDisable();
      } else {
        this.onEnable && this.onEnable();
      }
      this.janela.querySelector("#AjanDes" + this.pid).style.display = c
        ? "block"
        : "none";
    },

    setContent(t) {
      this.uniqid && t && (t = t.replace(/\{\{uniqid\}\}/g, this.uniqid));
      this.content.innerHTML = t;

      if (this.isResponsive()) {
        return;
      }

      let body = this.content.querySelector("#body"),
        footer,
        content;

      if (!body) {
        content = this.content.innerHTML;
        this.content.innerHTML = '<div id="body"></div>';
        body = this.content.querySelector("#body");
        body.innerHTML = content;
        footer = this.content.querySelector("#body > #footer");
        footer && jQuery__default["default"](footer).detach().appendTo(body.parentNode);
      }
      body.style.flex = 1;
      Util.isMobile() && (body.style.overflow = "");

      const parent = body.parentElement;
      if (
        parent !== this.content && getComputedStyle(parent).display !== "flex"
      ) {
        parent.style.flex = "1";
        parent.style.display = "flex";
        parent.style.overflow = "hidden";
        parent.style.flexDirection = "column";
      }

      const $child = jQuery__default["default"](body).find("> *");
      if ($child.length === 1) {
        $child.css({ flex: 1 });
        return;
      }

      content = body.innerHTML;
      body.innerHTML = '<div class="ajan-min-width"></div>';
      body.querySelector("div").innerHTML = content;
    },

    getContent() {
      return this.content.innerHTML;
    },

    /**
     * Procura por elementos com o respectivo id dentro da janela.
     */
    $(id) {
      return this.content.querySelector("#" + id);
    },

    /**
     * Apresenta imagem de estatus quando a jenela estiver em operação de ajax.
     */
    setCarregando(c) {
      this.setDisable(c);
      var div = this.janela.querySelector("#AjanAjax" + this.pid),
        span = div.firstElementChild;
      div.style.background = "url(" + Yanda.src +
        "img/carregando.gif) no-repeat center center";
      div.style.cursor = c ? "wait" : "default";
      div.style.display = c ? "block" : "none";

      // Span de cancelamento do ajax
      span && div.removeChild(span);
    },

    /**
     * TODO: Atualmente só pode ter uma janela filha
     */
    newChild(modal, opt) {
      var dad = this,
        idx = 0, // Permitir varios idx mais tarde para mas de uma janela filha
        id = opt.id ? opt.id : `${dad.id}_${idx}`;

      opt.id = id;
      opt.btFe = true;
      opt.modal = modal;

      let child = new janela(opt);
      if (dad.barra || dad.barraChild) {
        child.barraChild = dad.barra || dad.barraChild;
      }

      // Referencia com a janela pai
      child.dad = dad.pid;
      child.parent = dad;

      modal && dad.setDisable(true);
      dad.ajanChild[idx] = child;
      return child;
    },

    ajax(setCarregando, url, data = null, callback = null) {
      const self = this;
      const divAjax = this.janela.querySelector("#AjanAjax" + self.pid);

      setCarregando && self.setCarregando(setCarregando);

      let xhr = new XMLHttpRequest();
      xhr.open(data ? "POST" : "GET", url);
      xhr.addEventListener("load", () => {
        if (xhr.status !== 200) {
          return;
        }
        setCarregando && self.setCarregando && self.setCarregando(false);
        try {
          callback
            ? callback(xhr)
            : (new Function("self", xhr.responseText))(self);
        } catch (e) {}
      });
      xhr.addEventListener("loadend", () => {
        xhr.status !== 200 && setCarregando && self.setCarregando &&
          self.setCarregando(false);
        xhr = null;
      });
      // Somente adiciona o header Content-Type quando for um post
      // e os dados não forem provenientes de um FormData.
      // Quando for um FormData, ele mesmo gera o content-type de forma correta
      // utilizando o boundary
      if (data && !(data instanceof FormData)) {
        xhr.setRequestHeader(
          "Content-Type",
          "application/x-www-form-urlencoded; charset=UTF-8",
        );
      }
      xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
      xhr.send(data);

      function background(img) {
        divAjax.style.background =
          `url(${Yanda.src}img/${img}.gif) no-repeat center center`;
      }

      let seconds = 0;
      const onTime = function () {
        if (!xhr) {
          return;
        }
        switch (seconds) {
          case 4:
            background("carregando1");
            break;
          case 8:
          case 16:
            background("carregando2");
            break;
          case 12:
            background("carregando3");
            break;
          case 25:
            var cancelar = Util.createElm("span");
            cancelar.innerHTML = "Cancelar";
            cancelar.title = "Clique para cancelar a operação com o servidor";
            cancelar.onclick = function () {
              xhr && xhr.abort();
            };
            divAjax.appendChild(cancelar);
        }
        seconds++;
        setTimeout(onTime, 1000);
      };
      onTime();
    },

    centraliza() {
      var w = parseInt(this.janela.style.width),
        h = parseInt(this.janela.style.height),
        s = Yanda.ctr.pageSize;

      this.setPosicao(
        (s.windowWidth / 2) - w / 2 + (Yanda.ctr.janMaPosLeft / 2),
        (Yanda.ctr.janMaAlt / 2) - (h / 2) + Yanda.ctr.janMaPosTop,
      );
      Util.centralizaScroll(this);
    },

    /**
     * Operações de acordo com a tecla pressionada.
     */
    doOnKeyPress(e) {
      if (!this.keys) {
        return;
      }
      const k = e.keyCode;
      if (!this.keys[k]) {
        return;
      }
      const t = this.keys[k];
      if (!t[1]) {
        return;
      }
      if (checaCtrKeys(e, t[2], t[3], t[4])) {
        Util.cancelEvent(e);
        Function(t[1])();
        return;
      }

      if (!t[2] && !t[3] && !t[4]) {
        Util.cancelEvent(e);
        e.stopPropagation();
        Function(t[1])();
      }
    },

    /**
     * Retorna os dados dos campos da janela formatados para envio para o servidor.
     * @deprecated
     */
    getDataToServer(D) {
      console.warn("[yanda] getDataToServer está depreciado");
      var E, A, B, C = "";
      if (!D.notSelect) {
        for (A = 0; A < this.janela.getElementsByTagName("select").length; A++) {
          E = this.janela.getElementsByTagName("select")[A].id.split("_");
          C += "&" + E[0];
          C += "=" +
            encodeURIComponent(
              this.janela.getElementsByTagName("select")[A].value,
            );
        }
      }
      for (A = 0; A < this.janela.getElementsByTagName("input").length; A++) {
        B = this.janela.getElementsByTagName("input")[A].type;
        if (B == "button") {
          continue;
        }
        if (B == "text" && D.notText) {
          continue;
        }
        if (B == "radio" && D.notRadio) {
          continue;
        }
        if (B == "checkbox" && D.notCheckbox) {
          continue;
        }
        if (
          this.janela.getElementsByTagName("input")[A].value !== "" ||
          B == "checkbox"
        ) {
          E = this.janela.getElementsByTagName("input")[A].id.split("_");
          C += "&" + E[0];
          if (B == "checkbox") {
            C += "=" + this.janela.getElementsByTagName("input")[A].checked;
          } else {
            C += "=" +
              encodeURIComponent(
                this.janela.getElementsByTagName("input")[A].value,
              );
          }
        }
      }
      return C;
    },

    /**
     * @deprecated
     */
    getDataToServerGet(D) {
      console.warn("[yanda] getDataToServerGet está depreciado");
      var d = "", dad = this.submit(D);
      for (var i = 0; i <= dad.length - 1; i++) {
        // d += dad[i].replace('&','|||');
        if (dad.charAt(i) == "&") {
          d += "|||";
        } else {
          d += dad.charAt(i);
        }
      }
      return d;
    },

    /**
     * @deprecated
     */
    submit(D) {
      console.warn("[yanda] submit está depreciado");
      if (!D) {
        D = {};
      }
      var i, E, A, B, C = "";
      C += `&hdl=_${this.id}`;
      if (!D.notSelect) {
        for (A = 0; A < this.janela.getElementsByTagName("select").length; A++) {
          if (this.janela.getElementsByTagName("select")[A].value == "") {
            continue;
          }
          C += "&" + getIdName(this.janela.getElementsByTagName("select")[A].id);
          C += "=" +
            encodeURIComponent(
              this.janela.getElementsByTagName("select")[A].value,
            );
        }
      }
      if (!D.notTextarea) {
        for (
          A = 0;
          A < this.janela.getElementsByTagName("textarea").length;
          A++
        ) {
          if (this.janela.getElementsByTagName("textarea")[A].value == "") {
            continue;
          }
          C += "&" +
            getIdName(this.janela.getElementsByTagName("textarea")[A].id);
          C += "=" +
            encodeURIComponent(
              this.janela.getElementsByTagName("textarea")[A].value,
            );
        }
      }
      for (A = 0; A < this.janela.getElementsByTagName("input").length; A++) {
        if (
          this.janela.getElementsByTagName("input")[A].value != "" &&
          this.janela.getElementsByTagName("input")[A].id != ""
        ) {
          B = this.janela.getElementsByTagName("input")[A].type;
          switch (B) {
            case "button":
              if (D.notButton == false) {
                continue;
              }
              C += "&" +
                getIdName(this.janela.getElementsByTagName("input")[A].id);
              C += "=" +
                encodeURIComponent(
                  this.janela.getElementsByTagName("input")[A].value,
                );
              break;
            case "text":
              if (D.notText == false) {
                continue;
              }
              C += "&" +
                getIdName(this.janela.getElementsByTagName("input")[A].id);
              C += "=" +
                encodeURIComponent(
                  this.janela.getElementsByTagName("input")[A].value,
                );
              break;
            case "checkbox":
              if (D.notCheckbox == false) {
                continue;
              }
              if (this.janela.getElementsByTagName("input")[A].checked == false) {
                continue;
              }
              C += "&" +
                getIdName(this.janela.getElementsByTagName("input")[A].id);
              C += "=" + this.janela.getElementsByTagName("input")[A].value;
              break;
            case "radio":
              if (D.notRadio == false) {
                continue;
              }
              E = getIdName(this.janela.getElementsByTagName("input")[A].id);
              for (
                i = 0;
                i < this.janela.getElementsByTagName("input").length;
                i++
              ) {
                if (
                  this.janela.getElementsByTagName("input")[i].name ==
                    this.janela.getElementsByTagName("input")[A].name &&
                  this.janela.getElementsByTagName("input")[i].checked &&
                  C.indexOf("&" + E + "=", 0) < 0
                ) {
                  C += "&" +
                    getIdName(this.janela.getElementsByTagName("input")[A].id);
                  C += "=" + this.janela.getElementsByTagName("input")[i].value;
                }
              }
              break;

            default:
              C += "&" +
                getIdName(this.janela.getElementsByTagName("input")[A].id);
              C += "=" +
                encodeURIComponent(
                  this.janela.getElementsByTagName("input")[A].value,
                );
              break;
          }
        }
      }
      if (!D.notGrid) {
        C += this.submitGrid();
      }
      /* jshint ignore:end */
      return C;
    },

    /**
     * Função chamada quando o botão btPr for clicado.
     * TODO: Analisar melhor a utilização dos botoes da Janela.
     *
     * @deprecated
     * @return {undefined}
     */
    campoPadrao() {},
  };

  /**
   * Retorna o numero de janelas abertas.
   */
  function getTotJans() {
    for (var i = 1, j = 0, len = jansPid.length; i < len; i++) {
      jansPid[i] && j++;
    }
    return j;
  }

  /**
   * Retorna a janela pelo id.
   */
  function getJansById(d) {
    var i = 1, j = 0, t = [], len = jansPid.length;
    for (; i < len; i++) {
      if (jansPid[i] && jansPid[i].id == d) {
        t[j] = jansPid[i];
        j++;
      }
    }
    return (j > 0) ? t : false;
  }

  /**
   * Retorna a posição mais baixa das janelas (ver questão de custo)
   */
  function getJanMaxBottom() {
    var janela,
      bottom,
      maxBottom = 0,
      i = 0;
    for (; i < jansPid.length; i++) {
      janela = jansPid[i];
      if (!janela) {
        continue;
      }
      bottom = parseInt(janela.janela.style.top) +
        parseInt(janela.janela.style.height);
      (bottom > maxBottom) && (maxBottom = bottom);
    }
    return maxBottom;
  }

  /**
   * Retorna a janela pelo pid.
   */
  function getJanByPid(p) {
    return jansPid[p] || false;
  }

  /**
   * Tira o hdl do nome no id para fazer o post
   * exemplo nome_do_campo_255 vai fica nome_do_campo
   * @author Clairton Rodrigo Heinzen
   * @deprecated
   */
  function getIdName(id) {
    var j, aux = id.split("_"), e = aux[0];
    for (j = 1; j < aux.length - 1; j++) {
      e += "_";
      e += aux[j];
    }
    return e;
  }

  function newJanela(opt) {
    return new janela(opt);
  }

  /**
   * Controla as janelas abertas. Cria a barra de tarefas no final da página.
   */
  function Ctr () {
    // Controla qual janela esta em destaque
    this.janelaDes = false;

    this.disableAll = false;

    // Controla o minimo que uma janela tera de tamanho
    this.janResizeAltMin = 50;
    this.janResizeLarMin = 60;

    // Controle interno da janela
    this.janTitAlt = 20;
    this.janTamBorda = 8;
    this.janTitTopAlt = 4;
    this.janTamBordaInf = 8;

    // Controla o z-index das janelas
    this.contZindex = 5;

    // Controla o evento onmousedown e onmousemove da propriedade de redefinicao das janelas
    this.janCtrMove = false;
    this.janCtrResize = false;

    // Maxima posição que a janela tera
    this.janPosTopMax = 46;

    // TODO: Controlar conforme o tamanho de cada janela
    this.janPosLeftMax = -500;

    // Posição quando a janela estiver maximinizada
    this.janMaPosTop = 46;
    this.janMaPosLeft = 0;

    // Barra de Tarefas
    this.BTAlt = 28;

    /**
     * Atualiza as variáveis necessárias.
     */
    this.update = function () {
      this.pageSize = new Util.getPageSize();

      // Barra de Tarefas
      this.BTLar = this.pageSize.windowWidth - this.janMaPosLeft;
      this.BT.style.width = this.pageSize.windowWidth + "px";

      // Controle de movimentacao máxima da janela
      this.janPosRightMax = this.pageSize.windowWidth - 50 - this.janMaPosLeft;
      this.janPosBottomMax = this.pageSize.windowHeight - this.BTAlt -
        this.janTitAlt;
      this.janMaAlt = this.pageSize.windowHeight - this.janMaPosTop -
        this.BT.offsetHeight;

      // Maximinizacao da janela
      this.janMaLar = this.pageSize.windowWidth - this.janMaPosLeft;
    };

    /**
     * Instancia nova extenção de uma janela na barra de tarefas.
     *
     * @param obj Janela
     * @param tit Titulo a ser exibido na barra de tarefas
     */
    this.newBarraTar = function (obj, tit) {
      const div = Util.createElm("div");
      div.id = obj.pid;
      div.title = tit;
      div.className = "ajan-brt-jan-norm";
      div.innerHTML = tit;
      this.BT.querySelector(".ajan-brt-task-bar").appendChild(div);

      div.onmousemove = ajanBrOnMouseMove;
      div.onmouseout = ajanBrOnMouseOut;
      div.onclick = ajanBrOnClick;

      return div;
    };

    /**
     * Remove a extenção de uma janela na barra de tarefas.
     *
     * @param obj Janela
     */
    this.delBarraTar = function (obj) {
      this.BT.querySelector(".ajan-brt-task-bar").removeChild(obj);
    };

    /**
     * hide/show all windows
     */
    this.toogleAllWindows = function () {
      let i = 1, janela = null;
      const janelas = jansPid.length;
      const action = this.janelaDes ? "minimiza" : "show";

      this.windowsLastFocused = this.janelaDes || this.windowsLastFocused;

      for (; i < janelas; i++) {
        janela = jansPid[i];
        if (!janela || (action == "show" && !janela.windowsShow)) {
          continue;
        }
        janela.windowsShow = janela.estatus !== "MI";
        janela[action]();
      }

      if (action === "show" && this.windowsLastFocused) {
        this.windowsLastFocused.show();
        this.windowsLastFocused = null;
      }
    };

    // Cria div de controle de resize - efeito de redimensinamento via mouse
    let d = Util.createElm("div");
    d.className = "ajan-div-resize";
    d.style.display = "none";
    document.body.appendChild(d);
    this.divResize = d;

    // Cria a barra de tarefas
    d = Util.createElm("div");
    d.className = "ajan-brt";
    d.style.left = 0;
    d.style.bottom = 0;
    d.style.height = this.BTAlt + "px";
    d.style.zIndex = this.contZindex + 5;
    document.body.appendChild(d);
    this.BT = d;

    const template = document.createElement("template");
    template.innerHTML =
      `<div class="ajan-brt-task-bar"></div><div class="ajan-brt-tray-icons">
        <div class="ajan-brt-toggle desktop" style="padding-top: 4px">
            <i class="mdi mdi-monitor mdi-18px" aria-hidden="true" title="Minimizar todas janelas Ctrl+Alt+D">
                <div class="ajan-help-rtl ajan-help-rtl-focus ajan-help-up"></div>
            </i>
        </div>
    </div>`;
    this.BT.appendChild(template.content);

    // Cria controlador scroll
    d = Util.createElm("div");
    d.id = "scroll";
    d.style.top = 0;
    d.style.left = 0;
    d.style.width = this.BTAlt + "px";
    d.style.zIndex = 30000;
    d.style.height = (this.BTAlt - 6) + "px";
    d.style.position = "absolute";
    d.style.visibility = "hidden";
    d.style.backgroundColor = "#000";
    document.body.appendChild(d);

    this.BT.querySelector(".ajan-brt-toggle.desktop").addEventListener(
      "click",
      () => this.toogleAllWindows(),
    );
    this.update();
  }

  /**
   * Cria o status de aguardando do sistema na abertura de aplicações.
   */
  function classEstAjax(ctr) {
    this.txt = "aguarde, processando...";
    const d = document.createElement("div");

    d.className = "ajan-status-ajax";
    d.innerHTML = `
        <table style='width:100%;height:100%'>
            <tr>
                <td style='width:15%; text-align: center;'><span></span></td>
                <td><label>${this.txt}</label></td>
            </tr>
        </table>
    `;
    document.body.appendChild(d);

    this.div = d;
    this.id = 0;
    this.loads = [];

    this.isLoading = () => (this.loads.length > 0);

    this.show = function (options) {
      options = options || {};
      const msg = options.msg || this.txt;
      if (!arguments[1]) {
        options.id = this.id++;
        this.loads.push(options);
      }
      this.div.querySelector("label").innerHTML = msg;
      this.div.style.bottom = (parseInt(ctr.BT.style.height) + 5) + "px";
      this.div.style.display = "block";
      return options.id;
    };

    this.hidden = function (id) {
      if (typeof id === "number") {
        this.loads.splice(
          this.loads.findIndex(function (elm) {
            return (elm.id === id);
          }),
          1,
        );
      } else if (this.loads.length) {
        this.loads.shift();
      }

      if (!this.loads.length) {
        this.div.style.display = "none";
        return;
      }
      this.show(this.loads[this.loads.length - 1], true);
    };
  }

  // deno-lint-ignore-file

  /**
   * Subscreve as requisições para utilizar Yanda.ajaxResponseError como interceptor
   * TODO: Melhorar a utilização
   *
   * @param object Yanda
   */
  function proxyRequest(Yanda) {
    window.fetchOriginal = window.fetch;
    window.XMLHttpRequestOriginal = XMLHttpRequest;

    window.XMLHttpRequest = function () {
      const xhr = new window.XMLHttpRequestOriginal();
      xhr.addEventListener("load", () => Yanda.ajaxResponseError(xhr, true));
      xhr.addEventListener("error", () => Yanda.ajaxResponseError(xhr, true));

      return xhr;
    };
    window.fetch = function (input, init) {
      // simular XMLHttpRequest
      // PHP siggma identifica e retorna  403 (Sessão expirou)
      // caso contrario retorna um redirect
      function headers(opts) {
        opts = opts || {};
        opts.headers = opts.headers || {};
        opts.headers["X-Requested-With"] = "XMLHttpRequest";
        return opts;
      }

      return window.fetchOriginal(input, headers(init)).then((resp) => {
        if (resp.ok) {
          return resp;
        }

        const xhr = { status: resp.status };
        return resp.text().then((responseText) => {
          (xhr.status == 404) && (responseText = "Página não encontrada");
          xhr.responseText = responseText;

          Yanda.ajaxResponseError(xhr, true);
          throw Error(
            xhr.responseText ||
              "Erro ao efetuar comunicação com o servidor<br>Tente novamente",
          );
        });
      });
    };
  }

  /**
   * Faz aredondamento de valores numéricos conforme php/postgres.
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round#Decimal_rounding
   *
   * @param c Casas decimais
   */
  globalThis.Number.prototype.roundNumber = function (c) {
    const shift = function (number, precision) {
      const numArray = ("" + number).split("e");
      return +(numArray[0] + "e" +
        (numArray[1] ? (+numArray[1] + precision) : precision));
    };

    // Alguns numeros ainda não arredondam corretamente, por exemplo:
    // 24.45 * 16.90 = 413.2049999999999
    // Fazendo o roundNumber deste numero fica 413.20 quando o correto é 413.21
    let num = shift(Math.round(shift(this, +10)), -10);

    num = shift(Math.round(shift(num, +c)), -c);
    return arguments[1] ? num : num.toFixed(c);
  };

  function start (urlAction, urlSystem) {
    Yanda.installJQueryPlugins();

    // Clique de direta com o mouse é desabilitado
    document.body.oncontextmenu = function () {
      return false;
    };

    // Cria controle de aplicacoes
    Yanda.ctr = new Ctr();

    Yanda.srcAction = urlAction;

    // TODO: recuperar a url dinamicamente
    // Endereco das imagens do sistema
    Yanda.src = urlSystem;

    // Estatus padrao ao abrir aplicacao
    Yanda.estAjax = new classEstAjax(Yanda.ctr);

    /**
     * Controla os eventos do teclado.
     */
    document.addEventListener("keydown", function (e) {
      if (!Yanda.ctr) {
        return;
      }
      var k = e.keyCode;

      // Cancela o atalho do ctrl+j
      if (k === 74 && e.ctrlKey) {
        Yanda.util.cancelEvent(e);
        return;
      }

      // Ctr+Alt+C
      // No firefox do windows foi detectado um problema com essa combinação de teclas,
      // pois representa o caracte ₢ (Cruzeiro). No linux funciona normalmente
      if (k === 67 && ((e.altKey && e.ctrlKey) || e.key === "₢")) {
        Yanda.cmd();
        Yanda.util.cancelEvent(e);
        return;
      }

      if (Yanda.ctr.janelaDes) {
        if (k === 27) {
          Yanda.util.cancelEvent(e);
          Yanda.ctr.janelaDes.close();
          return;
        }
        Yanda.ctr.janelaDes.doOnKeyPress(e);
      }

      // (Ctrl + Alt + D)
      (e.ctrlKey && e.altKey && k === 68) && Yanda.ctr.toogleAllWindows();
    }, false);

    (function () {
      let longTimeout = null;
      const longEvent = (e) => {
        clearTimeout(longTimeout);
        (e.target.tagName === "BODY") &&
          (longTimeout = setTimeout(() => Yanda.cmd(), 1000));
      };
      const body = document.body;
      const cancel = () => clearTimeout(longTimeout);
      body.addEventListener("touchstart", longEvent);
      body.addEventListener("touchend", cancel);
      body.addEventListener("mousedown", longEvent);
      body.addEventListener("mouseup", cancel);
    })();

    // TODO: melhorar
    globalThis.Storage = {
      setItem: (key, value) => localStorage.setItem(Yanda.prefix + key, value),
      getItem: (key) => localStorage.getItem(Yanda.prefix + key),
      removeItem: (key) => localStorage.removeItem(Yanda.prefix + key),
    };

    proxyRequest(Yanda);
  }

  /**
   * @param params {msg, type, title, detail, disabled, showBarra, exception, onClose}
   * @returns {janela|*|janela}
   */
  Yanda.message = function (params) {
    switch (params.type) {
      case "error":
        params.image = `${Yanda.src}img/imgerro.gif`;
        !params.title && (params.title = "Erro");
        break;

      case "info":
        params.image = `${Yanda.src}img/ImgInfo.gif`;
        !params.title && (params.title = "Iforme");
        break;

      case "warning":
        params.image = `${Yanda.src}img/warning.gif`;
        !params.title && (params.title = "Alerta");
        break;

      case "success":
        params.image = `${Yanda.src}img/success.png`;
        !params.title && (params.title = "Sucesso");
        break;

      default:
        alert(`Tipo de mensagem não aceito: ${params.type}`);
        return;
    }

    (params.disabled === undefined) && (params.disabled = true);

    // Parametro antigo
    if (params.exception && params.detail === undefined) {
      params.detail = params.exception;
      delete params.exception;
    }

    let template;
    let height;
    let width = 500;
    const hdl = Yanda.newJanela({
      showBarra: params.showBarra,
      title: params.title,
      mode: "new",
      btMa: true,
      btFe: true,
      id: 100,
    });

    if (params.onClose) {
      hdl.onClose = function () {
        params.onClose();
      };
    }

    if (params.disabled === undefined || params.disabled) {
      hdl.onCreate = function () {
        hdl.acptDisableAll = false;
        Yanda.disableAll(true);
      };
      hdl.onAfterClose = () => Yanda.disableAll(false);
    }

    hdl.titulo.innerHTML = params.title;
    hdl.onResize = hdl.resize = function () {
      height = hdl.janela.clientHeight;
      width = hdl.janela.clientWidth;

      let h = height - 80;
      hdl.$("body").style.height = `${h}px`;
      if (hdl.$("detalhes")) {
        h -= hdl.$("table").clientHeight + 35;
        hdl.$("detalhes").style.height = (h > 100 ? h : 100) + "px";
      }
    };

    hdl.janela.style.width = `${width}px`;
    template = `<div id="body">
        <table id="table" style="'margin: 3px; width: 98%'; border-collapse: collapse;'">
            <tr>
                <td style="vertical-align: top; text-align: center; width: 80px;">
                    <img style="width: 48px; height: 48px; margin-right: 10px;" src="${params.image}">
                </td>
                <td style="vertical-align: middle;"><span class="yanda-message">${params.msg}</span></td>
            </tr>`;

    if (params.detail) {
      template += `<tr>
            <td colspan="2" style="cursor: pointer; font-weight: bold;" id="tdDetalhes">
                <label>Detalhes</label>
            </td>
        </tr></table>
        <div id="detalhes" style="background-color: #FFF; color: #000;
            width: calc(100% - 45px); padding: 10px 20px; height: 100px;
            border-radius: 4px; border: 1px solid #AAA; overflow: auto;"
        >${params.detail}</div>`;
    } else {
      template += "</table>";
    }

    template += `</div><div id="footer" style="text-align:right;">
        ${
    params.exception
      ? `<div id="divDetalhesTecnicos" style="cursor: pointer; position: absolute; bottom: -3px; display: flex; flex-direction: column;">
          <img
              src="${Yanda.src}img/tecnical.svg"
              style="height: 24px;"
              title="Detalhes Técnicos"
            >
          <span style="font-size: 10px; color: #2c417e;">
            Mais detalhes
          </span>
        </div>`
      : ""
  }
        <button type="button" id="btnOk" style="min-width: 70px;">OK</button>
    </div>`;
    hdl.setContent(template);

    height = hdl.$("table").clientHeight + 110 + (params.detail ? 100 : 0);
    (height > 400) && (height = 400);

    if (params.exception) {
      hdl.$("divDetalhesTecnicos").addEventListener("click", function () {
        const divDetTec = document.createElement("div");

        divDetTec.tabIndex = 0;
        divDetTec.style.top = "0";
        divDetTec.style.color = "white";
        divDetTec.style.width = "100%";
        divDetTec.style.zIndex = "999999";
        divDetTec.style.height = "calc(100% - 20px)";
        divDetTec.style.position = "fixed";
        divDetTec.style.textAlign = "center";
        divDetTec.style.paddingTop = "20px";
        divDetTec.style.backgroundColor = "#052f57";

        divDetTec.innerHTML =
          `<div style="text-align: center; font-size: 32px; height: 50px;">Detalhes Técnicos</div><i
                id="closeDetTec"
                class="mdi mdi-close"
                style="position: absolute; top: 15px; right: 20px; font-size: 50px!important; cursor: pointer;"
                aria-hidden="true"
            ></i>
            <div style="margin: 0 10% 50px 10%; overflow-y: auto; height: calc(100% - 100px); line-height: 1.5; font-size: 16px;">
                <b>Mensagem:</b> ${params.msg}<br><br>
                ${
          params.detail ? `<b>Detalhes:</b> ${params.detail}<br><br>` : ""
        }
                ${params.exception}
            </div>`;

        document.body.appendChild(divDetTec);

        divDetTec.querySelector("#closeDetTec").addEventListener(
          "click",
          () => document.body.removeChild(divDetTec),
        );
        divDetTec.addEventListener("keydown", function (e) {
          if (e.keyCode === 27) {
            e.preventDefault();
            e.stopPropagation();
            document.body.removeChild(divDetTec);
          }
        });
        divDetTec.focus();
      });
    }

    hdl.$("btnOk").addEventListener("click", hdl.close.bind(hdl), false);

    hdl.setTamanho(width, height, { minWidth: 500, minHeight: 170 });
    hdl.setResize(true);
    hdl.centraliza();
    hdl.show();
    hdl.resize();

    hdl.$("btnOk").focus();

    return hdl;
  };

  /**
   * @deprecated [#1] use Yanda.message({})
   */
  Yanda.erro = (disabled, title, msg, showBarra, detail, exception) =>
    Yanda.message({
      msg,
      type: "error",
      title,
      detail,
      disabled,
      showBarra,
      exception,
    });

  /**
   * @deprecated [#1] use Yanda.message({})
   */
  Yanda.alert = (disabled, title, msg, showBarra, detail, exception) =>
    Yanda.message({
      msg,
      type: "warning",
      title,
      detail,
      disabled,
      showBarra,
      exception,
    });

  /**
   * @deprecated [#1] use Yanda.message({})
   */
  Yanda.success = (disabled, title, msg, showBarra, detail, exception) =>
    Yanda.message({
      msg,
      type: "success",
      title,
      detail,
      disabled,
      showBarra,
      exception,
    });

  (function () {
    const confirm = function (
      disabled,
      cancel,
      title,
      message,
      showBarra,
      elements,
    ) {
      const hdl = Yanda.newJanela({
        showBarra,
        title,
        mode: "new",
        btFe: true,
        btPr: false,
        id: 101,
      });
      let b, i, j, elm;
      const botoes = [], largura = 500;

      if (disabled) {
        hdl.onCreate = function () {
          this.acptDisableAll = false;
          Yanda.disableAll(true);
        };
        hdl.onAfterClose = () => Yanda.disableAll(false);
      }

      hdl.titulo.innerHTML = title;
      hdl.janela.style.width = largura + "px";
      hdl.setResize(true);
      const aux =
        "<table id='tb' style='margin: 3px; width: 98%; border-collapse: collapse;'><tr>" +
        "<td style='vertical-align: top; text-align: center; width: 80px;'>" +
        "<img style='width: 48px; height: 48px; margin-right: 10px;' src='" +
        Yanda.src + "img/question.png'>" +
        "</td><td style='vertical-align: middle; width: 100%;'>" +
        "<span class='yanda-message'>" + message + "</span>" +
        "</td>" +
        "</tr><tr><td colspan='2'><div id='adicional'></div></td></tr>" +
        "</table>";
      hdl.setContent(aux);

      // elementos adicionais
      if (elements) {
        for (i = 0, j = 0; elements[i]; i++) {
          (elements[i].type === "button")
            ? (botoes[j++] = elements[i])
            : hdl.$("adicional").appendChild(elements[i]);
        }
      }

      const c = Util.createElm("div");
      c.id = "footer";
      hdl.content.appendChild(c);

      // Botões da Janela
      if (!elements) {
        b = Util.createElm("button");
        b.id = "btnOk";
        b.type = "button";
        b.className = "btn-primary";
        b.innerHTML = "OK";
        b.style.cssText = "margin-right:3px;min-width:70px;float:right";
        b.onclick = function () {
          hdl.returnValue = true;
          hdl.close();
        };
        c.appendChild(b);
        hdl.onShow = function () {
          this.$("btnCancelar")
            ? this.$("btnCancelar").focus()
            : this.$("btnOk").focus();
        };
      } else {
        j = 0;
        while (botoes[j]) {
          if (botoes[j].nodeName === "INPUT" && botoes[j].type === "button") {
            elm = Util.createElm("button");
            elm.id = botoes[j].id;
            elm.type = botoes[j].type;
            elm.onclick = botoes[j].onclick;
            elm.innerHTML = botoes[j].value;
            elm.className = botoes[j].className;
            elm.style.width = botoes[j].style.width;
            botoes[j] = elm;
          }

          (botoes[j].innerHTML === "OK") && (botoes[j].className = "btn-primary");
          botoes[j].style.setProperty("float", "right");
          c.appendChild(botoes[j++]);
        }
      }

      // Botão de cancelar
      if (cancel) {
        b = Util.createElm("button");
        b.id = "btnCancelar";
        b.type = "button";
        b.innerHTML = "Cancelar";
        b.style.cssText = "min-width:70px;float:right";
        b.onclick = function () {
          hdl.returnValue = false;
          hdl.close();
        };
        c.appendChild(b);
      }

      hdl.setTamanho(largura, hdl.$("tb").offsetHeight + 90);
      hdl.centraliza();
      hdl.show();
      return hdl;
    };

    Yanda.confirm = function (disabled, cancel, title, msg, showBarra, elements) {
      const params = (typeof disabled === "object")
        ? disabled
        : { showBarra, disabled, cancel, title, msg, elements };

      (params.cancel === undefined) && (params.cancel = true);
      (params.disabled === undefined) && (params.disabled = true);
      const janela = confirm(
        params.disabled,
        params.cancel,
        params.title || "Confirmação",
        params.msg || "Tens certeza que deseja executar esta operação?",
        params.showBarra,
        params.elements,
      );

      janela.onBeforeClose = function () {
        if (!this.returnValue) {
          params.actionFalse && params.actionFalse();
          return;
        }
        params.actionTrue && params.actionTrue();
      };
      janela.onClose = function () {
        params.onClose && params.onClose();
      };

      return janela;
    };
  })();

  let options = {}, appsChange = [];

  function connect() {
    return options.connection
      ? Promise.resolve(options.connection)
      : new Promise(function (resolve, reject) {
        !globalThis.indexedDB &&
          reject("Seu navegador não suporta uma versão estável do IndexedDB");
        const request = globalThis.indexedDB.open(
          options.database,
          options.version,
        );
        request.onerror = (event) =>
          reject(
            `Erro ao connectar no IndexedDB. Erro: ${event.target.errorCode}`,
          );
        request.onsuccess = function () {
          options.connection = request.result;
          resolve(request.result); // db reference
        };
      });
  }

  function set(dados) {
    return options.disabled ? Promise.resolve() : connect().then(function (db) {
      return new Promise(function (resolve, reject) {
        const transaction = db.transaction([options.table], "readwrite");
        transaction.onerror = (event) => reject(event);
        transaction.oncomplete = () => resolve();

        const objectStore = transaction.objectStore(options.table);
        const request = objectStore.get(dados.id);
        request.onsuccess = () => (request.result
          ? objectStore.put(dados)
          : objectStore.add(dados));
      });
    });
  }

  function get(id) {
    return options.disabled
      ? Promise.resolve(null)
      : connect().then(function (db) {
        return new Promise(function (resolve, reject) {
          const objectStore = db.transaction([options.table]).objectStore(
            options.table,
          );
          const request = objectStore.get(id);
          request.onerror = (event) => reject(event);
          request.onsuccess = () => resolve(request.result);
        });
      });
  }

  function clear() {
    return connect().then(function (db) {
      return new Promise(function (resolve, reject) {
        const objectStore = db.transaction([options.table], "readwrite")
          .objectStore(options.table);
        const request = objectStore.clear();
        request.onerror = (event) => reject(event);
        request.onsuccess = () => resolve();
      });
    });
  }

  function remove(id) {
    return connect().then(function (db) {
      return new Promise(function (resolve, reject) {
        const objectStore = db.transaction([options.table], "readwrite")
          .objectStore(options.table);
        const request = objectStore.delete(id);
        request.onerror = (event) => reject(event);
        request.onsuccess = () => resolve();
      });
    });
  }

  const cache = {
    get disabled() {
      return options.disabled;
    },
    set disabled(d) {
      options.disabled = d;
    },
    set config(opt) {
      options = opt;
    },

    get,
    set,
    clear,
    remove,
    getAppChange: (id) => (appsChange[id] || null),
    setAppsChange: (apps) => (appsChange = apps),
  };

  const handler = {
    get: function (target, propKey) {
      const origMethod = target[propKey];
      if (["get", "set", "remove", "clear"].indexOf(propKey) >= 0) {
        return function () {
          if (options && (options.connection || options.database)) {
            const result = origMethod.apply(this, arguments);
            return result;
          }
          return Promise.resolve();
        };
      }
      return origMethod;
    },
  };

  var Cache = new Proxy(cache, handler);

  Yanda.cache = Cache;

  function XMLErro() {
    Yanda.erro(true, "Erro", "XML da aplicação inválido");
  }

  /**
   * Manipula o XML da app
   *
   * @param xml XML recebido
   * @param callback
   * @param params
   * @param dad
   */
  function maniAplXML(xml, callback, params, dad, requests, doCache, onload) {
    if (!xml || !xml.childNodes.length) {
      XMLErro();
      return;
    }

    const tagApp = xml.getElementsByTagName("app");
    if (tagApp.length) {
      let template, script;

      const tagTemplate = xml.getElementsByTagName("template");
      tagTemplate.length && (template = tagTemplate[0].firstChild.nodeValue);

      const tagScript = xml.getElementsByTagName("script");
      tagScript.length && (script = tagScript[0].firstChild.nodeValue);

      const App = {
        template,
        params,
        dad,
        cache: "true",
      };
      const atr = tagApp[0].attributes;
      for (let i = 0; i < atr.length; i++) {
        App[atr[i].nodeName] = atr[i].nodeValue;
      }

      doCache && (App.cache === "true") && Cache.set({
        id: parseInt(App.id),
        xml: new XMLSerializer().serializeToString(xml),
        date: Date.now() / 1000 | 0,
        requests: (requests + 1),
      });

      const hdl = Function("App", "return " + script.trimLeft())(App);
      (hdl instanceof Promise ? hdl : Promise.resolve(hdl))
        .then((ref) => {
          ref.requests = requests;
          Yanda.help.createByJanela(ref);
          callback && callback(ref);

          if (onload !== undefined) {
            onload && Function(onload)();
          } else {
            const tagOnload = xml.getElementsByTagName("onload");
            for (let i = 0; i < tagOnload.length; i++) {
              Function(tagOnload[i].textContent)();
            }
          }
        });
      return;
    }

    // TODO: verificar se esta opção ainda será necessaria
    const tagErro = xml.getElementsByTagName("erro");
    if (tagErro.length) {
      let modal = true,
        title = "Aplicação do Sistema",
        barraTarefas = false;
      const atr = tagErro[0].attributes;
      for (let i = 0; i < atr.length; i++) {
        switch (atr[i].nodeName) {
          case "modal":
            modal = atr[i].nodeValue === "true";
            break;
          case "title":
            title = atr[i].nodeValue;
            break;
          case "bt":
            barraTarefas = atr[i].nodeValue === "true";
            break;
        }
      }
      Yanda.erro(modal, title, tagErro[0].firstChild.nodeValue, barraTarefas);
      return;
    }

    XMLErro();
  }

  function request(context) {
    return new Promise((resolve) => {
      let dados = `id=${context.id}`;

      // TODO: Futuramente parms não será mais enviado
      if (context.params) {
        const tmpParms = (typeof context.params === "object")
          ? encodeURIComponent(JSON.stringify(context.params))
          : context.params;
        dados += `&parms=${tmpParms}`;
      }

      const xhr = new XMLHttpRequest();
      xhr.addEventListener("loadend", () => resolve());
      xhr.addEventListener("load", function () {
        if (this.status === 200) {
          maniAplXML(
            this.responseXML,
            context.callback,
            context.params,
            context.dad,
            parseInt(xhr.getResponseHeader("X-Requests") || "0"),
            true,
          );
        }
      });
      xhr.open("POST", Yanda.srcAction, true);
      xhr.setRequestHeader(
        "Content-Type",
        "application/x-www-form-urlencoded; charset=UTF-8",
      );
      xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
      xhr.send(dados);
    });
  }

  /**
   * Abre as aplicações pelo seu id.
   *
   * @param id Identificador da aplicação
   * @param params parametros para abertura
   * @param string|object dad Identificador da janela pai
   * @param function callback Função chamada quando a janela é executada
   */
  Yanda.newApl = async function (id, params, dad, callback) {
    // esperar carregamentos anteriores
    if (Yanda.estAjax.isLoading()) {
      Notify.warning("Aguarde, processando...");
      return;
    }

    if (dad && typeof dad !== "object") {
      throw new Error("Janela pai inválida");
    }

    // Verifica se o id já está aberto e, não se trate de uma janela filha.
    if (!dad) {
      const abertas = Yanda.getJansById(id);
      if (abertas) {
        const ref = abertas.filter((janela) => !janela.dad).shift();
        if (ref && (!ref.options.mode || ref.options.mode === "self")) {
          ref.show();
          ref.onReset && ref.onReset();
          callback && callback(ref);
          return;
        }
      }
    }

    const context = { id, params, callback, dad };

    Yanda.estAjax.show();
    await Cache.get(parseInt(id))
      .then((appCache) => {
        if (!appCache) {
          return request(context);
        }

        const appDateChange = Cache.getAppChange(appCache.id);
        if (appDateChange && appDateChange > appCache.date) {
          return request(context);
        }

        return fetch(`${Yanda.srcAction}/check-permision?id=${id}`)
          .then((resp) => resp.json())
          .then(({ data }) => {
            const xml = new DOMParser().parseFromString(appCache.xml, "text/xml");
            try {
              maniAplXML(
                xml,
                callback,
                params,
                dad,
                appCache.requests || 0,
                false,
                data,
              );
            } catch (e) {
              console.log(e);
            }
          }).catch(() => null);
      })
      .catch(() => request(context))
      .finally(() => Yanda.estAjax.hidden());
  };

  let redrawTimeout;

  // TODO: não expor mais o array de janelas
  Yanda.jansPid = jansPid;

  Yanda.getIdName = getIdName;
  Yanda.getJanByPid = getJanByPid;
  Yanda.getJanMaxBottom = getJanMaxBottom;
  Yanda.getJansById = getJansById;
  Yanda.getTotJans = getTotJans;
  Yanda.janela = janela;
  Yanda.newJanela = newJanela;

  Yanda.cmd = function () {
    const $ref = document.getElementById("SystemCmd");
    $ref.style.display = "block";
    $ref.style.zIndex = Yanda.ctr.contZindex + 4;
    const ipt = $ref.querySelector("#tSystemCmd");
    ipt.focus();
    ipt.select();
  };

  /**
   * Reposiciona os elementos ao alterar as dimensões da pagina.
   */
  Yanda.ajaxResponseError = (xhr) => {
    if (xhr.status == 200) {
      return false;
    }
    Yanda.erro(
      true,
      "Erro",
      "Erro ao efetuar comunicação com o servidor<br>Tente novamente",
      false,
      xhr.responseText,
    );
    return true;
  };

  Yanda.redraw = function () {
    // chamado de varios lugares (Timeout evita recursão)
    clearTimeout(redrawTimeout);
    redrawTimeout = setTimeout(function () {
      let i,
        top,
        left,
        janela;
      const ctr = Yanda.ctr, len = jansPid.length;
      ctr.update();

      // Acerta as posicoes e tamanho de todas as janelas
      for (i = 1; i < len; i++) {
        janela = jansPid[i];
        if (!janela) {
          continue;
        }
        if (janela.isMax || (!janela.isResponsive() && Util.isMobile())) {
          janela.setTamanho(ctr.janMaLar, ctr.janMaAlt);
          janela.setPosicao(Yanda.ctr.janMaPosLeft, Yanda.ctr.janMaPosTop);
          janela.onResize && janela.onResize();
          continue;
        }

        top = parseInt(janela.janela.style.top);
        left = parseInt(janela.janela.style.left);
        (left > ctr.janPosRightMax) && janela.setPosicao(ctr.janPosRightMax, top);
      }
    }, 100);
  };

  /**
   * Mostra div de desabilitação geral
   */
  Yanda.disableAll = function (d) {
    Util.overlay(d ? { show: d, zIndex: Yanda.ctr.contZindex++ } : { show: d });
    Yanda.ctr.disableAll = d;
  };
  Yanda.setDesableAll = function (d) {
    console.log("[yanda] Método depreciado, utilize Yanda.disableAll");
    Yanda.disableAll(d);
  };

  /**
   * Inclusão de arquivos js e css.
   *
   * @param i Url do arquivo a ser incluído
   * @param id Identificador do arquivo incluido
   * @param tpo Tipo: js ou css
   * @param ass True/False para assincrono ou não
   */
  Yanda.include = function (url, id, tpo, async = true) {
    if (!["js", "css"].includes(tpo)) {
      throw new Error("Invalid type");
    }
    if (document.getElementById(id)) {
      return;
    }
    Yanda.estAjax.show();

    const xhr = new XMLHttpRequest();
    xhr.addEventListener("loadend", () => Yanda.estAjax.hidden());
    xhr.addEventListener(
      "error",
      () => Yanda.erro(true, "Erro", "Erro ao abrir aplicação."),
    );
    xhr.addEventListener("load", function () {
      if (this.status !== 200) {
        return;
      }

      let tag;
      const code = this.responseText;
      if (tpo === "js") {
        tag = Util.createElm("script");
        tag.setAttribute("type", "text/javascript");
        tag.text = code;
      } else if (tpo === "css") {
        tag = Util.createElm("style");
        tag.setAttribute("type", "text/css");
        tag.setAttribute("rel", "stylesheet");
        tag.textContent = code;
      }
      tag.id = id;
      document.querySelector("head").appendChild(tag);
    });
    xhr.open("GET", url, async);
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send();
  };

  /*
   * Generate a random uuid.
   *
   * USAGE: Math.uuid(length, radix)
   *   length - the desired number of characters
   *   radix  - the number of allowable values for each character.
   *
   * EXAMPLES:
   *   // No arguments  - returns RFC4122, version 4 ID
   *   >>> Math.uuid()
   *   "92329D39-6F5C-4520-ABFC-AAB64544E172"
   *
   *   // One argument - returns ID of the specified length
   *   >>> Math.uuid(15)     // 15 character ID (default base=62)
   *   "VcydxgltxrVZSTV"
   *
   *   // Two arguments - returns ID of the specified length, and radix. (Radix must be <= 62)
   *   >>> Math.uuid(8, 2)  // 8 character ID (base=2)
   *   "01001010"
   *   >>> Math.uuid(8, 10) // 8 character ID (base=10)
   *   "47473046"
   *   >>> Math.uuid(8, 16) // 8 character ID (base=16)
   *   "098F4D35"
   */
  (function () {
    // Private array of chars to use
    const CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"
      .split("");

    Math.uuid = function (len, radix) {
      if (!len) {
        return globalThis.crypto.randomUUID();
      }

      const uuid = [];
      radix = radix || CHARS.length;
      for (let i = 0; i < len; i++) {
        uuid[i] = CHARS[0 | Math.random() * radix];
      }
      return uuid.join("");
    };
  })();

  Yanda.showTabs = showTabs;
  Yanda.telaDefaultCadastro = telaDefaultCadastro;
  Yanda.telaDefaultConsulta = telaDefaultConsulta;
  Yanda.newToolbar = Toolbar;
  Yanda.ajanMenu = Menu;
  Yanda.help = Help;
  Yanda.util = Util;
  Yanda.ini = start;
  installJqueryPlugins(Yanda);

  return Yanda;

}));
